export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: string; output: string; }
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: { input: string; output: string; }
  /** The `Decimal` scalar rounded to 2 decimal places. */
  DecimalRoundedTo2: { input: string; output: string; }
  /** The `Float` scalar rounded to 1 decimal places. `Float`: [IEEE 754](http://en.wikipedia.org/wiki/IEEE_floating_point). */
  FloatRoundedTo1: { input: number; output: number; }
  /** The `Float` scalar rounded to 2 decimal places. `Float`: [IEEE 754](http://en.wikipedia.org/wiki/IEEE_floating_point). */
  FloatRoundedTo2: { input: number; output: number; }
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: { input: any; output: any; }
  /** The `HTMLString` scalar type represents HTML data. It is an extension of the String scalar type. */
  HTMLString: { input: string; output: string; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: string; output: string; }
  /** Basic bucket keys are: BUGS, DEVEX, FEATURE, KTLO, SUPPORT, TECH_DEBT. But you can also create your own. */
  NamedWorkCategory: { input: string; output: string; }
  /** Used for filtering in PQL queries. Can be of one of the following types `String`, `List[String]`, `Float`, `Int`. Timedeltas are passed as `String`, their full format is `"10d:20h:3:m:9s"`, which means 10 days, 20 hours, 3 minutes, 9 seconds. But they can also be as short as 1 time-unit, example: `5h` which means 5 hours. */
  PQLFieldValue: { input: any; output: any; }
  /** The `TagOperatorType` scalar type is used for PQL queries. Valid values are `:`, `:!`, `:<`, `:>`. */
  PQLOperator: { input: string; output: string; }
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: { input: string; output: string; }
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: { input: any; output: any; }
};

export type AccessTokenConnection = {
  __typename?: 'AccessTokenConnection';
  edges: Array<AccessTokenNodeEdge>;
  nodes: Array<AccessTokenNode>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type AccessTokenNode = {
  __typename?: 'AccessTokenNode';
  applicationName: Scalars['String']['output'];
  created: Scalars['String']['output'];
  expires: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  scope: OAuthScopeType;
  token: Scalars['String']['output'];
};

export type AccessTokenNodeEdge = {
  __typename?: 'AccessTokenNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AccessTokenNode;
};

/** Activate (rollback to) a specific skill version. */
export type ActivateSkillVersionMutation = {
  __typename?: 'ActivateSkillVersionMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type AddAssetPullRequestFileChangeInput = {
  /** File action type */
  action: SkillPullRequestFileActionEnum;
  /** New file content */
  content?: InputMaybe<Scalars['String']['input']>;
  /** File name */
  name: Scalars['String']['input'];
  /** File path */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Original content before editing (for diffs) */
  previousContent?: InputMaybe<Scalars['String']['input']>;
  /** GID of the pull request */
  pullRequestId: Scalars['ID']['input'];
};

/** Add or update a file change in a pull request. */
export type AddAssetPullRequestFileChangeMutation = {
  __typename?: 'AddAssetPullRequestFileChangeMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

/** Add assets to a profile. */
export type AddAssetsToProfileMutation = {
  __typename?: 'AddAssetsToProfileMutation';
  errors: Array<ErrorType>;
  profile?: Maybe<VaultAssetProfile>;
};

export type AddTeamsOrUsersToScopeMutation = {
  __typename?: 'AddTeamsOrUsersToScopeMutation';
  errors?: Maybe<Array<ErrorType>>;
  instance: TeamOrUsersScoped;
};

export type AddTeamsOrUsersToScopeMutationInput = {
  id: Scalars['ID']['input'];
  /** List of TeamOrUser IDs to be added */
  teamOrUserIds: Array<Scalars['ID']['input']>;
};

export type AddUsersToScopeMutation = {
  __typename?: 'AddUsersToScopeMutation';
  errors?: Maybe<Array<ErrorType>>;
  instance: UserScoped;
};

export type AddUsersToScopeMutationInput = {
  id: Scalars['ID']['input'];
  /** List of user IDs to be added */
  users: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type Agent = VaultAsset & {
  __typename?: 'Agent';
  /** Repository code contexts where this asset will execute */
  codeContexts: Array<AssetCodeContext>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** Whether an evaluation is currently in progress for this asset */
  evaluating: Scalars['Boolean']['output'];
  /** Files belonging to this asset */
  files: Array<SkillFile>;
  id: Scalars['ID']['output'];
  /** Pending installation requests for this asset visible to the current user */
  installationRequests: Array<AssetInstallationRequest>;
  installations: Array<VaultAssetInstallation>;
  isChatDefault: Scalars['Boolean']['output'];
  latestVersion: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Current user's permissions for this asset */
  permissions?: Maybe<VaultAssetPermissions>;
  profiles: Array<VaultAssetProfile>;
  slug: Scalars['String']['output'];
  /** Asset source metadata */
  source: AssetSource;
  status?: Maybe<SkillStatusEnum>;
  /** Token counts for the current version */
  tokenCounts?: Maybe<AssetTokenCount>;
  type: AssetType;
  updatedAt: Scalars['DateTime']['output'];
  usageCount: Scalars['Int']['output'];
  versions: Array<VaultAssetVersion>;
  versionsCount: Scalars['Int']['output'];
};


export type AgentFilesArgs = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

export enum AiClient {
  /** Claude Code */
  ClaudeCode = 'CLAUDE_CODE',
  /** Cline */
  Cline = 'CLINE',
  /** Codex */
  Codex = 'CODEX',
  /** Cursor */
  Cursor = 'CURSOR',
  /** Gemini */
  Gemini = 'GEMINI',
  /** GitHub Copilot */
  GithubCopilot = 'GITHUB_COPILOT',
  /** Kiro */
  Kiro = 'KIRO',
  /** OpenClaw */
  Openclaw = 'OPENCLAW',
  /** SX Vault */
  Sx = 'SX',
  /** Windsurf */
  Windsurf = 'WINDSURF'
}

/** Context information for AI queries (auto-detected by sx MCP server). */
export type AiQueryContextInput = {
  /** Current branch name */
  branch: Scalars['String']['input'];
  /** Current commit SHA */
  commitSha: Scalars['String']['input'];
  /** Full repository URL (e.g., "https://github.com/owner/repo") */
  repoUrl: Scalars['String']['input'];
};

/** Input for querying integrations with natural language. */
export type AiQueryInput = {
  /** Git context for the query */
  context: AiQueryContextInput;
  /** Integration provider to query */
  provider: Provider;
  /** Natural language query to execute */
  query: Scalars['String']['input'];
};

/** Result from an AI query. */
export type AiQueryResult = {
  __typename?: 'AiQueryResult';
  /** Query results (filtered and summarized) */
  data: Scalars['String']['output'];
  /** Status of the query execution */
  status: Scalars['String']['output'];
  /** List of tools called during execution */
  toolCallsMade: Array<Scalars['String']['output']>;
};

export enum AllowedLoginMethodType {
  /** Sleuth-managed username and password */
  Password = 'PASSWORD',
  /** Third-party OAuth-based authentication provider */
  Provider = 'PROVIDER'
}

export type ApplyOptimizedDescriptionInput = {
  optimizationGid: Scalars['ID']['input'];
};

export type ApplyOptimizedDescriptionMutation = {
  __typename?: 'ApplyOptimizedDescriptionMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type ApproveDeviceMutation = {
  __typename?: 'ApproveDeviceMutation';
  result: ApproveDeviceResult;
};

export type ApproveDeviceResult = {
  __typename?: 'ApproveDeviceResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ApproveInstallationRequestMutation = {
  __typename?: 'ApproveInstallationRequestMutation';
  errors: Array<ErrorType>;
  installationRequest?: Maybe<AssetInstallationRequest>;
};

export type Assessable = {
  assessment: DelayedAssessment;
};

export type Assessment = {
  __typename?: 'Assessment';
  score?: Maybe<Score>;
  scoreByAi: Score;
  summary: TextContent;
};

export type AssessmentMutationInput = {
  /** Assessable object ID. (Review or Section) */
  id: Scalars['ID']['input'];
  resetScore?: InputMaybe<Scalars['Boolean']['input']>;
  score?: InputMaybe<Score>;
  summary?: InputMaybe<Scalars['HTMLString']['input']>;
  userInputRefinement?: InputMaybe<Scalars['String']['input']>;
};

export type AssetAuditEvent = {
  __typename?: 'AssetAuditEvent';
  actorAvatarUrl?: Maybe<Scalars['String']['output']>;
  actorEmail?: Maybe<Scalars['String']['output']>;
  actorId?: Maybe<Scalars['Int']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  actorType: Scalars['String']['output'];
  data?: Maybe<Scalars['JSONString']['output']>;
  date: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  eventLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  targetAssetType?: Maybe<AssetType>;
  targetGid?: Maybe<Scalars['String']['output']>;
  targetId: Scalars['Int']['output'];
  targetName?: Maybe<Scalars['String']['output']>;
  targetSlug?: Maybe<Scalars['String']['output']>;
  targetType: Scalars['String']['output'];
};

export type AssetAuditEventConnection = {
  __typename?: 'AssetAuditEventConnection';
  edges: Array<AssetAuditEventEdge>;
  nodes: Array<AssetAuditEvent>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type AssetAuditEventEdge = {
  __typename?: 'AssetAuditEventEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AssetAuditEvent;
};

/** A repository code context where an asset will execute. */
export type AssetCodeContext = {
  __typename?: 'AssetCodeContext';
  monoRepoConfigName?: Maybe<Scalars['String']['output']>;
  repositoryName: Scalars['String']['output'];
  /** Human-readable source (e.g. 'Team: Engineering') */
  source: Scalars['String']['output'];
  /** Source type: organization, team, repository, user */
  sourceType: Scalars['String']['output'];
};

export type AssetEval = {
  __typename?: 'AssetEval';
  /** Grouping category: 'basic', 'edge-case', etc. */
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Unique key within the skill, e.g. 'basic-pdf-fill' */
  evalKey: Scalars['String']['output'];
  /** List of verifiable assertion strings */
  expectations: Scalars['JSONString']['output'];
  /** Human-readable description of expected success */
  expectedOutput: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Optional file paths or contents for the eval */
  inputFiles?: Maybe<Scalars['JSONString']['output']>;
  isActive: Scalars['Boolean']['output'];
  /** The task prompt to execute */
  prompt: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum AssetEventType {
  /** Bot Created */
  BotCreated = 'BOT_CREATED',
  /** Bot Deleted */
  BotDeleted = 'BOT_DELETED',
  /** Bot Key Deleted */
  BotKeyDeleted = 'BOT_KEY_DELETED',
  /** Bot Updated */
  BotUpdated = 'BOT_UPDATED',
  /** Created */
  Created = 'CREATED',
  /** Deleted */
  Deleted = 'DELETED',
  /** Downloaded */
  Downloaded = 'DOWNLOADED',
  /** Auto-Deleted From Git */
  GitAssetAutoDeleted = 'GIT_ASSET_AUTO_DELETED',
  /** Git Content Refreshed */
  GitAssetContentRefreshed = 'GIT_ASSET_CONTENT_REFRESHED',
  /** Discovered from Git */
  GitAssetDiscovered = 'GIT_ASSET_DISCOVERED',
  /** Imported from Catalog */
  ImportedFromCatalog = 'IMPORTED_FROM_CATALOG',
  /** Imported from Repository */
  ImportedFromRepository = 'IMPORTED_FROM_REPOSITORY',
  /** Installed */
  Installed = 'INSTALLED',
  /** Lock File Accessed */
  LockFileAccessed = 'LOCK_FILE_ACCESSED',
  /** Profile Assets Added */
  ProfileAssetsAdded = 'PROFILE_ASSETS_ADDED',
  /** Profile Assets Removed */
  ProfileAssetsRemoved = 'PROFILE_ASSETS_REMOVED',
  /** Profile Created */
  ProfileCreated = 'PROFILE_CREATED',
  /** Profile Deleted */
  ProfileDeleted = 'PROFILE_DELETED',
  /** Profile Updated */
  ProfileUpdated = 'PROFILE_UPDATED',
  /** PR Approved */
  PrApproved = 'PR_APPROVED',
  /** PR Closed */
  PrClosed = 'PR_CLOSED',
  /** PR Created */
  PrCreated = 'PR_CREATED',
  /** PR Merged */
  PrMerged = 'PR_MERGED',
  /** Published */
  Published = 'PUBLISHED',
  /** Settings Updated */
  SettingsUpdated = 'SETTINGS_UPDATED',
  /** Uninstalled */
  Uninstalled = 'UNINSTALLED',
  /** Unpublished */
  Unpublished = 'UNPUBLISHED',
  /** Updated */
  Updated = 'UPDATED',
  /** Updated from Catalog */
  UpdatedFromCatalog = 'UPDATED_FROM_CATALOG',
  /** Version Created */
  VersionCreated = 'VERSION_CREATED'
}

/** Source metadata for a git-sourced asset. */
export type AssetGitSource = AssetSource & {
  __typename?: 'AssetGitSource';
  /** Whether this asset is read-only */
  isReadonly: Scalars['Boolean']['output'];
  /** Last time content was fetched from the remote */
  lastFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Path within the repository */
  path: Scalars['String']['output'];
  /** SHA of the latest synced commit */
  ref?: Maybe<Scalars['String']['output']>;
  /** Source repository */
  repository?: Maybe<RepositoryType>;
  /** AI client this asset was discovered from */
  sourceClient?: Maybe<AiClient>;
  /** URL to the source file/directory in the repository */
  sourceUrl?: Maybe<Scalars['String']['output']>;
};

export type AssetInstallationInput = {
  /** GID of the entity (null for organization-wide) */
  entityId?: InputMaybe<Scalars['ID']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  entityProvider?: InputMaybe<Scalars['String']['input']>;
  entityType: VaultAssetInstallationEntityType;
  /** GID of the mono-repo config (repository targets only) */
  monoRepoConfigId?: InputMaybe<Scalars['ID']['input']>;
  monoRepoConfigName?: InputMaybe<Scalars['String']['input']>;
};

export type AssetInstallationRequest = {
  __typename?: 'AssetInstallationRequest';
  assetId: Scalars['ID']['output'];
  assetName: Scalars['String']['output'];
  assetType: AssetType;
  /** Whether the current user can retract this request (they submitted it) */
  canRetract: Scalars['Boolean']['output'];
  /** Whether the current user can approve or reject this request */
  canReview: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  requestedByEmail?: Maybe<Scalars['String']['output']>;
  requestedByName?: Maybe<Scalars['String']['output']>;
  reviewNote?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedByName?: Maybe<Scalars['String']['output']>;
  status: IssuesAssetInstallationRequestStatusChoices;
  targetEntityId?: Maybe<Scalars['ID']['output']>;
  targetLabel: Scalars['String']['output'];
  targetProvider?: Maybe<Scalars['String']['output']>;
  targetType: IssuesAssetInstallationRequestTargetTypeChoices;
};

/** Source metadata for a Pulse-managed asset. */
export type AssetManagedSource = AssetSource & {
  __typename?: 'AssetManagedSource';
  /** Catalog source key if imported from a catalog */
  catalogSource?: Maybe<Scalars['String']['output']>;
  /** URL to the catalog source page */
  catalogSourceUrl?: Maybe<Scalars['String']['output']>;
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  evaluationResult?: Maybe<Scalars['String']['output']>;
  fileIds: Array<Scalars['String']['output']>;
  /** Whether this asset is read-only */
  isReadonly: Scalars['Boolean']['output'];
  originalPrompt?: Maybe<Scalars['String']['output']>;
};

/** Sort options for vault asset listings. */
export enum AssetSortField {
  Created = 'CREATED',
  Impact = 'IMPACT',
  Popularity_30D = 'POPULARITY_30D',
  Popularity_90D = 'POPULARITY_90D',
  PopularityAll = 'POPULARITY_ALL',
  Quality = 'QUALITY'
}

/** Base interface for asset source metadata. */
export type AssetSource = {
  /** Whether this asset is read-only */
  isReadonly: Scalars['Boolean']['output'];
};

export enum AssetSourceType {
  /** Git */
  Git = 'GIT',
  /** Managed */
  Managed = 'MANAGED'
}

/** Token counts for an asset version. */
export type AssetTokenCount = {
  __typename?: 'AssetTokenCount';
  /** Frontmatter token count using Claude tokenizer */
  claudeFrontmatterTokens?: Maybe<Scalars['Int']['output']>;
  /** Token count using Claude tokenizer */
  claudeTokens?: Maybe<Scalars['Int']['output']>;
  /** Estimated frontmatter tokens using ~4 chars/token */
  estimatedFrontmatterTokens?: Maybe<Scalars['Int']['output']>;
  /** Estimated tokens using ~4 chars/token */
  estimatedTokens: Scalars['Int']['output'];
  /** Frontmatter token count using OpenAI tiktoken */
  openaiFrontmatterTokens?: Maybe<Scalars['Int']['output']>;
  /** Token count using OpenAI tiktoken */
  openaiTokens?: Maybe<Scalars['Int']['output']>;
};

export enum AssetType {
  /** Agent */
  Agent = 'AGENT',
  /** Claude Code Plugin */
  ClaudeCodePlugin = 'CLAUDE_CODE_PLUGIN',
  /** Command */
  Command = 'COMMAND',
  /** Hook */
  Hook = 'HOOK',
  /** MCP Server */
  Mcp = 'MCP',
  /** Rule */
  Rule = 'RULE',
  /** Skill */
  Skill = 'SKILL'
}

/**
 * A single raw asset usage event.
 *
 * Exposes the individual rows behind the aggregated usage dashboards so an
 * external tool (the sx CLI) can export usage history losslessly — actor,
 * timestamp, and asset coordinates included.
 */
export type AssetUsageEvent = {
  __typename?: 'AssetUsageEvent';
  actorEmail?: Maybe<Scalars['String']['output']>;
  assetName: Scalars['String']['output'];
  assetType: Scalars['String']['output'];
  assetVersion: Scalars['String']['output'];
  botName?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type AssetUsageEventConnection = {
  __typename?: 'AssetUsageEventConnection';
  edges: Array<AssetUsageEventEdge>;
  nodes: Array<AssetUsageEvent>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type AssetUsageEventEdge = {
  __typename?: 'AssetUsageEventEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AssetUsageEvent;
};

export type BaseNoteGqlType = {
  msg: Scalars['String']['output'];
};

export type BatchWorkingHoursDeleteInputType = {
  userIds: Array<Scalars['String']['input']>;
};

export type BatchWorkingHoursInputType = {
  duration: Scalars['String']['input'];
  recurrence: Scalars['String']['input'];
  startTime: Scalars['Time']['input'];
  userIds: Array<Scalars['String']['input']>;
};

/** An API key for a bot, showing masked token for identification. */
export type BotApiKey = {
  __typename?: 'BotApiKey';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  maskedToken: Scalars['String']['output'];
};

/** Lightweight skill info for display on bot detail page. */
export type BotInstalledSkill = {
  __typename?: 'BotInstalledSkill';
  assetType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDirectInstall: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
};

/** A team a bot belongs to, with the count of assets installed to that team. */
export type BotTeamMembership = {
  __typename?: 'BotTeamMembership';
  assetCount: Scalars['Int']['output'];
  team: Team;
};

/** An enumeration. */
export enum BotsBotStatusChoices {
  /** Active */
  Active = 'ACTIVE'
}

/** An entry from a public catalog (skills.sh, Smithery, etc.). */
export type CatalogEntry = {
  __typename?: 'CatalogEntry';
  /** 'skill' or 'mcp' */
  assetType: Scalars['String']['output'];
  /** Short description */
  description: Scalars['String']['output'];
  /** Provider-specific unique key */
  key: Scalars['String']['output'];
  /** Display name */
  name: Scalars['String']['output'];
  /** Install/use count */
  popularity: Scalars['Int']['output'];
  /** Link to the catalog page */
  sourceUrl: Scalars['String']['output'];
};

/** A catalog source provider. */
export type CatalogSource = {
  __typename?: 'CatalogSource';
  /** Type of assets this source provides: 'skill' or 'mcp' */
  assetType: Scalars['String']['output'];
  /** Human-readable name, e.g. 'skills.sh' */
  displayName: Scalars['String']['output'];
  /** Provider key, e.g. 'skills_sh' */
  sourceName: Scalars['String']['output'];
};

export type CategoriesWidgetRenderHints = {
  __typename?: 'CategoriesWidgetRenderHints';
  rawDateLabels?: Maybe<Scalars['Boolean']['output']>;
  renderPercentages?: Maybe<Scalars['Boolean']['output']>;
  xAxisLabel?: Maybe<Scalars['String']['output']>;
  yAxisLabel?: Maybe<Scalars['String']['output']>;
};

export type CategoriesWidgetValue = WidgetValue & {
  __typename?: 'CategoriesWidgetValue';
  exportLinks: Array<Maybe<ExportLink>>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  legend?: Maybe<WidgetLegend>;
  notes?: Maybe<Array<BaseNoteGqlType>>;
  renderHints?: Maybe<CategoriesWidgetRenderHints>;
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: WidgetValueFormat;
  unit: Unit;
  values: Array<Maybe<Scalars['Float']['output']>>;
  xAxisLabel?: Maybe<Scalars['String']['output']>;
  yAxisLabel?: Maybe<Scalars['String']['output']>;
};

export type CategoryDataset = {
  __typename?: 'CategoryDataset';
  category: Scalars['String']['output'];
  items: Array<Scalars['Float']['output']>;
};

export type ChangeRequest = {
  __typename?: 'ChangeRequest';
  assetGid: Scalars['ID']['output'];
  assetName: Scalars['String']['output'];
  assetType: AssetType;
  /** Whether the current user can retract this change request (only for installation requests they submitted). */
  canRetract: Scalars['Boolean']['output'];
  /** Whether the current user can approve or reject this change request. */
  canReview: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  requestedByName?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  status: ChangeRequestStatusEnum;
  targetLabel?: Maybe<Scalars['String']['output']>;
  targetProvider?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: ChangeRequestTypeEnum;
  /** True when approving this installation request will remove an existing organization-wide installation of the asset (narrowing scope to the requested team or repository). */
  willUninstallFromOrg: Scalars['Boolean']['output'];
};

export type ChangeRequestConnection = {
  __typename?: 'ChangeRequestConnection';
  edges: Array<ChangeRequestEdge>;
  nodes: Array<ChangeRequest>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type ChangeRequestEdge = {
  __typename?: 'ChangeRequestEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ChangeRequest;
};

export enum ChangeRequestStatusEnum {
  Approved = 'APPROVED',
  Open = 'OPEN',
  Rejected = 'REJECTED'
}

export enum ChangeRequestTypeEnum {
  InstallationRequest = 'INSTALLATION_REQUEST',
  PullRequest = 'PULL_REQUEST'
}

export type ChangeRoleMutation = {
  __typename?: 'ChangeRoleMutation';
  success: Scalars['Boolean']['output'];
};

export type ChangeRoleMutationInput = {
  role: Role;
  userId: Scalars['ID']['input'];
};

export type ClaimEmailDomainMutation = {
  __typename?: 'ClaimEmailDomainMutation';
  success: Scalars['Boolean']['output'];
};

export type ClaudeCodePlugin = VaultAsset & {
  __typename?: 'ClaudeCodePlugin';
  /** Repository code contexts where this asset will execute */
  codeContexts: Array<AssetCodeContext>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** Whether an evaluation is currently in progress for this asset */
  evaluating: Scalars['Boolean']['output'];
  /** Files belonging to this asset */
  files: Array<SkillFile>;
  id: Scalars['ID']['output'];
  /** Pending installation requests for this asset visible to the current user */
  installationRequests: Array<AssetInstallationRequest>;
  installations: Array<VaultAssetInstallation>;
  isChatDefault: Scalars['Boolean']['output'];
  latestVersion: Scalars['String']['output'];
  marketplaceUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Current user's permissions for this asset */
  permissions?: Maybe<VaultAssetPermissions>;
  profiles: Array<VaultAssetProfile>;
  slug: Scalars['String']['output'];
  /** Asset source metadata */
  source: AssetSource;
  status?: Maybe<SkillStatusEnum>;
  /** Token counts for the current version */
  tokenCounts?: Maybe<AssetTokenCount>;
  type: AssetType;
  updatedAt: Scalars['DateTime']['output'];
  usageCount: Scalars['Int']['output'];
  versions: Array<VaultAssetVersion>;
  versionsCount: Scalars['Int']['output'];
};


export type ClaudeCodePluginFilesArgs = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** Clear an asset's chat history (event log) without affecting files. */
export type ClearAssetChatMutation = {
  __typename?: 'ClearAssetChatMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type ClearManagementSessionMutation = {
  __typename?: 'ClearManagementSessionMutation';
  success: Scalars['Boolean']['output'];
};

/** Close/reject a pull request without merging. */
export type CloseAssetPullRequestMutation = {
  __typename?: 'CloseAssetPullRequestMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type CombinedCategoriesWidgetValue = WidgetValue & {
  __typename?: 'CombinedCategoriesWidgetValue';
  exportLinks: Array<Maybe<ExportLink>>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  legend?: Maybe<WidgetLegend>;
  notes?: Maybe<Array<BaseNoteGqlType>>;
  renderHints?: Maybe<GroupedCategoriesWidgetRenderHints>;
  title: Scalars['String']['output'];
  type: WidgetValueFormat;
  unit: Unit;
  values: Array<CombinedCategoryDataset>;
  xAxisLabel?: Maybe<Scalars['String']['output']>;
  yAxisLabel?: Maybe<Scalars['String']['output']>;
};

export type CombinedCategoryDataset = {
  __typename?: 'CombinedCategoryDataset';
  category: Scalars['String']['output'];
  items: Array<Scalars['Float']['output']>;
  negative: Scalars['Boolean']['output'];
  type: CombinedChartType;
};

export enum CombinedChartType {
  /** Bar */
  Bar = 'BAR',
  /** Line */
  Line = 'LINE'
}

export type Command = VaultAsset & {
  __typename?: 'Command';
  /** Repository code contexts where this asset will execute */
  codeContexts: Array<AssetCodeContext>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** Whether an evaluation is currently in progress for this asset */
  evaluating: Scalars['Boolean']['output'];
  /** Files belonging to this asset */
  files: Array<SkillFile>;
  id: Scalars['ID']['output'];
  /** Pending installation requests for this asset visible to the current user */
  installationRequests: Array<AssetInstallationRequest>;
  installations: Array<VaultAssetInstallation>;
  isChatDefault: Scalars['Boolean']['output'];
  latestVersion: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Current user's permissions for this asset */
  permissions?: Maybe<VaultAssetPermissions>;
  profiles: Array<VaultAssetProfile>;
  slug: Scalars['String']['output'];
  /** Asset source metadata */
  source: AssetSource;
  status?: Maybe<SkillStatusEnum>;
  /** Token counts for the current version */
  tokenCounts?: Maybe<AssetTokenCount>;
  type: AssetType;
  updatedAt: Scalars['DateTime']['output'];
  usageCount: Scalars['Int']['output'];
  versions: Array<VaultAssetVersion>;
  versionsCount: Scalars['Int']['output'];
};


export type CommandFilesArgs = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type Comment = {
  __typename?: 'Comment';
  author?: Maybe<User>;
  createdOn: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  text: TextContent;
  updatedOn: Scalars['DateTime']['output'];
};

export type CommentConnection = {
  __typename?: 'CommentConnection';
  edges: Array<CommentEdge>;
  nodes: Array<Comment>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type CommentEdge = {
  __typename?: 'CommentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Comment;
};

export type Commentable = {
  comment?: Maybe<Comment>;
  commentAuthors: UserConnection;
  comments: CommentConnection;
  commentsCount: Scalars['Int']['output'];
};


export type CommentableCommentArgs = {
  id: Scalars['ID']['input'];
};


export type CommentableCommentAuthorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CommentableCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Compare skill files with the source repository to see differences. */
export type CompareSkillWithRepositoryMutation = {
  __typename?: 'CompareSkillWithRepositoryMutation';
  comparison?: Maybe<SkillComparisonResult>;
  errors: Array<ErrorType>;
};

/**
 * Kick off background import of confirmed candidates.
 *
 * Returns immediately. Frontend watches ``managedImportRunStatus`` (polling)
 * and ``MANAGED_IMPORT_ITEM_COMPLETED`` / ``MANAGED_IMPORT_RUN_COMPLETED``
 * WebSocket events for progress. The scan status in Redis is cleared so a
 * subsequent re-scan starts fresh.
 */
export type ConfirmManagedImportMutation = {
  __typename?: 'ConfirmManagedImportMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type CopyReviewInput = {
  fromReview: Scalars['ID']['input'];
  /** The title of the new review, defaults to the title of the previous review. */
  newTitle?: InputMaybe<Scalars['String']['input']>;
  /** The workspace to create the new review in. Defaults to the same workspace. */
  toWorkspace?: InputMaybe<Scalars['ID']['input']>;
};

/** Creates a new review that starts a new review chain. The new review will have no link to the blueprint review, except that all the widgets were copied over. */
export type CopyReviewMutation = {
  __typename?: 'CopyReviewMutation';
  errors?: Maybe<Array<ErrorType>>;
  review?: Maybe<Review>;
};

export type CreateAccessTokenInputType = {
  label: Scalars['String']['input'];
  orgSlug: Scalars['ID']['input'];
  scope: OAuthScopeType;
};

export type CreateAccessTokenMutation = {
  __typename?: 'CreateAccessTokenMutation';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  token?: Maybe<Scalars['String']['output']>;
};

export type CreateAssetEvalInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  evalKey: Scalars['String']['input'];
  expectations?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedOutput?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  skillGid: Scalars['ID']['input'];
};

export type CreateAssetEvalMutation = {
  __typename?: 'CreateAssetEvalMutation';
  errors: Array<ErrorType>;
  eval?: Maybe<AssetEval>;
};

export type CreateAssetInput = {
  /** Type: skill, rule, agent, command, mcp, hook, plugin */
  assetType: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  hookArgs?: InputMaybe<Array<Scalars['String']['input']>>;
  hookCommand?: InputMaybe<Scalars['String']['input']>;
  hookEvent?: InputMaybe<Scalars['String']['input']>;
  hookMatcher?: InputMaybe<Scalars['String']['input']>;
  hookTimeout?: InputMaybe<Scalars['Int']['input']>;
  /** Initial installations for the asset (empty/null = org-wide) */
  installations?: InputMaybe<Array<AssetInstallationInput>>;
  mcpArgs?: InputMaybe<Array<Scalars['String']['input']>>;
  mcpCommand?: InputMaybe<Scalars['String']['input']>;
  mcpEnv?: InputMaybe<Scalars['JSONString']['input']>;
  mcpIntegrationId?: InputMaybe<Scalars['ID']['input']>;
  mcpSecured?: InputMaybe<Scalars['Boolean']['input']>;
  mcpToolNames?: InputMaybe<Array<McpToolInput>>;
  mcpTransport?: InputMaybe<Scalars['String']['input']>;
  mcpUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  originalPrompt?: InputMaybe<Scalars['String']['input']>;
  pluginMarketplaceUrl?: InputMaybe<Scalars['String']['input']>;
  /** Direct file content (skips orchestration) */
  rawContent?: InputMaybe<Scalars['String']['input']>;
  ruleGlobs?: InputMaybe<Array<Scalars['String']['input']>>;
  ruleTitle?: InputMaybe<Scalars['String']['input']>;
  /** GID of the SuggestedSkill this was created from */
  suggestionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAssetMutation = {
  __typename?: 'CreateAssetMutation';
  asset?: Maybe<VaultAsset>;
  errors: Array<ErrorType>;
};

export type CreateAssetProfileInput = {
  /** Profile description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Profile name (must be unique within org) */
  name: Scalars['String']['input'];
};

/** Create a new asset profile. */
export type CreateAssetProfileMutation = {
  __typename?: 'CreateAssetProfileMutation';
  errors: Array<ErrorType>;
  profile?: Maybe<VaultAssetProfile>;
};

export type CreateAssetPullRequestInput = {
  /** GID of the skill */
  assetId: Scalars['ID']['input'];
  /** Pull request description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Pull request title */
  title: Scalars['String']['input'];
};

/** Create a new pull request for a skill. */
export type CreateAssetPullRequestMutation = {
  __typename?: 'CreateAssetPullRequestMutation';
  errors: Array<ErrorType>;
  pullRequest?: Maybe<SkillPullRequest>;
};

export type CreateBitbucketIntegrationMutationInput = {
  apiSecondaryToken?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraData?: InputMaybe<Scalars['String']['input']>;
  /** Coma separated list of custom headers Sleuth will send with every request. Specify in the format: my-header=my-value,my-other-header=value2 */
  extraHeaders?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  /** Whether only read operations will be allowed or not. If enabled, some features may be unavailable. */
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The fully qualified url of your instance. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The username of the user used to create the API token */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBitbucketIntegrationMutationPayload = {
  __typename?: 'CreateBitbucketIntegrationMutationPayload';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  integration?: Maybe<IntegrationAuthenticationType>;
};

export type CreateBitbucketPipelinesIntegrationMutationInput = {
  apiSecondaryToken?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraData?: InputMaybe<Scalars['String']['input']>;
  /** Coma separated list of custom headers Sleuth will send with every request. Specify in the format: my-header=my-value,my-other-header=value2 */
  extraHeaders?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  /** Whether only read operations will be allowed or not. If enabled, some features may be unavailable. */
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The fully qualified url of your instance. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The username of the user used to create the API token */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBitbucketPipelinesIntegrationMutationPayload = {
  __typename?: 'CreateBitbucketPipelinesIntegrationMutationPayload';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  integration?: Maybe<IntegrationAuthenticationType>;
};

export type CreateBotApiKeyMutation = {
  __typename?: 'CreateBotApiKeyMutation';
  botKey: Scalars['String']['output'];
};

export type CreateBotInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateBotMutation = {
  __typename?: 'CreateBotMutation';
  bot?: Maybe<ManagedBot>;
  botKey: Scalars['String']['output'];
};

export type CreateBotRuntimeTokenMutation = {
  __typename?: 'CreateBotRuntimeTokenMutation';
  botKey: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
};

export type CreateCircleCiIntegrationMutationInput = {
  apiSecondaryToken?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraData?: InputMaybe<Scalars['String']['input']>;
  /** Coma separated list of custom headers Sleuth will send with every request. Specify in the format: my-header=my-value,my-other-header=value2 */
  extraHeaders?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  /** Whether only read operations will be allowed or not. If enabled, some features may be unavailable. */
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The fully qualified url of your instance. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The username of the user used to create the API token */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCircleCiIntegrationMutationPayload = {
  __typename?: 'CreateCircleCiIntegrationMutationPayload';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  integration?: Maybe<IntegrationAuthenticationType>;
};

export type CreateClubhouseIntegrationMutationInput = {
  apiSecondaryToken?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraData?: InputMaybe<Scalars['String']['input']>;
  /** Coma separated list of custom headers Sleuth will send with every request. Specify in the format: my-header=my-value,my-other-header=value2 */
  extraHeaders?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  /** Whether only read operations will be allowed or not. If enabled, some features may be unavailable. */
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The fully qualified url of your instance. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The username of the user used to create the API token */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClubhouseIntegrationMutationPayload = {
  __typename?: 'CreateClubhouseIntegrationMutationPayload';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  integration?: Maybe<IntegrationAuthenticationType>;
};

export type CreateCommentInput = {
  reviewId?: InputMaybe<Scalars['ID']['input']>;
  sectionId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['HTMLString']['input'];
};

export type CreateCommentMutation = {
  __typename?: 'CreateCommentMutation';
  comment?: Maybe<Comment>;
  errors?: Maybe<Array<ErrorType>>;
};

export type CreateDdIntegrationMutationInput = {
  /** Your <a href='https://app.datadoghq.com/organization-settings/application-keys' target='_blank'>generated</a> Application key */
  apiSecondaryToken: Scalars['String']['input'];
  /** Your <a href='https://app.datadoghq.com/organization-settings/api-keys' target='_blank'>generated</a> API key */
  apiToken: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  inEurope?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  /** URL of your Datadog instance, only required if you are using a custom subdomain. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDdIntegrationMutationPayload = {
  __typename?: 'CreateDDIntegrationMutationPayload';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  integration?: Maybe<IntegrationAuthenticationType>;
};

export type CreateGithubEnterpriseIntegrationMutationInput = {
  apiSecondaryToken?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraData?: InputMaybe<Scalars['String']['input']>;
  /** Coma separated list of custom headers Sleuth will send with every request. Specify in the format: my-header=my-value,my-other-header=value2 */
  extraHeaders?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  /** Whether only read operations will be allowed or not. If enabled, some features may be unavailable. */
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The fully qualified url of your instance. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The username of the user used to create the API token */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGithubEnterpriseIntegrationMutationPayload = {
  __typename?: 'CreateGithubEnterpriseIntegrationMutationPayload';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  integration?: Maybe<IntegrationAuthenticationType>;
};

export type CreateGitlabIntegrationMutationInput = {
  apiSecondaryToken?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraData?: InputMaybe<Scalars['String']['input']>;
  /** Coma separated list of custom headers Sleuth will send with every request. Specify in the format: my-header=my-value,my-other-header=value2 */
  extraHeaders?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  /** Whether only read operations will be allowed or not. If enabled, some features may be unavailable. */
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The fully qualified url of your instance. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The username of the user used to create the API token */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGitlabIntegrationMutationPayload = {
  __typename?: 'CreateGitlabIntegrationMutationPayload';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  integration?: Maybe<IntegrationAuthenticationType>;
};

export type CreateInstallationRequestInput = {
  /** GID of the asset */
  assetId: Scalars['ID']['input'];
  /** GID of the target repository */
  targetEntityId?: InputMaybe<Scalars['String']['input']>;
  /** GID of the target team (required if target_type is 'team') */
  targetTeamId?: InputMaybe<Scalars['ID']['input']>;
  /** 'team', 'organization', or 'repository' */
  targetType: Scalars['String']['input'];
};

export type CreateInstallationRequestMutation = {
  __typename?: 'CreateInstallationRequestMutation';
  errors: Array<ErrorType>;
  installationRequest?: Maybe<AssetInstallationRequest>;
};

export type CreateIntegrationMutationInput = {
  apiSecondaryToken?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraData?: InputMaybe<Scalars['String']['input']>;
  /** Coma separated list of custom headers Sleuth will send with every request. Specify in the format: my-header=my-value,my-other-header=value2 */
  extraHeaders?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  /** Whether only read operations will be allowed or not. If enabled, some features may be unavailable. */
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The fully qualified url of your instance. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The username of the user used to create the API token */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIntegrationMutationPayload = {
  __typename?: 'CreateIntegrationMutationPayload';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  integration?: Maybe<IntegrationAuthenticationType>;
};

export type CreateJenkinsIntegrationMutationInput = {
  apiSecondaryToken?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraData?: InputMaybe<Scalars['String']['input']>;
  /** Coma separated list of custom headers Sleuth will send with every request. Specify in the format: my-header=my-value,my-other-header=value2 */
  extraHeaders?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  /** Whether only read operations will be allowed or not. If enabled, some features may be unavailable. */
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The fully qualified url of your instance. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The username of the user used to create the API token */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateJenkinsIntegrationMutationPayload = {
  __typename?: 'CreateJenkinsIntegrationMutationPayload';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  integration?: Maybe<IntegrationAuthenticationType>;
};

export type CreateJiraDatacenterIntegrationMutationInput = {
  apiSecondaryToken?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraData?: InputMaybe<Scalars['String']['input']>;
  /** Coma separated list of custom headers Sleuth will send with every request. Specify in the format: my-header=my-value,my-other-header=value2 */
  extraHeaders?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  /** Whether only read operations will be allowed or not. If enabled, some features may be unavailable. */
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The fully qualified url of your instance. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The username of the user used to create the API token */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateJiraDatacenterIntegrationMutationPayload = {
  __typename?: 'CreateJiraDatacenterIntegrationMutationPayload';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  integration?: Maybe<IntegrationAuthenticationType>;
};

export type CreateLegacyIntegrationMutationInput = {
  apiSecondaryToken?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraData?: InputMaybe<Scalars['String']['input']>;
  /** Coma separated list of custom headers Sleuth will send with every request. Specify in the format: my-header=my-value,my-other-header=value2 */
  extraHeaders?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  /** Whether only read operations will be allowed or not. If enabled, some features may be unavailable. */
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The fully qualified url of your instance. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The username of the user used to create the API token */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLegacyIntegrationMutationPayload = {
  __typename?: 'CreateLegacyIntegrationMutationPayload';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  integration?: Maybe<IntegrationAuthenticationType>;
};

export type CreateMonoRepoConfigInput = {
  issueProvider?: InputMaybe<Provider>;
  issueTeamKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  repositoryId: Scalars['ID']['input'];
  sourcePathPrefixExcludes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourcePathPrefixIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateMonoRepoConfigMutation = {
  __typename?: 'CreateMonoRepoConfigMutation';
  errors: Array<ErrorType>;
  monoRepoConfig?: Maybe<MonoRepoConfigOutputType>;
};

export type CreateNotificationInput = {
  event?: InputMaybe<NotificationEvent>;
  integrationAuthId?: InputMaybe<Scalars['ID']['input']>;
  provider: NotificationProviderType;
};

export type CreateNotificationMutation = {
  __typename?: 'CreateNotificationMutation';
  errors: Array<ErrorType>;
  notification?: Maybe<Notification>;
  success: Scalars['Boolean']['output'];
};

export type CreatePersonalTokenMutation = {
  __typename?: 'CreatePersonalTokenMutation';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  token: Scalars['String']['output'];
};

export type CreateReviewInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  templateId: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type CreateReviewMutation = {
  __typename?: 'CreateReviewMutation';
  errors?: Maybe<Array<ErrorType>>;
  review?: Maybe<Review>;
};

export type CreateSectionInput = {
  hasAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  reviewId: Scalars['ID']['input'];
};

export type CreateSectionMutation = {
  __typename?: 'CreateSectionMutation';
  errors?: Maybe<Array<ErrorType>>;
  section?: Maybe<Section>;
};

export type CreateSkillFileInput = {
  assetId: Scalars['ID']['input'];
  changeSummary?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  name: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Create a new file on an asset and seed it with an initial content version. */
export type CreateSkillFileMutation = {
  __typename?: 'CreateSkillFileMutation';
  errors: Array<ErrorType>;
  file?: Maybe<SkillFile>;
};

export type CreateTeamInput = {
  members: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['ID']['input']>;
  skillsRepositories?: InputMaybe<Array<SkillsRepositoryInput>>;
};

export type CreateTeamMutation = {
  __typename?: 'CreateTeamMutation';
  errors: Array<ErrorType>;
  team?: Maybe<Team>;
};

export type CreateWidgetInput = {
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSONString']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  renderer?: InputMaybe<FormatRenderer>;
  sectionId: Scalars['ID']['input'];
  size?: InputMaybe<WidgetSize>;
  /** All possible values are: Current month breakdown, Current quarter breakdown, Details, Manual chart, Manual stacked chart, Percentages, Period breakdown, Period vs last period trend, Period vs period last year, Previous comparison, Priorities, Proportions, Rating, Single number, Six months trend, Six period proportions trend, Six period trend, Survey answer list, Text, Trend, Twelve months trend, Twelve period proportions trend, Twelve period trend, Two months trend. But not every widget supports all of them. Each widget has a different default. */
  valueType?: InputMaybe<Scalars['String']['input']>;
  widgetType: Scalars['String']['input'];
};

export type CreateWidgetMutation = {
  __typename?: 'CreateWidgetMutation';
  errors?: Maybe<Array<ErrorType>>;
  widget?: Maybe<Widget>;
};

export type CreateWorkspaceMutation = {
  __typename?: 'CreateWorkspaceMutation';
  errors?: Maybe<Array<ErrorType>>;
  workspace?: Maybe<Workspace>;
};

export type CreateWorkspaceMutationInput = {
  marker?: InputMaybe<WorkspaceMarkerInput>;
  name: Scalars['String']['input'];
};

export enum Currency {
  /** UAE Dirham */
  Aed = 'AED',
  /** Afghani */
  Afn = 'AFN',
  /** Lek */
  All = 'ALL',
  /** Armenian Dram */
  Amd = 'AMD',
  /** Netherlands Antillean Guilder */
  Ang = 'ANG',
  /** Kwanza */
  Aoa = 'AOA',
  /** Argentine Peso */
  Ars = 'ARS',
  /** Australian Dollar */
  Aud = 'AUD',
  /** Aruban Florin */
  Awg = 'AWG',
  /** Azerbaijanian Manat */
  Azn = 'AZN',
  /** Convertible Mark */
  Bam = 'BAM',
  /** Barbados Dollar */
  Bbd = 'BBD',
  /** Taka */
  Bdt = 'BDT',
  /** Bulgarian Lev */
  Bgn = 'BGN',
  /** Bahraini Dinar */
  Bhd = 'BHD',
  /** Burundi Franc */
  Bif = 'BIF',
  /** Bermudian Dollar */
  Bmd = 'BMD',
  /** Brunei Dollar */
  Bnd = 'BND',
  /** Boliviano */
  Bob = 'BOB',
  /** Mvdol */
  Bov = 'BOV',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Bahamian Dollar */
  Bsd = 'BSD',
  /** Ngultrum */
  Btn = 'BTN',
  /** Pula */
  Bwp = 'BWP',
  /** Belarusian Ruble (BYN) */
  Byn = 'BYN',
  /** Belarusian Ruble (BYR) */
  Byr = 'BYR',
  /** Belize Dollar */
  Bzd = 'BZD',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Congolese Franc */
  Cdf = 'CDF',
  /** WIR Euro */
  Che = 'CHE',
  /** Swiss Franc */
  Chf = 'CHF',
  /** WIR Franc */
  Chw = 'CHW',
  /** Unidades de fomento */
  Clf = 'CLF',
  /** Chilean Peso */
  Clp = 'CLP',
  /** Yuan Renminbi */
  Cny = 'CNY',
  /** Colombian Peso */
  Cop = 'COP',
  /** Unidad de Valor Real */
  Cou = 'COU',
  /** Costa Rican Colon */
  Crc = 'CRC',
  /** Peso Convertible */
  Cuc = 'CUC',
  /** Cuban Peso */
  Cup = 'CUP',
  /** Cape Verde Escudo */
  Cve = 'CVE',
  /** Czech Koruna */
  Czk = 'CZK',
  /** Djibouti Franc */
  Djf = 'DJF',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Dominican Peso */
  Dop = 'DOP',
  /** Algerian Dinar */
  Dzd = 'DZD',
  /** Egyptian Pound */
  Egp = 'EGP',
  /** Nakfa */
  Ern = 'ERN',
  /** Ethiopian Birr */
  Etb = 'ETB',
  /** Euro */
  Eur = 'EUR',
  /** Fiji Dollar */
  Fjd = 'FJD',
  /** Falkland Islands Pound */
  Fkp = 'FKP',
  /** Pound Sterling */
  Gbp = 'GBP',
  /** Lari */
  Gel = 'GEL',
  /** Ghana Cedi */
  Ghs = 'GHS',
  /** Gibraltar Pound */
  Gip = 'GIP',
  /** Dalasi */
  Gmd = 'GMD',
  /** Guinea Franc */
  Gnf = 'GNF',
  /** Quetzal */
  Gtq = 'GTQ',
  /** Guyana Dollar */
  Gyd = 'GYD',
  /** Hong Kong Dollar */
  Hkd = 'HKD',
  /** Lempira */
  Hnl = 'HNL',
  /** Croatian Kuna */
  Hrk = 'HRK',
  /** Gourde */
  Htg = 'HTG',
  /** Forint */
  Huf = 'HUF',
  /** Rupiah */
  Idr = 'IDR',
  /** New Israeli Sheqel */
  Ils = 'ILS',
  /** Indian Rupee */
  Inr = 'INR',
  /** Iraqi Dinar */
  Iqd = 'IQD',
  /** Iranian Rial */
  Irr = 'IRR',
  /** Iceland Krona */
  Isk = 'ISK',
  /** Jamaican Dollar */
  Jmd = 'JMD',
  /** Jordanian Dinar */
  Jod = 'JOD',
  /** Yen */
  Jpy = 'JPY',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Som */
  Kgs = 'KGS',
  /** Riel */
  Khr = 'KHR',
  /** Comoro Franc */
  Kmf = 'KMF',
  /** North Korean Won */
  Kpw = 'KPW',
  /** Won */
  Krw = 'KRW',
  /** Kuwaiti Dinar */
  Kwd = 'KWD',
  /** Cayman Islands Dollar */
  Kyd = 'KYD',
  /** Tenge */
  Kzt = 'KZT',
  /** Kip */
  Lak = 'LAK',
  /** Lebanese Pound */
  Lbp = 'LBP',
  /** Sri Lanka Rupee */
  Lkr = 'LKR',
  /** Liberian Dollar */
  Lrd = 'LRD',
  /** Loti */
  Lsl = 'LSL',
  /** Lithuanian Litas */
  Ltl = 'LTL',
  /** Latvian Lats */
  Lvl = 'LVL',
  /** Libyan Dinar */
  Lyd = 'LYD',
  /** Moroccan Dirham */
  Mad = 'MAD',
  /** Moldovan Leu */
  Mdl = 'MDL',
  /** Malagasy Ariary */
  Mga = 'MGA',
  /** Denar */
  Mkd = 'MKD',
  /** Kyat */
  Mmk = 'MMK',
  /** Tugrik */
  Mnt = 'MNT',
  /** Pataca */
  Mop = 'MOP',
  /** Ouguiya */
  Mro = 'MRO',
  /** Mauritius Rupee */
  Mur = 'MUR',
  /** Rufiyaa */
  Mvr = 'MVR',
  /** Kwacha */
  Mwk = 'MWK',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Mexican Unidad de Inversion (UDI) */
  Mxv = 'MXV',
  /** Malaysian Ringgit */
  Myr = 'MYR',
  /** Mozambique Metical */
  Mzn = 'MZN',
  /** Namibia Dollar */
  Nad = 'NAD',
  /** Naira */
  Ngn = 'NGN',
  /** Cordoba Oro */
  Nio = 'NIO',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** Nepalese Rupee */
  Npr = 'NPR',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Rial Omani */
  Omr = 'OMR',
  /** Balboa */
  Pab = 'PAB',
  /** Nuevo Sol */
  Pen = 'PEN',
  /** Kina */
  Pgk = 'PGK',
  /** Philippine Peso */
  Php = 'PHP',
  /** Pakistan Rupee */
  Pkr = 'PKR',
  /** Zloty */
  Pln = 'PLN',
  /** Guarani */
  Pyg = 'PYG',
  /** Qatari Rial */
  Qar = 'QAR',
  /** New Romanian Leu */
  Ron = 'RON',
  /** Serbian Dinar */
  Rsd = 'RSD',
  /** Russian Ruble */
  Rub = 'RUB',
  /** Rwanda Franc */
  Rwf = 'RWF',
  /** Saudi Riyal */
  Sar = 'SAR',
  /** Solomon Islands Dollar */
  Sbd = 'SBD',
  /** Seychelles Rupee */
  Scr = 'SCR',
  /** Sudanese Pound */
  Sdg = 'SDG',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** Saint Helena Pound */
  Shp = 'SHP',
  /** Leone */
  Sll = 'SLL',
  /** Somali Shilling */
  Sos = 'SOS',
  /** Surinam Dollar */
  Srd = 'SRD',
  /** South Sudanese Pound */
  Ssp = 'SSP',
  /** Dobra */
  Std = 'STD',
  /** El Salvador Colon */
  Svc = 'SVC',
  /** Syrian Pound */
  Syp = 'SYP',
  /** Lilangeni */
  Szl = 'SZL',
  /** Baht */
  Thb = 'THB',
  /** Somoni */
  Tjs = 'TJS',
  /** Turkmenistan New Manat */
  Tmt = 'TMT',
  /** Tunisian Dinar */
  Tnd = 'TND',
  /** Pa’anga */
  Top = 'TOP',
  /** Turkish Lira */
  Try = 'TRY',
  /** Trinidad and Tobago Dollar */
  Ttd = 'TTD',
  /** New Taiwan Dollar */
  Twd = 'TWD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Hryvnia */
  Uah = 'UAH',
  /** Uganda Shilling */
  Ugx = 'UGX',
  /** US Dollar */
  Usd = 'USD',
  /** US Dollar (Next day) */
  Usn = 'USN',
  /** US Dollar (Same day) */
  Uss = 'USS',
  /** Uruguay Peso en Unidades Indexadas (URUIURUI) */
  Uyi = 'UYI',
  /** Peso Uruguayo */
  Uyu = 'UYU',
  /** Uzbekistan Sum */
  Uzs = 'UZS',
  /** Bolivar */
  Vef = 'VEF',
  /** Dong */
  Vnd = 'VND',
  /** Vatu */
  Vuv = 'VUV',
  /** Tala */
  Wst = 'WST',
  /** CFA Franc BEAC */
  Xaf = 'XAF',
  /** Silver */
  Xag = 'XAG',
  /** Gold */
  Xau = 'XAU',
  /** Bond Markets Unit European Composite Unit (EURCO) */
  Xba = 'XBA',
  /** Bond Markets Unit European Monetary Unit (E.M.U.-6) */
  Xbb = 'XBB',
  /** Bond Markets Unit European Unit of Account 9 (E.U.A.-9) */
  Xbc = 'XBC',
  /** Bond Markets Unit European Unit of Account 17 (E.U.A.-17) */
  Xbd = 'XBD',
  /** East Caribbean Dollar */
  Xcd = 'XCD',
  /** SDR (Special Drawing Right) */
  Xdr = 'XDR',
  /** UIC-Franc */
  Xfu = 'XFU',
  /** CFA Franc BCEAO */
  Xof = 'XOF',
  /** Palladium */
  Xpd = 'XPD',
  /** CFP Franc */
  Xpf = 'XPF',
  /** Platinum */
  Xpt = 'XPT',
  /** Sucre */
  Xsu = 'XSU',
  /** Codes specifically reserved for testing purposes */
  Xts = 'XTS',
  /** ADB Unit of Account */
  Xua = 'XUA',
  /** Yemeni Rial */
  Yer = 'YER',
  /** Rand */
  Zar = 'ZAR',
  /** Zambian Kwacha */
  Zmw = 'ZMW',
  /** Zimbabwe Dollar */
  Zwl = 'ZWL'
}

export type CustomizeAssessmentMutation = {
  __typename?: 'CustomizeAssessmentMutation';
  errors?: Maybe<Array<ErrorType>>;
  instance?: Maybe<Assessment>;
};

export type Dashboard = Assessable & Commentable & TeamOrUsersScoped & UserScoped & {
  __typename?: 'Dashboard';
  assessment: DelayedAssessment;
  comment?: Maybe<Comment>;
  commentAuthors: UserConnection;
  comments: CommentConnection;
  commentsCount: Scalars['Int']['output'];
  createdOn: Scalars['DateTime']['output'];
  end: Scalars['DateTime']['output'];
  highlightWidget?: Maybe<Widget>;
  id: Scalars['ID']['output'];
  modifiedOn: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<User>;
  section?: Maybe<Section>;
  sections: SectionConnection;
  start: Scalars['DateTime']['output'];
  teamsOrUsers: TeamOrUsersConnection;
  users: UserConnection;
  workspace: Workspace;
};


export type DashboardCommentArgs = {
  id: Scalars['ID']['input'];
};


export type DashboardCommentAuthorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardSectionArgs = {
  id: Scalars['ID']['input'];
};


export type DashboardSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardTeamsOrUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type DashboardUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardConnection = {
  __typename?: 'DashboardConnection';
  edges: Array<DashboardEdge>;
  nodes: Array<Dashboard>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type DashboardEdge = {
  __typename?: 'DashboardEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Dashboard;
};

export enum DataType {
  /** Currency */
  Currency = 'CURRENCY',
  /** Date */
  Date = 'DATE',
  /** DateTime */
  Datetime = 'DATETIME',
  /** Link */
  Link = 'LINK',
  /** Number */
  Number = 'NUMBER',
  /** Text */
  Text = 'TEXT'
}

export type DateModifierNote = BaseNoteGqlType & {
  __typename?: 'DateModifierNote';
  end: Scalars['DateTime']['output'];
  endField?: Maybe<Scalars['String']['output']>;
  msg: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  startField: Scalars['String']['output'];
};

export type Delayable = {
  inProgress: Scalars['Boolean']['output'];
};

export type DelayedAssessment = Delayable & {
  __typename?: 'DelayedAssessment';
  inProgress: Scalars['Boolean']['output'];
  instance?: Maybe<Assessment>;
};

export type DelayedWidgetValue = Delayable & {
  __typename?: 'DelayedWidgetValue';
  error?: Maybe<WidgetError>;
  inProgress: Scalars['Boolean']['output'];
  instance?: Maybe<WidgetValue>;
  sourceData: SourceData;
  valueContextId: Scalars['String']['output'];
};


export type DelayedWidgetValueSourceDataArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  periodIndex?: Scalars['Int']['input'];
};

export type DeleteAccessTokenInputType = {
  orgSlug: Scalars['ID']['input'];
  tokenId: Scalars['ID']['input'];
};

export type DeleteAccessTokenMutation = {
  __typename?: 'DeleteAccessTokenMutation';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteAssetEvalInput = {
  evalGid: Scalars['ID']['input'];
};

export type DeleteAssetEvalMutation = {
  __typename?: 'DeleteAssetEvalMutation';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteAssetMutation = {
  __typename?: 'DeleteAssetMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type DeleteAssetProfileInput = {
  /** Profile GID to delete */
  gid: Scalars['ID']['input'];
};

/** Delete an asset profile. */
export type DeleteAssetProfileMutation = {
  __typename?: 'DeleteAssetProfileMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type DeleteBotApiKeyMutation = {
  __typename?: 'DeleteBotApiKeyMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type DeleteBotMutation = {
  __typename?: 'DeleteBotMutation';
  bot?: Maybe<ManagedBot>;
  errors: Array<ErrorType>;
};

export type DeleteBulkUserWorkingHoursMutation = {
  __typename?: 'DeleteBulkUserWorkingHoursMutation';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteCommentMutation = {
  __typename?: 'DeleteCommentMutation';
  errors?: Maybe<Array<ErrorType>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteCurrentUserWorkingHoursMutation = {
  __typename?: 'DeleteCurrentUserWorkingHoursMutation';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteIntegrationAuthenticationMutationInput = {
  provider: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteIntegrationAuthenticationMutationPayload = {
  __typename?: 'DeleteIntegrationAuthenticationMutationPayload';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteMemberMutation = {
  __typename?: 'DeleteMemberMutation';
  success: Scalars['Boolean']['output'];
};

export type DeleteMonoRepoConfigMutation = {
  __typename?: 'DeleteMonoRepoConfigMutation';
  affectedTeams?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type DeleteNotificationMutation = {
  __typename?: 'DeleteNotificationMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type DeleteOrganizationWorkingHoursMutation = {
  __typename?: 'DeleteOrganizationWorkingHoursMutation';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type DeletePersonalTokenMutation = {
  __typename?: 'DeletePersonalTokenMutation';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteReviewChainMutation = {
  __typename?: 'DeleteReviewChainMutation';
  errors?: Maybe<Array<ErrorType>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteReviewMutation = {
  __typename?: 'DeleteReviewMutation';
  errors?: Maybe<Array<ErrorType>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteSectionMutation = {
  __typename?: 'DeleteSectionMutation';
  errors?: Maybe<Array<ErrorType>>;
  success: Scalars['Boolean']['output'];
};

/** Delete a file from an asset, creating a new asset version without it. */
export type DeleteSkillFileMutation = {
  __typename?: 'DeleteSkillFileMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type DeleteTeamMutation = {
  __typename?: 'DeleteTeamMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type DeleteWidgetMutation = {
  __typename?: 'DeleteWidgetMutation';
  errors?: Maybe<Array<ErrorType>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteWorkspaceMutation = {
  __typename?: 'DeleteWorkspaceMutation';
  errors?: Maybe<Array<ErrorType>>;
  success: Scalars['Boolean']['output'];
};

export type DescriptionOptimization = {
  __typename?: 'DescriptionOptimization';
  bestDescription: Scalars['String']['output'];
  bestScore: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Full iteration history */
  history?: Maybe<Scalars['JSONString']['output']>;
  id: Scalars['ID']['output'];
  iterationsRun: Scalars['Int']['output'];
  originalDesc: Scalars['String']['output'];
  status: SkillsDescriptionOptimizationStatusChoices;
  /** [{query, should_trigger}] */
  triggerEvalSet?: Maybe<Scalars['JSONString']['output']>;
};

export type DeveloperSalaryInputType = {
  annualRate: Scalars['Decimal']['input'];
  currency: Currency;
  id?: InputMaybe<Scalars['ID']['input']>;
  level: SalaryLevel;
};

export type DeveloperSalaryType = {
  __typename?: 'DeveloperSalaryType';
  annualRate: Scalars['Decimal']['output'];
  currency: Currency;
  id: Scalars['String']['output'];
  level: SalaryLevel;
};

export type DeviceGrant = {
  __typename?: 'DeviceGrant';
  status: Scalars['String']['output'];
  userCode: Scalars['String']['output'];
};

export type DoraLegend = WidgetLegend & {
  __typename?: 'DoraLegend';
  items: Array<DoraLegendItem>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DoraLegendItem = {
  __typename?: 'DoraLegendItem';
  /** Will be one of `Failure rate`, `Frequency`, `Lead time`, `MTTR` */
  categoryName: Scalars['String']['output'];
  rank?: Maybe<DoraRanking>;
};

export enum DoraRanking {
  Elite = 'ELITE',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type EditCommentInput = {
  id: Scalars['ID']['input'];
  text: Scalars['HTMLString']['input'];
};

export type EditCommentMutation = {
  __typename?: 'EditCommentMutation';
  comment?: Maybe<Comment>;
  errors?: Maybe<Array<ErrorType>>;
};

export type EpicDataset = {
  __typename?: 'EpicDataset';
  end?: Maybe<Scalars['DateTime']['output']>;
  isOverdue: Scalars['Boolean']['output'];
  percentage?: Maybe<Scalars['FloatRoundedTo1']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type EpicsTimelineWidgetValue = WidgetValue & {
  __typename?: 'EpicsTimelineWidgetValue';
  exportLinks: Array<Maybe<ExportLink>>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  legend?: Maybe<WidgetLegend>;
  notes?: Maybe<Array<BaseNoteGqlType>>;
  renderHints?: Maybe<CategoriesWidgetRenderHints>;
  title: Scalars['String']['output'];
  type: WidgetValueFormat;
  unit: Unit;
  values: Array<EpicDataset>;
};

export type ErrorType = {
  __typename?: 'ErrorType';
  field: Scalars['String']['output'];
  messages: Array<Scalars['String']['output']>;
};

export type EvalBenchmark = {
  __typename?: 'EvalBenchmark';
  createdAt: Scalars['DateTime']['output'];
  error: Scalars['String']['output'];
  executorModel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Analyzer observations and patterns */
  notes?: Maybe<Scalars['JSONString']['output']>;
  /** Aggregated stats: {with_skill: {...}, without_skill: {...}, delta: {...}} */
  runSummary?: Maybe<Scalars['JSONString']['output']>;
  runs?: Maybe<Array<EvalRun>>;
  runsPerConfig: Scalars['Int']['output'];
  status: SkillsEvalBenchmarkStatusChoices;
  triggeredBy: SkillsEvalBenchmarkTriggeredByChoices;
};

/** Lightweight benchmark summary for list views. */
export type EvalBenchmarkSummary = {
  __typename?: 'EvalBenchmarkSummary';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  passRate?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  triggeredBy: Scalars['String']['output'];
};

export type EvalGrading = {
  __typename?: 'EvalGrading';
  /** [{claim, type, verified, evidence}] */
  claims?: Maybe<Scalars['JSONString']['output']>;
  /** {suggestions[], overall} */
  evalFeedback?: Maybe<Scalars['JSONString']['output']>;
  /** [{text, passed, evidence}] */
  expectationsResults: Scalars['JSONString']['output'];
  failed: Scalars['Int']['output'];
  /** 0.0 to 1.0 */
  passRate: Scalars['Float']['output'];
  passed: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EvalRun = {
  __typename?: 'EvalRun';
  configuration: SkillsEvalRunConfigurationChoices;
  createdAt: Scalars['DateTime']['output'];
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  error: Scalars['String']['output'];
  /** Key of the eval this run belongs to */
  evalKey?: Maybe<Scalars['String']['output']>;
  grading?: Maybe<EvalGrading>;
  id: Scalars['ID']['output'];
  output: Scalars['String']['output'];
  runNumber: Scalars['Int']['output'];
  status: SkillsEvalRunStatusChoices;
  toolCallsCount: Scalars['Int']['output'];
  totalTokens?: Maybe<Scalars['Int']['output']>;
};

/** Evaluate an asset's quality, actionability, and completeness. */
export type EvaluateAssetMutation = {
  __typename?: 'EvaluateAssetMutation';
  asset?: Maybe<VaultAsset>;
  errors: Array<ErrorType>;
};

export type ExportAssetEvalsInput = {
  skillGid: Scalars['ID']['input'];
};

export type ExportAssetEvalsMutation = {
  __typename?: 'ExportAssetEvalsMutation';
  errors: Array<ErrorType>;
  evalsJson?: Maybe<Scalars['String']['output']>;
};

export enum ExportFormat {
  /** XLSX */
  Xlsx = 'XLSX'
}

export type ExportLink = {
  __typename?: 'ExportLink';
  format: ExportFormat;
  url: Scalars['String']['output'];
};

export type ExternalUserType = {
  __typename?: 'ExternalUserType';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  user?: Maybe<User>;
  username?: Maybe<Scalars['String']['output']>;
};

export type ExternalUserTypeEdge = {
  __typename?: 'ExternalUserTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExternalUserType;
};

export type ExternalUsersConnection = {
  __typename?: 'ExternalUsersConnection';
  edges: Array<ExternalUserTypeEdge>;
  nodes: Array<ExternalUserType>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type FavoriteWorkspaceMutation = {
  __typename?: 'FavoriteWorkspaceMutation';
  errors?: Maybe<Array<ErrorType>>;
  success: Scalars['Boolean']['output'];
};

export type FavoriteWorkspaceType = {
  __typename?: 'FavoriteWorkspaceType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FiltersModifierNote = BaseNoteGqlType & {
  __typename?: 'FiltersModifierNote';
  filters: Array<Maybe<Scalars['String']['output']>>;
  msg: Scalars['String']['output'];
};

export enum FormatRenderer {
  /** Bar chart */
  BarChart = 'BAR_CHART',
  /** Bar with line chart */
  BarWithLineChart = 'BAR_WITH_LINE_CHART',
  /** Dora */
  Dora = 'DORA',
  /** Doughnut chart */
  DoughnutChart = 'DOUGHNUT_CHART',
  /** Emoji */
  Emoji = 'EMOJI',
  /** Horizontal bar chart */
  HorizontalBarChart = 'HORIZONTAL_BAR_CHART',
  /** Horizontal proportion chart */
  HorizontalProportionChart = 'HORIZONTAL_PROPORTION_CHART',
  /** HTML */
  Html = 'HTML',
  /** KTLO */
  Ktlo = 'KTLO',
  /** Line chart */
  LineChart = 'LINE_CHART',
  /** Percentage table */
  PercentageTable = 'PERCENTAGE_TABLE',
  /** Pie chart */
  PieChart = 'PIE_CHART',
  /** Pie chart (top 5) */
  PieChartTopFive = 'PIE_CHART_TOP_FIVE',
  /** Priorities */
  Priorities = 'PRIORITIES',
  /** Radar chart */
  RadarChart = 'RADAR_CHART',
  /** Rating table */
  RatingTable = 'RATING_TABLE',
  /** Sorted bar chart */
  SortedBarChart = 'SORTED_BAR_CHART',
  /** Stacked bar chart */
  StackedBarChart = 'STACKED_BAR_CHART',
  /** Stacked Line chart */
  StackedLineChart = 'STACKED_LINE_CHART',
  /** Survey rating answer list */
  SurveyRatingAnswerList = 'SURVEY_RATING_ANSWER_LIST',
  /** Survey text answer list */
  SurveyTextAnswerList = 'SURVEY_TEXT_ANSWER_LIST',
  /** Timeline */
  Timeline = 'TIMELINE',
  /** Traffic light */
  TrafficLight = 'TRAFFIC_LIGHT',
  /** Weather */
  Weather = 'WEATHER'
}

export type GenerateAssessmentMutation = {
  __typename?: 'GenerateAssessmentMutation';
  errors?: Maybe<Array<ErrorType>>;
};

/** Generate more skill suggestions for a repository without deleting existing ones. */
export type GenerateMoreRepositorySuggestionsMutation = {
  __typename?: 'GenerateMoreRepositorySuggestionsMutation';
  errors: Array<ErrorType>;
  repositoryGid?: Maybe<Scalars['String']['output']>;
};

export type GenerateSkillPatchInput = {
  /** Action: UPDATE to sync changes, DELETE to remove skill from repo */
  actionType: SkillPatchActionTypeEnum;
  /** GID of the skill to generate patch for */
  skillId: Scalars['ID']['input'];
};

/** Generate a unified diff patch for skill changes to download. */
export type GenerateSkillPatchMutation = {
  __typename?: 'GenerateSkillPatchMutation';
  errors: Array<ErrorType>;
  filename?: Maybe<Scalars['String']['output']>;
  patchContent?: Maybe<Scalars['String']['output']>;
};

export type GroupedCategoriesWidgetRenderHints = {
  __typename?: 'GroupedCategoriesWidgetRenderHints';
  rawDateLabels?: Maybe<Scalars['Boolean']['output']>;
  renderPercentages?: Maybe<Scalars['Boolean']['output']>;
  xAxisLabel?: Maybe<Scalars['String']['output']>;
  yAxisLabel?: Maybe<Scalars['String']['output']>;
};

export type GroupedCategoriesWidgetValue = WidgetValue & {
  __typename?: 'GroupedCategoriesWidgetValue';
  exportLinks: Array<Maybe<ExportLink>>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  legend?: Maybe<WidgetLegend>;
  legendsForPeriods?: Maybe<Array<WidgetLegend>>;
  notes?: Maybe<Array<BaseNoteGqlType>>;
  renderHints?: Maybe<GroupedCategoriesWidgetRenderHints>;
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: WidgetValueFormat;
  unit: Unit;
  values: Array<CategoryDataset>;
  xAxisLabel?: Maybe<Scalars['String']['output']>;
  yAxisLabel?: Maybe<Scalars['String']['output']>;
};

export type Hook = VaultAsset & {
  __typename?: 'Hook';
  /** Repository code contexts where this asset will execute */
  codeContexts: Array<AssetCodeContext>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** Whether an evaluation is currently in progress for this asset */
  evaluating: Scalars['Boolean']['output'];
  event?: Maybe<Scalars['String']['output']>;
  /** Files belonging to this asset */
  files: Array<SkillFile>;
  hookArgs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hookCommand?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Pending installation requests for this asset visible to the current user */
  installationRequests: Array<AssetInstallationRequest>;
  installations: Array<VaultAssetInstallation>;
  isChatDefault: Scalars['Boolean']['output'];
  latestVersion: Scalars['String']['output'];
  matcher?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Current user's permissions for this asset */
  permissions?: Maybe<VaultAssetPermissions>;
  profiles: Array<VaultAssetProfile>;
  slug: Scalars['String']['output'];
  /** Asset source metadata */
  source: AssetSource;
  status?: Maybe<SkillStatusEnum>;
  timeout?: Maybe<Scalars['Int']['output']>;
  /** Token counts for the current version */
  tokenCounts?: Maybe<AssetTokenCount>;
  type: AssetType;
  updatedAt: Scalars['DateTime']['output'];
  usageCount: Scalars['Int']['output'];
  versions: Array<VaultAssetVersion>;
  versionsCount: Scalars['Int']['output'];
};


export type HookFilesArgs = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type IgnoredIssuesNote = BaseNoteGqlType & {
  __typename?: 'IgnoredIssuesNote';
  count: Scalars['Int']['output'];
  msg: Scalars['String']['output'];
};

/** Import an external (non-managed) asset as a new managed asset. */
export type ImportAssetAsManagedMutation = {
  __typename?: 'ImportAssetAsManagedMutation';
  errors: Array<ErrorType>;
  /** GID of the newly created managed asset */
  newAssetGid?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImportAssetEvalsInput = {
  /** JSON string in Anthropic evals.json format */
  evalsJson: Scalars['String']['input'];
  skillGid: Scalars['ID']['input'];
};

export type ImportAssetEvalsMutation = {
  __typename?: 'ImportAssetEvalsMutation';
  errors: Array<ErrorType>;
  evals?: Maybe<Array<AssetEval>>;
  importedCount?: Maybe<Scalars['Int']['output']>;
};

export type ImportAuditEventInput = {
  /** Email of the original actor */
  actor?: InputMaybe<Scalars['String']['input']>;
  /** Event-specific payload */
  data?: InputMaybe<Scalars['JSONString']['input']>;
  /** Event name, stored verbatim (e.g. team.created) */
  event: Scalars['String']['input'];
  /** Target name/identifier */
  target?: InputMaybe<Scalars['String']['input']>;
  /** Target type, stored verbatim (e.g. team, asset) */
  targetType: Scalars['String']['input'];
  /** When the event occurred (original timestamp) */
  timestamp: Scalars['DateTime']['input'];
};

/**
 * Import historical audit events from another vault, verbatim.
 *
 * Preserves the original timestamp, actor (resolved by email within the org;
 * unresolved actors fall back to the caller with the original email kept in
 * data), event name, target type, and payload — so migrating a vault into
 * skills.new doesn't lose its audit trail.
 */
export type ImportAuditEventsMutation = {
  __typename?: 'ImportAuditEventsMutation';
  errors: Array<ErrorType>;
  importedCount: Scalars['Int']['output'];
};

/** Import an asset from a public catalog (skills.sh, Smithery, etc.). */
export type ImportFromCatalogMutation = {
  __typename?: 'ImportFromCatalogMutation';
  asset?: Maybe<VaultAsset>;
  errors: Array<ErrorType>;
};

export type ImproveEvalsInput = {
  skillGid: Scalars['ID']['input'];
};

export type ImproveEvalsMutation = {
  __typename?: 'ImproveEvalsMutation';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type InstallSkillToBotMutation = {
  __typename?: 'InstallSkillToBotMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

/** An asset in the installed assets response. */
export type InstalledAssetData = {
  __typename?: 'InstalledAssetData';
  assetType: Scalars['String']['output'];
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  evalImpact?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  installStatus?: Maybe<InstalledAssetInstallStatus>;
  installations: Array<InstalledAssetInstallation>;
  name: Scalars['String']['output'];
  originalPrompt?: Maybe<Scalars['String']['output']>;
  relevantInstallations: Array<InstalledAssetInstallation>;
  slug: Scalars['String']['output'];
  sourceType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tokenCounts?: Maybe<InstalledAssetTokenCounts>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usageCount: Scalars['Int']['output'];
};

/** Install status for a single asset. */
export type InstalledAssetInstallStatus = {
  __typename?: 'InstalledAssetInstallStatus';
  everInstalled: Scalars['Boolean']['output'];
  lastInstalledAt?: Maybe<Scalars['String']['output']>;
  lastInstalledVersion?: Maybe<Scalars['Int']['output']>;
  latestVersion: Scalars['Int']['output'];
  needsInstall: Scalars['Boolean']['output'];
  needsUpdate: Scalars['Boolean']['output'];
  versionsBehind: Scalars['Int']['output'];
};

/** Installation location for an installed asset. */
export type InstalledAssetInstallation = {
  __typename?: 'InstalledAssetInstallation';
  entityId?: Maybe<Scalars['String']['output']>;
  entityName: Scalars['String']['output'];
  entityProvider?: Maybe<Scalars['String']['output']>;
  entityType: VaultAssetInstallationEntityType;
  monoRepoConfigId?: Maybe<Scalars['String']['output']>;
  monoRepoConfigName?: Maybe<Scalars['String']['output']>;
};

/** Token counts for an installed asset's current version. */
export type InstalledAssetTokenCounts = {
  __typename?: 'InstalledAssetTokenCounts';
  claudeFrontmatterTokens?: Maybe<Scalars['Int']['output']>;
  claudeTokens?: Maybe<Scalars['Int']['output']>;
  estimatedFrontmatterTokens?: Maybe<Scalars['Int']['output']>;
  estimatedTokens: Scalars['Int']['output'];
  openaiFrontmatterTokens?: Maybe<Scalars['Int']['output']>;
  openaiTokens?: Maybe<Scalars['Int']['output']>;
};

/** Assets grouped by ownership type. */
export type InstalledAssetsByOwnership = {
  __typename?: 'InstalledAssetsByOwnership';
  botOwned: Array<InstalledAssetData>;
  organizationOwned: Array<InstalledAssetData>;
  profileOwned: Array<InstalledAssetData>;
  repositoryOwned: Array<InstalledAssetData>;
  teamOwnedViaMembership: Array<InstalledAssetData>;
  teamOwnedViaRepository: Array<InstalledAssetData>;
  userOwned: Array<InstalledAssetData>;
};

/** Response for installed assets query. */
export type InstalledAssetsResponse = {
  __typename?: 'InstalledAssetsResponse';
  assets: InstalledAssetsByOwnership;
  syncSummary?: Maybe<InstalledAssetsSyncSummary>;
};

/** Summary of install sync status across all assets. */
export type InstalledAssetsSyncSummary = {
  __typename?: 'InstalledAssetsSyncSummary';
  lastSyncAt?: Maybe<Scalars['String']['output']>;
  needsUpdate: Scalars['Int']['output'];
  notInstalled: Scalars['Int']['output'];
  totalAssets: Scalars['Int']['output'];
  upToDate: Scalars['Int']['output'];
};

export enum IntegrationAuthenticationConnectionType {
  /** Uses an API key to authenticate the integration */
  ApiKey = 'API_KEY',
  /** Uses a provider-specific app to authenticate the integration */
  App = 'APP',
  /** Users a SocialAuthUser to authenticate the integration */
  Oauth = 'OAUTH'
}

export type IntegrationAuthenticationType = {
  __typename?: 'IntegrationAuthenticationType';
  apiClientName?: Maybe<Scalars['String']['output']>;
  camouflagedApiSecondaryToken: Scalars['String']['output'];
  camouflagedApiToken: Scalars['String']['output'];
  canBeEdited: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  disconnectPath?: Maybe<Scalars['String']['output']>;
  extraHeaders?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  org: OrganizationType;
  provider: Scalars['String']['output'];
  readOnly: Scalars['Boolean']['output'];
  realm?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  /** Be careful when changing this. Some relationships are referenced by slugs as strings. */
  slug: Scalars['String']['output'];
  type: IntegrationAuthenticationConnectionType;
  url?: Maybe<Scalars['String']['output']>;
  userLabel?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export enum IntegrationProvider {
  /** Bitbucket */
  Bitbucket = 'BITBUCKET',
  /** Circleci */
  Circleci = 'CIRCLECI',
  /** Claude Code */
  ClaudeCode = 'CLAUDE_CODE',
  /** Cloudwatch */
  Cloudwatch = 'CLOUDWATCH',
  /** Custom Git */
  CustomGit = 'CUSTOM_GIT',
  /** Datadog */
  Datadog = 'DATADOG',
  /** Github */
  Github = 'GITHUB',
  /** Github Copilot */
  GithubCopilot = 'GITHUB_COPILOT',
  /** Incident Io */
  IncidentIo = 'INCIDENT_IO',
  /** Jira */
  Jira = 'JIRA',
  /** Jira Datacenter */
  JiraDatacenter = 'JIRA_DATACENTER',
  /** Linear */
  Linear = 'LINEAR',
  /** Newrelic */
  Newrelic = 'NEWRELIC',
  /** Opsgenie */
  Opsgenie = 'OPSGENIE',
  /** Pagerduty */
  Pagerduty = 'PAGERDUTY',
  /** Slack */
  Slack = 'SLACK',
  /** Sleuth Dora */
  SleuthDora = 'SLEUTH_DORA',
  /** Statuspage */
  Statuspage = 'STATUSPAGE',
  /** Zendesk */
  Zendesk = 'ZENDESK'
}

export type IntegrationProviderAuthType = {
  __typename?: 'IntegrationProviderAuthType';
  /** Is true if the integration provider supports multiple authentication connections. */
  isMulti: Scalars['Boolean']['output'];
  oauthPath?: Maybe<Scalars['String']['output']>;
  type: IntegrationAuthenticationConnectionType;
};

export type IntegrationProviderDefinitionType = {
  __typename?: 'IntegrationProviderDefinitionType';
  auth: IntegrationProviderAuthType;
  categories: Array<ProviderCategory>;
  connections: Array<IntegrationAuthenticationType>;
  integrationEnabled: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  provider: IntegrationProvider;
};

export type InvitationConnection = {
  __typename?: 'InvitationConnection';
  edges: Array<InvitationTypeEdge>;
  nodes: Array<InvitationType>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type InvitationType = Node & {
  __typename?: 'InvitationType';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitedBy: User;
  on: Scalars['DateTime']['output'];
};

export type InvitationTypeEdge = {
  __typename?: 'InvitationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: InvitationType;
};

export type InviteMemberInput = {
  email: Scalars['String']['input'];
  role?: Role;
};

export type InviteMemberMutation = {
  __typename?: 'InviteMemberMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum IssuesAssetInstallationRequestStatusChoices {
  /** Approved */
  Approved = 'APPROVED',
  /** Pending */
  Pending = 'PENDING',
  /** Rejected */
  Rejected = 'REJECTED'
}

/** An enumeration. */
export enum IssuesAssetInstallationRequestTargetTypeChoices {
  /** Organization */
  Organization = 'ORGANIZATION',
  /** Repository */
  Repository = 'REPOSITORY',
  /** Team */
  Team = 'TEAM'
}

/** An enumeration. */
export enum IssuesAssetPullRequestFileActionChoices {
  /** Add */
  Add = 'ADD',
  /** Delete */
  Delete = 'DELETE',
  /** Modify */
  Modify = 'MODIFY'
}

export type LinkExternalUserInputType = {
  externalUserIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type LinkExternalUserMutation = {
  __typename?: 'LinkExternalUserMutation';
  errors?: Maybe<Array<ErrorType>>;
  success: Scalars['Boolean']['output'];
};

export type LoginMethodInputType = {
  provider?: InputMaybe<SocialLoginProviderType>;
  type: AllowedLoginMethodType;
};

export type ManagedBot = {
  __typename?: 'ManagedBot';
  apiKeys: Array<BotApiKey>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  installedSkills: Array<BotInstalledSkill>;
  metaCreatedOn: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: BotsBotStatusChoices;
  teamMemberships: Array<BotTeamMembership>;
  teams: Array<Team>;
};

export type ManagedImportCandidate = {
  __typename?: 'ManagedImportCandidate';
  assetName: Scalars['String']['output'];
  assetType: AssetType;
  content: Scalars['String']['output'];
  contentHash: Scalars['String']['output'];
  files: Array<ManagedImportCandidateFile>;
  path: Scalars['String']['output'];
  repoId: Scalars['ID']['output'];
  repoName: Scalars['String']['output'];
  sourceClient: Scalars['String']['output'];
};

export type ManagedImportCandidateFile = {
  __typename?: 'ManagedImportCandidateFile';
  content: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
};

export type ManagedImportFileInput = {
  content: Scalars['String']['input'];
  name: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
};

export type ManagedImportItemInput = {
  assetType: AssetType;
  files: Array<ManagedImportFileInput>;
  name: Scalars['String']['input'];
  repositoryIds: Array<Scalars['ID']['input']>;
};

export type ManagedImportRunItem = {
  __typename?: 'ManagedImportRunItem';
  assetGid?: Maybe<Scalars['ID']['output']>;
  assetName: Scalars['String']['output'];
  assetType: AssetType;
  error?: Maybe<Scalars['String']['output']>;
  /** pending | done | error */
  status: Scalars['String']['output'];
};

export type ManagedImportRunStatus = {
  __typename?: 'ManagedImportRunStatus';
  isComplete: Scalars['Boolean']['output'];
  isRunning: Scalars['Boolean']['output'];
  items: Array<ManagedImportRunItem>;
};

export type ManagedImportScanStatus = {
  __typename?: 'ManagedImportScanStatus';
  candidates: Array<ManagedImportCandidate>;
  isComplete: Scalars['Boolean']['output'];
  isRunning: Scalars['Boolean']['output'];
};

export type ManagementSession = {
  __typename?: 'ManagementSession';
  eventCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type MarkOrgOnboardingCompleteMutation = {
  __typename?: 'MarkOrgOnboardingCompleteMutation';
  success: Scalars['Boolean']['output'];
};

export type MarkUserOnboardingCompleteMutation = {
  __typename?: 'MarkUserOnboardingCompleteMutation';
  success: Scalars['Boolean']['output'];
};

/** A tool available from an MCP integration. */
export type McpIntegrationTool = {
  __typename?: 'McpIntegrationTool';
  /** Tool description */
  description: Scalars['String']['output'];
  /** Approximate prompt token cost when this tool is included in a request */
  estimatedTokens?: Maybe<Scalars['Int']['output']>;
  /** Tool name */
  name: Scalars['String']['output'];
};

export type McpIntegrationToolEdge = {
  __typename?: 'McpIntegrationToolEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: McpIntegrationTool;
};

/** Paginated list of MCP integration tools. */
export type McpIntegrationToolsConnection = {
  __typename?: 'McpIntegrationToolsConnection';
  edges: Array<McpIntegrationToolEdge>;
  /** Discovered command arguments (stdio only) */
  mcpArgs?: Maybe<Array<Scalars['String']['output']>>;
  /** Discovered command to run the MCP server (stdio only) */
  mcpCommand?: Maybe<Scalars['String']['output']>;
  /** Discovered required environment variables */
  mcpEnv?: Maybe<Scalars['JSONString']['output']>;
  /** Discovered transport type: stdio, http, or sse */
  mcpTransport?: Maybe<Scalars['String']['output']>;
  /** Discovered server endpoint URL (http/sse only) */
  mcpUrl?: Maybe<Scalars['String']['output']>;
  nodes: Array<McpIntegrationTool>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Server instructions/description from the MCP initialize response */
  serverInstructions?: Maybe<Scalars['String']['output']>;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
  /** Total estimated tokens across all tools */
  totalEstimatedTokens?: Maybe<Scalars['Int']['output']>;
};

/** A provider and its upstream MCP server URL. */
export type McpProviderUrl = {
  __typename?: 'McpProviderUrl';
  provider: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type McpServer = VaultAsset & {
  __typename?: 'McpServer';
  /** Repository code contexts where this asset will execute */
  codeContexts: Array<AssetCodeContext>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** Whether an evaluation is currently in progress for this asset */
  evaluating: Scalars['Boolean']['output'];
  /** Files belonging to this asset */
  files: Array<SkillFile>;
  id: Scalars['ID']['output'];
  /** Pending installation requests for this asset visible to the current user */
  installationRequests: Array<AssetInstallationRequest>;
  installations: Array<VaultAssetInstallation>;
  integrationId?: Maybe<Scalars['String']['output']>;
  isChatDefault: Scalars['Boolean']['output'];
  latestVersion: Scalars['String']['output'];
  mcpArgs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mcpCommand?: Maybe<Scalars['String']['output']>;
  mcpEnv?: Maybe<Scalars['JSONString']['output']>;
  name: Scalars['String']['output'];
  /** Current user's permissions for this asset */
  permissions?: Maybe<VaultAssetPermissions>;
  profiles: Array<VaultAssetProfile>;
  secured?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  /** Asset source metadata */
  source: AssetSource;
  status?: Maybe<SkillStatusEnum>;
  timeout?: Maybe<Scalars['Int']['output']>;
  /** Token counts for the current version */
  tokenCounts?: Maybe<AssetTokenCount>;
  toolNames?: Maybe<Array<Maybe<McpToolEntry>>>;
  transport?: Maybe<Scalars['String']['output']>;
  type: AssetType;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  usageCount: Scalars['Int']['output'];
  versions: Array<VaultAssetVersion>;
  versionsCount: Scalars['Int']['output'];
};


export type McpServerFilesArgs = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type McpToolEntry = {
  __typename?: 'McpToolEntry';
  description?: Maybe<Scalars['String']['output']>;
  /** Approximate prompt token cost when this tool is included in a request */
  estimatedTokens?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type McpToolInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedTokens?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

/** Merge a pull request into a new skill version. */
export type MergeAssetPullRequestMutation = {
  __typename?: 'MergeAssetPullRequestMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type MessageType = {
  __typename?: 'MessageType';
  message: Scalars['String']['output'];
  type: MessageTypeEnum;
};

export enum MessageTypeEnum {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type ModifyAssetProfileAssetsInput = {
  /** List of asset GIDs to add/remove */
  assetGids: Array<Scalars['ID']['input']>;
  /** Profile GID */
  profileGid: Scalars['ID']['input'];
};

/** Output type for mono repo config mutations */
export type MonoRepoConfigOutputType = {
  __typename?: 'MonoRepoConfigOutputType';
  id?: Maybe<Scalars['ID']['output']>;
  issueProvider?: Maybe<Provider>;
  issueTeamKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  sourcePathPrefixExcludes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sourcePathPrefixIncludes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** GraphQL type for monorepo configuration */
export type MonoRepoConfigType = {
  __typename?: 'MonoRepoConfigType';
  id?: Maybe<Scalars['ID']['output']>;
  issueProvider?: Maybe<Provider>;
  issueTeamKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  sourcePathPrefixExcludes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sourcePathPrefixIncludes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  teamsUsing?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type MoveInput = {
  id: Scalars['ID']['input'];
  newPosition: Scalars['Int']['input'];
  newSectionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MoveSectionMutation = {
  __typename?: 'MoveSectionMutation';
  errors?: Maybe<Array<ErrorType>>;
  section?: Maybe<Section>;
};

export type MoveWidgetMutation = {
  __typename?: 'MoveWidgetMutation';
  errors?: Maybe<Array<ErrorType>>;
  widget?: Maybe<Widget>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Activate (rollback to) a specific skill version. */
  activateSkillVersion?: Maybe<ActivateSkillVersionMutation>;
  /** Add or update a file change in a pull request. */
  addAssetPullRequestFileChange?: Maybe<AddAssetPullRequestFileChangeMutation>;
  /** Add assets to a profile. */
  addAssetsToProfile?: Maybe<AddAssetsToProfileMutation>;
  addTeamsOrUsersToScope?: Maybe<AddTeamsOrUsersToScopeMutation>;
  addUsersToScope?: Maybe<AddUsersToScopeMutation>;
  applyOptimizedDescription?: Maybe<ApplyOptimizedDescriptionMutation>;
  approveDevice?: Maybe<ApproveDeviceMutation>;
  approveInstallationRequest?: Maybe<ApproveInstallationRequestMutation>;
  changeMemberRole?: Maybe<ChangeRoleMutation>;
  claimEmailDomain?: Maybe<ClaimEmailDomainMutation>;
  /** Clear an asset's chat history (event log) without affecting files. */
  clearAssetChat?: Maybe<ClearAssetChatMutation>;
  clearManagementSession?: Maybe<ClearManagementSessionMutation>;
  /** Close/reject a pull request without merging. */
  closeAssetPullRequest?: Maybe<CloseAssetPullRequestMutation>;
  /** Compare skill files with the source repository to see differences. */
  compareSkillWithRepository?: Maybe<CompareSkillWithRepositoryMutation>;
  /**
   * Kick off background import of confirmed candidates.
   *
   * Returns immediately. Frontend watches ``managedImportRunStatus`` (polling)
   * and ``MANAGED_IMPORT_ITEM_COMPLETED`` / ``MANAGED_IMPORT_RUN_COMPLETED``
   * WebSocket events for progress. The scan status in Redis is cleared so a
   * subsequent re-scan starts fresh.
   */
  confirmManagedImport?: Maybe<ConfirmManagedImportMutation>;
  /** Creates a new review that starts a new review chain. The new review will have no link to the blueprint review, except that all the widgets were copied over. */
  copyReview?: Maybe<CopyReviewMutation>;
  createAccessToken?: Maybe<CreateAccessTokenMutation>;
  createAsset?: Maybe<CreateAssetMutation>;
  createAssetEval?: Maybe<CreateAssetEvalMutation>;
  /** Create a new asset profile. */
  createAssetProfile?: Maybe<CreateAssetProfileMutation>;
  /** Create a new pull request for a skill. */
  createAssetPullRequest?: Maybe<CreateAssetPullRequestMutation>;
  createBitbucketIntegration?: Maybe<CreateBitbucketIntegrationMutationPayload>;
  createBitbucketPipelinesIntegration?: Maybe<CreateBitbucketPipelinesIntegrationMutationPayload>;
  createBot?: Maybe<CreateBotMutation>;
  createBotApiKey?: Maybe<CreateBotApiKeyMutation>;
  createBotRuntimeToken?: Maybe<CreateBotRuntimeTokenMutation>;
  createCircleciIntegration?: Maybe<CreateCircleCiIntegrationMutationPayload>;
  createClubhouseIntegration?: Maybe<CreateClubhouseIntegrationMutationPayload>;
  createComment?: Maybe<CreateCommentMutation>;
  createDatadogIntegration?: Maybe<CreateDdIntegrationMutationPayload>;
  createGithubEnterpriseIntegration?: Maybe<CreateGithubEnterpriseIntegrationMutationPayload>;
  createGitlabIntegration?: Maybe<CreateGitlabIntegrationMutationPayload>;
  createInstallationRequest?: Maybe<CreateInstallationRequestMutation>;
  createIntegration?: Maybe<CreateIntegrationMutationPayload>;
  createJenkinsIntegration?: Maybe<CreateJenkinsIntegrationMutationPayload>;
  createJiraDatacenterIntegration?: Maybe<CreateJiraDatacenterIntegrationMutationPayload>;
  createLegacyIntegration?: Maybe<CreateLegacyIntegrationMutationPayload>;
  createMonoRepoConfig?: Maybe<CreateMonoRepoConfigMutation>;
  createNotification?: Maybe<CreateNotificationMutation>;
  createPersonalToken?: Maybe<CreatePersonalTokenMutation>;
  createReview?: Maybe<CreateReviewMutation>;
  createSection?: Maybe<CreateSectionMutation>;
  /** Create a new file on an asset and seed it with an initial content version. */
  createSkillFile?: Maybe<CreateSkillFileMutation>;
  createTeam?: Maybe<CreateTeamMutation>;
  createWidget?: Maybe<CreateWidgetMutation>;
  createWorkspace?: Maybe<CreateWorkspaceMutation>;
  customizeAssessment?: Maybe<CustomizeAssessmentMutation>;
  deleteAccessToken?: Maybe<DeleteAccessTokenMutation>;
  deleteAsset?: Maybe<DeleteAssetMutation>;
  deleteAssetEval?: Maybe<DeleteAssetEvalMutation>;
  /** Delete an asset profile. */
  deleteAssetProfile?: Maybe<DeleteAssetProfileMutation>;
  deleteBot?: Maybe<DeleteBotMutation>;
  deleteBotApiKey?: Maybe<DeleteBotApiKeyMutation>;
  deleteBulkUserWorkingHours?: Maybe<DeleteBulkUserWorkingHoursMutation>;
  deleteComment?: Maybe<DeleteCommentMutation>;
  deleteCurrentUserWorkingHours?: Maybe<DeleteCurrentUserWorkingHoursMutation>;
  deleteIntegrationAuthentication?: Maybe<DeleteIntegrationAuthenticationMutationPayload>;
  deleteMember?: Maybe<DeleteMemberMutation>;
  deleteMonoRepoConfig?: Maybe<DeleteMonoRepoConfigMutation>;
  deleteNotification?: Maybe<DeleteNotificationMutation>;
  deleteOrganizationWorkingHours?: Maybe<DeleteOrganizationWorkingHoursMutation>;
  deletePersonalToken?: Maybe<DeletePersonalTokenMutation>;
  deleteReview?: Maybe<DeleteReviewMutation>;
  deleteReviewChain?: Maybe<DeleteReviewChainMutation>;
  deleteSection?: Maybe<DeleteSectionMutation>;
  /** Delete a file from an asset, creating a new asset version without it. */
  deleteSkillFile?: Maybe<DeleteSkillFileMutation>;
  deleteTeam?: Maybe<DeleteTeamMutation>;
  deleteWidget?: Maybe<DeleteWidgetMutation>;
  deleteWorkspace?: Maybe<DeleteWorkspaceMutation>;
  editComment?: Maybe<EditCommentMutation>;
  /** Evaluate an asset's quality, actionability, and completeness. */
  evaluateAsset?: Maybe<EvaluateAssetMutation>;
  exportAssetEvals?: Maybe<ExportAssetEvalsMutation>;
  favoriteWorkspace?: Maybe<FavoriteWorkspaceMutation>;
  generateAssessment?: Maybe<GenerateAssessmentMutation>;
  /** Generate more skill suggestions for a repository without deleting existing ones. */
  generateMoreRepositorySuggestions?: Maybe<GenerateMoreRepositorySuggestionsMutation>;
  /** Generate a unified diff patch for skill changes to download. */
  generateSkillPatch?: Maybe<GenerateSkillPatchMutation>;
  /** Import an external (non-managed) asset as a new managed asset. */
  importAssetAsManaged?: Maybe<ImportAssetAsManagedMutation>;
  importAssetEvals?: Maybe<ImportAssetEvalsMutation>;
  /**
   * Import historical audit events from another vault, verbatim.
   *
   * Preserves the original timestamp, actor (resolved by email within the org;
   * unresolved actors fall back to the caller with the original email kept in
   * data), event name, target type, and payload — so migrating a vault into
   * skills.new doesn't lose its audit trail.
   */
  importAuditEvents?: Maybe<ImportAuditEventsMutation>;
  /** Import an asset from a public catalog (skills.sh, Smithery, etc.). */
  importFromCatalog?: Maybe<ImportFromCatalogMutation>;
  improveEvals?: Maybe<ImproveEvalsMutation>;
  installSkillToBot?: Maybe<InstallSkillToBotMutation>;
  inviteMember?: Maybe<InviteMemberMutation>;
  linkExternalUsers?: Maybe<LinkExternalUserMutation>;
  markOrgOnboardingComplete?: Maybe<MarkOrgOnboardingCompleteMutation>;
  markSeen?: Maybe<SeenEventType>;
  markUserOnboardingComplete?: Maybe<MarkUserOnboardingCompleteMutation>;
  /** Merge a pull request into a new skill version. */
  mergeAssetPullRequest?: Maybe<MergeAssetPullRequestMutation>;
  moveSection?: Maybe<MoveSectionMutation>;
  moveWidget?: Maybe<MoveWidgetMutation>;
  refreshGitAsset?: Maybe<RefreshGitAssetMutation>;
  /** Wipe a managed asset's files, evals, and chat history, then start a fresh orchestration run. */
  regenerateAsset?: Maybe<RegenerateAssetMutation>;
  regenerateEvals?: Maybe<RegenerateEvalsMutation>;
  /** Re-initialize skill discovery for a repository, deleting existing suggestions. */
  reinitializeRepositoryDiscovery?: Maybe<ReinitializeRepositoryDiscoveryMutation>;
  rejectInstallationRequest?: Maybe<RejectInstallationRequestMutation>;
  removeAssetInstallations?: Maybe<RemoveAssetInstallationsMutation>;
  /** Remove assets from a profile. */
  removeAssetsFromProfile?: Maybe<RemoveAssetsFromProfileMutation>;
  removeTeamMember?: Maybe<RemoveTeamMemberMutation>;
  removeTeamsOrUsersFromScope?: Maybe<RemoveTeamsOrUsersFromScopeMutation>;
  removeUsersFromScope?: Maybe<RemoveUsersFromScopeMutation>;
  renameAsset?: Maybe<RenameAssetMutation>;
  /** Create a new review in this chain of reviews. The new review will link to the previous review and the previous review will link to the new review. */
  repeatReview?: Maybe<RepeatReviewMutation>;
  resendEmailConfirmation?: Maybe<ResendEmailConfirmationMutation>;
  resendInvitation?: Maybe<ResendInvitationMutationPayload>;
  retractInstallationRequest?: Maybe<RetractInstallationRequestMutation>;
  revokeBotRuntimeTokens?: Maybe<RevokeBotRuntimeTokensMutation>;
  revokeInvitation?: Maybe<RevokeInvitationMutationPayload>;
  runEvalBenchmark?: Maybe<RunEvalBenchmarkMutation>;
  /** Save a new version of a file, creating a new asset version with the updated content. */
  saveSkillFileVersion?: Maybe<SaveSkillFileVersionMutation>;
  /** Set or clear the active skill profile for the current user. */
  setActiveSkillProfile?: Maybe<SetActiveSkillProfileMutation>;
  setAssetInstallations?: Maybe<SetAssetInstallationsMutation>;
  /** Set an asset's status to a specific value (draft, published, or rejected). */
  setAssetStatus?: Maybe<SetAssetStatusMutation>;
  setBulkUserWorkingHours?: Maybe<SetBulkUserWorkingHoursMutation>;
  setCurrentUserWorkingHours?: Maybe<SetCurrentUserWorkingHoursMutation>;
  setDeveloperSalary?: Maybe<SetDeveloperSalaryMutation>;
  /** NOTE: If the list of filters is empty, we will return `workPlanning: null`. */
  setNamedWorkCategory?: Maybe<SetNamedWorkCategoryMutation>;
  /** NOTE: If the list of filters is empty, we will return `workPlanning: null`. */
  setNamedWorkPlanning?: Maybe<SetNamedWorkPlanningMutation>;
  setOrganizationWorkingHours?: Maybe<SetOrganizationWorkingHoursMutation>;
  setReviewStatus?: Maybe<SetReviewStatusMutation>;
  setSectionStatus?: Maybe<SetSectionStatusMutation>;
  setTeamAdmin?: Maybe<SetTeamAdminMutation>;
  setTeamsSyncStatus?: Maybe<TeamsSyncStatusMutation>;
  toggleAssetStatus?: Maybe<ToggleAssetStatusMutation>;
  toggleLLMFeatures?: Maybe<ToggleLlmFeaturesMutation>;
  trackView?: Maybe<TrackViewMutation>;
  triggerDescriptionOptimization?: Maybe<TriggerDescriptionOptimizationMutation>;
  /**
   * Start a managed-import scan over the user-selected repositories.
   *
   * Resets prior scan state, queues one celery task per repo, and returns
   * immediately. Frontend reads progress from ``managedImportScanStatus`` and
   * listens to ``MANAGED_IMPORT_CANDIDATE_FOUND`` / ``MANAGED_IMPORT_SCAN_COMPLETED``
   * websocket events.
   */
  triggerManagedImportScan?: Maybe<TriggerManagedImportScanMutation>;
  /**
   * Kick off a background LLM-driven smart merge.
   *
   * Returns a ``merge_id`` immediately. The actual LLM call runs in a celery
   * task; the frontend polls ``smartMergeStatus(mergeId)`` for the result.
   * A single LLM call can take well over the 60s GraphQL request timeout, so
   * keeping this mutation synchronous would unavoidably stall the wizard.
   */
  triggerSmartMerge?: Maybe<TriggerSmartMergeMutation>;
  triggerTeamsSync?: Maybe<TriggerTeamsSyncMutation>;
  unfavoriteWorkspace?: Maybe<UnfavoriteWorkspaceMutation>;
  /** Remove a single installation from an asset (does not delete the asset). */
  uninstallAsset?: Maybe<UninstallAssetMutation>;
  uninstallSkillFromBot?: Maybe<UninstallSkillFromBotMutation>;
  unlinkExternalUsers?: Maybe<UnlinkExternalUserMutation>;
  updateAsset?: Maybe<UpdateAssetMutation>;
  updateAssetEval?: Maybe<UpdateAssetEvalMutation>;
  /** Update an existing asset profile. */
  updateAssetProfile?: Maybe<UpdateAssetProfileMutation>;
  updateBot?: Maybe<UpdateBotMutation>;
  /** Trigger an update of a catalog-sourced asset from upstream. */
  updateFromCatalog?: Maybe<UpdateFromCatalogMutation>;
  updateIntegration?: Maybe<UpdateIntegrationMutationPayload>;
  updateMonoRepoConfig?: Maybe<UpdateMonoRepoConfigMutation>;
  updateOrganization?: Maybe<UpdateOrganizationMutation>;
  updateReview?: Maybe<UpdateReviewMutation>;
  updateSection?: Maybe<UpdateSectionMutation>;
  updateSkillsSettings?: Maybe<UpdateSkillsSettingsMutation>;
  /** Update the status of a suggested skill (reject or unreject). */
  updateSuggestedSkillStatus?: Maybe<UpdateSuggestedSkillStatusMutation>;
  updateTeam?: Maybe<UpdateTeamMutation>;
  updateUser?: Maybe<UpdateUserMutation>;
  updateWidget?: Maybe<UpdateWidgetMutation>;
  updateWorkspace?: Maybe<UpdateWorkspaceMutation>;
  upload?: Maybe<UploadMutation>;
  validateDeviceCode?: Maybe<ValidateDeviceCodeMutation>;
};


export type MutationActivateSkillVersionArgs = {
  assetId: Scalars['ID']['input'];
  versionNumber: Scalars['Int']['input'];
};


export type MutationAddAssetPullRequestFileChangeArgs = {
  input: AddAssetPullRequestFileChangeInput;
};


export type MutationAddAssetsToProfileArgs = {
  input: ModifyAssetProfileAssetsInput;
};


export type MutationAddTeamsOrUsersToScopeArgs = {
  input: AddTeamsOrUsersToScopeMutationInput;
};


export type MutationAddUsersToScopeArgs = {
  input: AddUsersToScopeMutationInput;
};


export type MutationApplyOptimizedDescriptionArgs = {
  input: ApplyOptimizedDescriptionInput;
};


export type MutationApproveDeviceArgs = {
  approve: Scalars['Boolean']['input'];
  botGid?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  userCode: Scalars['String']['input'];
};


export type MutationApproveInstallationRequestArgs = {
  input: ReviewInstallationRequestInput;
};


export type MutationChangeMemberRoleArgs = {
  input: ChangeRoleMutationInput;
};


export type MutationClaimEmailDomainArgs = {
  enable: Scalars['Boolean']['input'];
  orgSlug: Scalars['ID']['input'];
};


export type MutationClearAssetChatArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCloseAssetPullRequestArgs = {
  pullRequestId: Scalars['ID']['input'];
};


export type MutationCompareSkillWithRepositoryArgs = {
  skillId: Scalars['ID']['input'];
};


export type MutationConfirmManagedImportArgs = {
  items: Array<ManagedImportItemInput>;
};


export type MutationCopyReviewArgs = {
  input: CopyReviewInput;
};


export type MutationCreateAccessTokenArgs = {
  input: CreateAccessTokenInputType;
};


export type MutationCreateAssetArgs = {
  input: CreateAssetInput;
};


export type MutationCreateAssetEvalArgs = {
  input: CreateAssetEvalInput;
};


export type MutationCreateAssetProfileArgs = {
  input: CreateAssetProfileInput;
};


export type MutationCreateAssetPullRequestArgs = {
  input: CreateAssetPullRequestInput;
};


export type MutationCreateBitbucketIntegrationArgs = {
  input: CreateBitbucketIntegrationMutationInput;
};


export type MutationCreateBitbucketPipelinesIntegrationArgs = {
  input: CreateBitbucketPipelinesIntegrationMutationInput;
};


export type MutationCreateBotArgs = {
  input: CreateBotInput;
};


export type MutationCreateBotApiKeyArgs = {
  botId: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};


export type MutationCreateBotRuntimeTokenArgs = {
  botId: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  ttlSeconds?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateCircleciIntegrationArgs = {
  input: CreateCircleCiIntegrationMutationInput;
};


export type MutationCreateClubhouseIntegrationArgs = {
  input: CreateClubhouseIntegrationMutationInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateDatadogIntegrationArgs = {
  input: CreateDdIntegrationMutationInput;
};


export type MutationCreateGithubEnterpriseIntegrationArgs = {
  input: CreateGithubEnterpriseIntegrationMutationInput;
};


export type MutationCreateGitlabIntegrationArgs = {
  input: CreateGitlabIntegrationMutationInput;
};


export type MutationCreateInstallationRequestArgs = {
  input: CreateInstallationRequestInput;
};


export type MutationCreateIntegrationArgs = {
  input: CreateIntegrationMutationInput;
};


export type MutationCreateJenkinsIntegrationArgs = {
  input: CreateJenkinsIntegrationMutationInput;
};


export type MutationCreateJiraDatacenterIntegrationArgs = {
  input: CreateJiraDatacenterIntegrationMutationInput;
};


export type MutationCreateLegacyIntegrationArgs = {
  input: CreateLegacyIntegrationMutationInput;
};


export type MutationCreateMonoRepoConfigArgs = {
  input: CreateMonoRepoConfigInput;
};


export type MutationCreateNotificationArgs = {
  input: CreateNotificationInput;
};


export type MutationCreatePersonalTokenArgs = {
  label: Scalars['String']['input'];
};


export type MutationCreateReviewArgs = {
  input: CreateReviewInput;
};


export type MutationCreateSectionArgs = {
  input: CreateSectionInput;
};


export type MutationCreateSkillFileArgs = {
  input: CreateSkillFileInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateWidgetArgs = {
  input: CreateWidgetInput;
};


export type MutationCreateWorkspaceArgs = {
  input: CreateWorkspaceMutationInput;
};


export type MutationCustomizeAssessmentArgs = {
  input: AssessmentMutationInput;
};


export type MutationDeleteAccessTokenArgs = {
  input: DeleteAccessTokenInputType;
};


export type MutationDeleteAssetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAssetEvalArgs = {
  input: DeleteAssetEvalInput;
};


export type MutationDeleteAssetProfileArgs = {
  input: DeleteAssetProfileInput;
};


export type MutationDeleteBotArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBotApiKeyArgs = {
  keyId: Scalars['ID']['input'];
};


export type MutationDeleteBulkUserWorkingHoursArgs = {
  input: BatchWorkingHoursDeleteInputType;
};


export type MutationDeleteCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIntegrationAuthenticationArgs = {
  input: DeleteIntegrationAuthenticationMutationInput;
};


export type MutationDeleteMemberArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDeleteMonoRepoConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePersonalTokenArgs = {
  tokenId: Scalars['ID']['input'];
};


export type MutationDeleteReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReviewChainArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSkillFileArgs = {
  assetId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
};


export type MutationDeleteTeamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEditCommentArgs = {
  input: EditCommentInput;
};


export type MutationEvaluateAssetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExportAssetEvalsArgs = {
  input: ExportAssetEvalsInput;
};


export type MutationFavoriteWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateMoreRepositorySuggestionsArgs = {
  repositoryGid: Scalars['String']['input'];
};


export type MutationGenerateSkillPatchArgs = {
  input: GenerateSkillPatchInput;
};


export type MutationImportAssetAsManagedArgs = {
  assetId: Scalars['ID']['input'];
};


export type MutationImportAssetEvalsArgs = {
  input: ImportAssetEvalsInput;
};


export type MutationImportAuditEventsArgs = {
  events: Array<ImportAuditEventInput>;
};


export type MutationImportFromCatalogArgs = {
  installations?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  source: Scalars['String']['input'];
};


export type MutationImproveEvalsArgs = {
  input: ImproveEvalsInput;
};


export type MutationInstallSkillToBotArgs = {
  botId: Scalars['ID']['input'];
  skillId: Scalars['ID']['input'];
};


export type MutationInviteMemberArgs = {
  input: InviteMemberInput;
};


export type MutationLinkExternalUsersArgs = {
  input: LinkExternalUserInputType;
};


export type MutationMarkSeenArgs = {
  name: Scalars['String']['input'];
  orgSlug?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationMergeAssetPullRequestArgs = {
  pullRequestId: Scalars['ID']['input'];
};


export type MutationMoveSectionArgs = {
  input: MoveInput;
};


export type MutationMoveWidgetArgs = {
  input: MoveInput;
};


export type MutationRefreshGitAssetArgs = {
  assetId: Scalars['ID']['input'];
};


export type MutationRegenerateAssetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRegenerateEvalsArgs = {
  input: RegenerateEvalsInput;
};


export type MutationReinitializeRepositoryDiscoveryArgs = {
  repositoryGid: Scalars['String']['input'];
};


export type MutationRejectInstallationRequestArgs = {
  input: ReviewInstallationRequestInput;
};


export type MutationRemoveAssetInstallationsArgs = {
  input: RemoveAssetInstallationsInput;
};


export type MutationRemoveAssetsFromProfileArgs = {
  input: ModifyAssetProfileAssetsInput;
};


export type MutationRemoveTeamMemberArgs = {
  input: RemoveTeamMemberInput;
};


export type MutationRemoveTeamsOrUsersFromScopeArgs = {
  input: RemoveTeamsOrUsersFromScopeMutationInput;
};


export type MutationRemoveUsersFromScopeArgs = {
  input: RemoveUsersFromScopeMutationInput;
};


export type MutationRenameAssetArgs = {
  input: RenameAssetInput;
};


export type MutationRepeatReviewArgs = {
  input: RepeatReviewInput;
};


export type MutationResendInvitationArgs = {
  input: ResendInvitationMutationInput;
};


export type MutationRetractInstallationRequestArgs = {
  requestId: Scalars['ID']['input'];
};


export type MutationRevokeBotRuntimeTokensArgs = {
  botId: Scalars['ID']['input'];
};


export type MutationRevokeInvitationArgs = {
  input: RevokeInvitationMutationInput;
};


export type MutationRunEvalBenchmarkArgs = {
  input: RunEvalBenchmarkInput;
};


export type MutationSaveSkillFileVersionArgs = {
  input: SaveSkillFileVersionInput;
};


export type MutationSetActiveSkillProfileArgs = {
  skillProfileId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetAssetInstallationsArgs = {
  input: SetAssetInstallationsInput;
};


export type MutationSetAssetStatusArgs = {
  id: Scalars['ID']['input'];
  status: SkillStatusEnum;
};


export type MutationSetBulkUserWorkingHoursArgs = {
  input: BatchWorkingHoursInputType;
};


export type MutationSetCurrentUserWorkingHoursArgs = {
  input: WorkingHoursInputType;
};


export type MutationSetDeveloperSalaryArgs = {
  input: DeveloperSalaryInputType;
};


export type MutationSetNamedWorkCategoryArgs = {
  input: NamedWorkCategoryInputType;
};


export type MutationSetNamedWorkPlanningArgs = {
  input: NamedWorkPlanningInputType;
};


export type MutationSetOrganizationWorkingHoursArgs = {
  input: WorkingHoursInputType;
};


export type MutationSetReviewStatusArgs = {
  input: SetReviewStatusInput;
};


export type MutationSetSectionStatusArgs = {
  input: SetSectionStatusInput;
};


export type MutationSetTeamAdminArgs = {
  input: SetTeamAdminInput;
};


export type MutationSetTeamsSyncStatusArgs = {
  input: TeamsSyncInputType;
};


export type MutationToggleAssetStatusArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleLlmFeaturesArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationTrackViewArgs = {
  targetId: Scalars['ID']['input'];
  targetType: ViewTargetType;
};


export type MutationTriggerDescriptionOptimizationArgs = {
  input: TriggerDescriptionOptimizationInput;
};


export type MutationTriggerManagedImportScanArgs = {
  repositoryIds: Array<Scalars['ID']['input']>;
};


export type MutationTriggerSmartMergeArgs = {
  assetName: Scalars['String']['input'];
  assetType: AssetType;
  variants: Array<SmartMergeVariantInput>;
};


export type MutationTriggerTeamsSyncArgs = {
  input: TriggerTeamsSyncInputType;
};


export type MutationUnfavoriteWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUninstallAssetArgs = {
  input: UninstallAssetInput;
};


export type MutationUninstallSkillFromBotArgs = {
  botId: Scalars['ID']['input'];
  skillId: Scalars['ID']['input'];
};


export type MutationUnlinkExternalUsersArgs = {
  input: LinkExternalUserInputType;
};


export type MutationUpdateAssetArgs = {
  input: UpdateAssetInput;
};


export type MutationUpdateAssetEvalArgs = {
  input: UpdateAssetEvalInput;
};


export type MutationUpdateAssetProfileArgs = {
  input: UpdateAssetProfileInput;
};


export type MutationUpdateBotArgs = {
  input: UpdateBotInput;
};


export type MutationUpdateFromCatalogArgs = {
  assetGid: Scalars['ID']['input'];
};


export type MutationUpdateIntegrationArgs = {
  input: UpdateIntegrationMutationInput;
};


export type MutationUpdateMonoRepoConfigArgs = {
  input: UpdateMonoRepoConfigInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInputType;
};


export type MutationUpdateReviewArgs = {
  input: UpdateReviewInput;
};


export type MutationUpdateSectionArgs = {
  input: UpdateSectionInput;
};


export type MutationUpdateSkillsSettingsArgs = {
  input: UpdateSkillsSettingsInput;
};


export type MutationUpdateSuggestedSkillStatusArgs = {
  id: Scalars['ID']['input'];
  status: SuggestedSkillStatusEnum;
};


export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationUpdateUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateWidgetArgs = {
  input: UpdateWidgetInput;
};


export type MutationUpdateWorkspaceArgs = {
  input: UpdateWorkspaceMutationInput;
};


export type MutationUploadArgs = {
  files: Array<Scalars['Upload']['input']>;
};


export type MutationValidateDeviceCodeArgs = {
  userCode: Scalars['String']['input'];
};

export type MyAssetCapabilities = {
  __typename?: 'MyAssetCapabilities';
  canCreate: Scalars['Boolean']['output'];
  canInstallOrg: Scalars['Boolean']['output'];
  canInstallRepoAny: Scalars['Boolean']['output'];
  canInstallSelf: Scalars['Boolean']['output'];
  canPublishAny: Scalars['Boolean']['output'];
  isReadOnly: Scalars['Boolean']['output'];
  /** Org role name (ADMIN, ASSET_MANAGER, DEV, MEMBER, BILLING) */
  role?: Maybe<Scalars['String']['output']>;
  teamAdminOf: Array<TeamAdminScope>;
};

export type NameAndSlugSearchOptionType = {
  __typename?: 'NameAndSlugSearchOptionType';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export enum NamedBucketOptions {
  /** Work Category */
  WorkCategory = 'WORK_CATEGORY',
  /** Work Type */
  WorkType = 'WORK_TYPE'
}

export type NamedWorkCategoryGqlType = {
  __typename?: 'NamedWorkCategoryGqlType';
  bucketKey: Scalars['NamedWorkCategory']['output'];
  id: Scalars['String']['output'];
  pql: Scalars['String']['output'];
  pqlFilters: Array<PqlFilter>;
  workspace: Workspace;
};

export type NamedWorkCategoryInputType = {
  bucketKey: Scalars['NamedWorkCategory']['input'];
  pqlFilterGroups: Array<PqlFilterGroupsGqlInput>;
  workspaceId: Scalars['ID']['input'];
};

export enum NamedWorkCategoryType {
  /** Bugs */
  Bugs = 'BUGS',
  /** DevEx and Internal Improvements */
  Devex = 'DEVEX',
  /** Feature and Enhancements */
  Feature = 'FEATURE',
  /** Keep The Lights On */
  Ktlo = 'KTLO',
  /** Support */
  Support = 'SUPPORT',
  /** Tech Debt */
  TechDebt = 'TECH_DEBT'
}

export type NamedWorkPlanningGqlType = {
  __typename?: 'NamedWorkPlanningGqlType';
  bucketKey: NamedWorkPlanningType;
  id: Scalars['String']['output'];
  pql: Scalars['String']['output'];
  pqlFilters: Array<PqlFilter>;
  workspace: Workspace;
};

export type NamedWorkPlanningInputType = {
  bucketKey: NamedWorkPlanningType;
  id?: InputMaybe<Scalars['ID']['input']>;
  pqlFilterGroups: Array<PqlFilterGroupsGqlInput>;
  workspaceId: Scalars['ID']['input'];
};

export enum NamedWorkPlanningType {
  /** Planned Work */
  PlannedWork = 'PLANNED_WORK',
  /** Unplanned Work */
  UnplannedWork = 'UNPLANNED_WORK'
}

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type Note = BaseNoteGqlType & {
  __typename?: 'Note';
  msg: Scalars['String']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  createdOn: Scalars['DateTime']['output'];
  event: NotificationEvent;
  id: Scalars['ID']['output'];
  integrationAuth?: Maybe<IntegrationAuthenticationType>;
  modifiedOn: Scalars['DateTime']['output'];
  provider: NotificationProviderType;
  recipient?: Maybe<User>;
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges: Array<NotificationEdge>;
  nodes: Array<Notification>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Notification;
};

export enum NotificationEvent {
  /** All Sections Submitted */
  AllSectionsSubmitted = 'ALL_SECTIONS_SUBMITTED',
  /** User Mention */
  AtMention = 'AT_MENTION',
  /** Review Due Date Changed */
  ReviewDueDateChanged = 'REVIEW_DUE_DATE_CHANGED',
  /** Review Overdue */
  ReviewOverdue = 'REVIEW_OVERDUE',
  /** Review Published */
  ReviewPublished = 'REVIEW_PUBLISHED',
  /** Review Scope Changed */
  ReviewScopeChanged = 'REVIEW_SCOPE_CHANGED',
  /** Review Stopped */
  ReviewStopped = 'REVIEW_STOPPED',
  /** Section Approved */
  SectionApproved = 'SECTION_APPROVED',
  /** Section Assigned */
  SectionAssigned = 'SECTION_ASSIGNED',
  /** Section Commented On */
  SectionCommentedOn = 'SECTION_COMMENTED_ON',
  /** Section Deleted */
  SectionDeleted = 'SECTION_DELETED',
  /** Section Due Soon */
  SectionDueSoon = 'SECTION_DUE_SOON',
  /** Section Rejected */
  SectionRejected = 'SECTION_REJECTED',
  /** Section Submitted */
  SectionSubmitted = 'SECTION_SUBMITTED',
  /** Section Unassigned */
  SectionUnassigned = 'SECTION_UNASSIGNED',
  /** Your Review Section Changed */
  YourReviewSectionChanged = 'YOUR_REVIEW_SECTION_CHANGED',
  /** Your Review State Changed */
  YourReviewStateChanged = 'YOUR_REVIEW_STATE_CHANGED',
  /** Your Section Submitted */
  YourSectionSubmitted = 'YOUR_SECTION_SUBMITTED'
}

export enum NotificationProviderType {
  /** Email */
  Email = 'EMAIL',
  /** Slack */
  Slack = 'SLACK'
}

export type NumberWidgetValue = WidgetValue & {
  __typename?: 'NumberWidgetValue';
  exportLinks: Array<Maybe<ExportLink>>;
  legend?: Maybe<WidgetLegend>;
  notes?: Maybe<Array<BaseNoteGqlType>>;
  number?: Maybe<Scalars['Float']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  type: WidgetValueFormat;
  unit: Unit;
};

export enum OAuthScopeType {
  All = 'ALL',
  /** Register deploy */
  RegisterDeploy = 'REGISTER_DEPLOY'
}

export type OrgAllowedLoginMethodType = {
  __typename?: 'OrgAllowedLoginMethodType';
  enabled: Scalars['Boolean']['output'];
  provider?: Maybe<SocialLoginProviderType>;
  type: AllowedLoginMethodType;
};

export type OrganizationType = TeamOrUsersScoped & {
  __typename?: 'OrganizationType';
  accessTokens: AccessTokenConnection;
  addressCity?: Maybe<Scalars['String']['output']>;
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressPostalCode?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  allowedLoginMethods: Array<OrgAllowedLoginMethodType>;
  /** @deprecated Use `accessTokens` field instead. */
  apiKey: Scalars['String']['output'];
  bots: Array<ManagedBot>;
  /** Default role to assign to users signing up with SSO. Only supports MEMBER, DEV and ADMIN. */
  defaultRole: Role;
  description: Scalars['String']['output'];
  developerSalaries: Array<DeveloperSalaryType>;
  emailDomain?: Maybe<Scalars['String']['output']>;
  externalUsers: ExternalUsersConnection;
  flagEnabled: Scalars['Boolean']['output'];
  /** URL to the organization's icon */
  iconUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  llmFeaturesEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orgOnboardingCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  owner?: Maybe<User>;
  pendingInvites: InvitationConnection;
  planType: PlanType;
  repositories: RepositoryConnection;
  skillsDashboard?: Maybe<Dashboard>;
  skillsDashboards: Array<Dashboard>;
  skillsSettings: SkillsSettings;
  slug: Scalars['String']['output'];
  team: Team;
  teams: TeamsConnection;
  teamsOrUsers: TeamOrUsersConnection;
  teamsSyncStatuses: Array<TeamsSyncStatusType>;
  timezone?: Maybe<Scalars['String']['output']>;
  trialDaysRemaining: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  users: UserConnection;
  /** EXPERIMENTAL FIELD, can change at any time. */
  workingHours?: Maybe<WorkingHoursType>;
};


export type OrganizationTypeAccessTokensArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationTypeExternalUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeLinked?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationTypeFlagEnabledArgs = {
  flagName: Scalars['String']['input'];
};


export type OrganizationTypePendingInvitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationTypeRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alwaysIncludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<IntegrationProvider>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationTypeTeamArgs = {
  id: Scalars['ID']['input'];
};


export type OrganizationTypeTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alwaysIncludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  childless?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  parent?: InputMaybe<TeamParentInputType>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationTypeTeamsOrUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationTypeUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alwaysIncludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeTeamSlug?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
  userRole?: InputMaybe<Role>;
  userType?: InputMaybe<UsersType>;
};

/** Single filter for use in PQL queries. */
export type PqlFilter = {
  __typename?: 'PQLFilter';
  operator: Scalars['PQLOperator']['output'];
  tagName: Scalars['String']['output'];
  tagValue: Scalars['PQLFieldValue']['output'];
};

export type PqlFilterGroupsGqlInput = {
  pqlFilters: Array<PqlFilterInput>;
};

/** Single filter for use in PQL queries. */
export type PqlFilterInput = {
  operator: Scalars['PQLOperator']['input'];
  tagName: Scalars['String']['input'];
  tagValue: Scalars['PQLFieldValue']['input'];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ParameterValueOptionConnection = {
  __typename?: 'ParameterValueOptionConnection';
  edges: Array<ParameterValueOptionTypeEdge>;
  nodes: Array<ParameterValueOptionType>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type ParameterValueOptionType = {
  __typename?: 'ParameterValueOptionType';
  label: Scalars['String']['output'];
  /** This field holds additional metadata for the option. It is different for different parameter types. */
  meta?: Maybe<Scalars['JSONString']['output']>;
  pqlFragmentName?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type ParameterValueOptionTypeEdge = {
  __typename?: 'ParameterValueOptionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ParameterValueOptionType;
};

export type PercentageCategoriesWidgetValue = WidgetValue & {
  __typename?: 'PercentageCategoriesWidgetValue';
  exportLinks: Array<Maybe<ExportLink>>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  legend?: Maybe<WidgetLegend>;
  notes?: Maybe<Array<BaseNoteGqlType>>;
  renderHints?: Maybe<CategoriesWidgetRenderHints>;
  title: Scalars['String']['output'];
  type: WidgetValueFormat;
  unit: Unit;
  values: Array<Maybe<Scalars['Float']['output']>>;
  xAxisLabel?: Maybe<Scalars['String']['output']>;
  yAxisLabel?: Maybe<Scalars['String']['output']>;
};

export enum PlanType {
  /** Enterprise */
  Enterprise = 'ENTERPRISE',
  /** Free */
  Free = 'FREE',
  /** Trial */
  Trial = 'TRIAL'
}

export type PqlQueryResult = {
  __typename?: 'PqlQueryResult';
  markdown: Scalars['String']['output'];
};

export type PqlResponse = {
  __typename?: 'PqlResponse';
  filters: Array<Maybe<QueryFilter>>;
  floatValue?: Maybe<Scalars['Float']['output']>;
  intValue?: Maybe<Scalars['Float']['output']>;
  listValue?: Maybe<Array<Scalars['String']['output']>>;
  strValue?: Maybe<Scalars['String']['output']>;
};

export type PrioritiesWidgetValue = WidgetValue & {
  __typename?: 'PrioritiesWidgetValue';
  exportLinks: Array<Maybe<ExportLink>>;
  legend?: Maybe<WidgetLegend>;
  nextCyclePriorities: Array<PriorityWidgetValueData>;
  notes?: Maybe<Array<BaseNoteGqlType>>;
  priorities: Array<PriorityWidgetValueData>;
  type: WidgetValueFormat;
};

export enum PriorityStatus {
  /** 🚫 Blocked */
  Blocked = 'BLOCKED',
  /** 🙅‍♀️ Deprioritized */
  Deprioritized = 'DEPRIORITIZED',
  /** ✅ Done */
  Done = 'DONE',
  /** ➕ Newly added */
  NewlyAdded = 'NEWLY_ADDED',
  /** ⚠️ Off track */
  OffTrack = 'OFF_TRACK',
  /** 👍 On track */
  OnTrack = 'ON_TRACK'
}

export type PriorityWidgetValueData = {
  __typename?: 'PriorityWidgetValueData';
  priority: TextContent;
  status?: Maybe<PriorityStatus>;
};

export enum Provider {
  /** AppDynamics */
  Appdynamics = 'APPDYNAMICS',
  /** AWS */
  Aws = 'AWS',
  /** Azure DevOps */
  Azure = 'AZURE',
  /** Bitbucket */
  Bitbucket = 'BITBUCKET',
  /** Bitbucket Pipelines */
  BitbucketPipelines = 'BITBUCKET_PIPELINES',
  /** Blameless */
  Blameless = 'BLAMELESS',
  /** Bugsnag */
  Bugsnag = 'BUGSNAG',
  /** Buildkite */
  Buildkite = 'BUILDKITE',
  /** CircleCI */
  Circleci = 'CIRCLECI',
  /** Claude Code */
  ClaudeCode = 'CLAUDE_CODE',
  /** Amazon CloudWatch */
  Cloudwatch = 'CLOUDWATCH',
  /** Shortcut */
  Clubhouse = 'CLUBHOUSE',
  /** CodeDeploy */
  Codedeploy = 'CODEDEPLOY',
  /** Custom - any git repository */
  CustomGit = 'CUSTOM_GIT',
  /** Custom Incident - user provided */
  CustomIncident = 'CUSTOM_INCIDENT',
  /** Custom Metric - user provided */
  CustomMetric = 'CUSTOM_METRIC',
  /** Datadog */
  Datadog = 'DATADOG',
  /** Email */
  Email = 'EMAIL',
  /** Fake Build */
  Fakebuild = 'FAKEBUILD',
  /** Fake Flag */
  Fakeflag = 'FAKEFLAG',
  /** Fake Git */
  Fakegit = 'FAKEGIT',
  /** FireHydrant */
  Firehydrant = 'FIREHYDRANT',
  /** GitHub */
  Github = 'GITHUB',
  /** Sleuth Automations for GitHub */
  GithubAutomations = 'GITHUB_AUTOMATIONS',
  /** GitHub Copilot */
  GithubCopilot = 'GITHUB_COPILOT',
  /** GitHub Enterprise Server */
  GithubEnterprise = 'GITHUB_ENTERPRISE',
  /** GitLab */
  Gitlab = 'GITLAB',
  /** Google */
  Google = 'GOOGLE',
  /** Honeybadger */
  Honeybadger = 'HONEYBADGER',
  /** Incident.io */
  IncidentIo = 'INCIDENT_IO',
  /** Jenkins */
  Jenkins = 'JENKINS',
  /** Jira Cloud */
  Jira = 'JIRA',
  /** Jira Data Center */
  JiraDatacenter = 'JIRA_DATACENTER',
  /** LaunchDarkly */
  Launchdarkly = 'LAUNCHDARKLY',
  /** Linear */
  Linear = 'LINEAR',
  /** Microsoft */
  Microsoft = 'MICROSOFT',
  /** Microsoft Teams */
  MicrosoftTeams = 'MICROSOFT_TEAMS',
  /** New Relic */
  Newrelic = 'NEWRELIC',
  /** Opsgenie */
  Opsgenie = 'OPSGENIE',
  /** PagerDuty */
  Pagerduty = 'PAGERDUTY',
  /** Rollbar */
  Rollbar = 'ROLLBAR',
  /** Rootly */
  Rootly = 'ROOTLY',
  /** Sentry Cloud */
  Sentry = 'SENTRY',
  /** Sentry Self-Hosted */
  SentrySelfHosted = 'SENTRY_SELF_HOSTED',
  /** ServiceNow */
  Servicenow = 'SERVICENOW',
  /** Splunk Observability Cloud */
  Signalfx = 'SIGNALFX',
  /** Slack */
  Slack = 'SLACK',
  /** Sleuth DORA */
  SleuthDora = 'SLEUTH_DORA',
  /** Statuspage */
  Statuspage = 'STATUSPAGE',
  /** Zendesk */
  Zendesk = 'ZENDESK'
}

export enum ProviderCategory {
  Build = 'BUILD',
  Chat = 'CHAT',
  Code = 'CODE',
  Incident = 'INCIDENT',
  Issue = 'ISSUE',
  Metric = 'METRIC',
  Support = 'SUPPORT'
}

/** Complete diff between pull request and current version. */
export type PullRequestDiff = {
  __typename?: 'PullRequestDiff';
  baseVersionNumber?: Maybe<Scalars['Int']['output']>;
  conflictFiles: Array<Scalars['String']['output']>;
  files: Array<PullRequestFileDiff>;
  filesAdded: Scalars['Int']['output'];
  filesDeleted: Scalars['Int']['output'];
  filesModified: Scalars['Int']['output'];
  hasConflicts: Scalars['Boolean']['output'];
  pullRequestId: Scalars['String']['output'];
  totalAdditions: Scalars['Int']['output'];
  totalDeletions: Scalars['Int']['output'];
};

/** Diff information for a single file in a pull request. */
export type PullRequestFileDiff = {
  __typename?: 'PullRequestFileDiff';
  action: Scalars['String']['output'];
  additions: Scalars['Int']['output'];
  conflictReason?: Maybe<Scalars['String']['output']>;
  deletions: Scalars['Int']['output'];
  hasConflict: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  patch?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  aiAssetCleanupRoots: Array<Scalars['String']['output']>;
  aiQuery: AiQueryResult;
  asset?: Maybe<VaultAsset>;
  assetAuditLog: AssetAuditEventConnection;
  assetIds: Array<Scalars['ID']['output']>;
  assetPullRequest: SkillPullRequest;
  assetPullRequests: SkillPullRequestConnection;
  assetUsageEvents: AssetUsageEventConnection;
  baseurl: Scalars['String']['output'];
  bot: ManagedBot;
  bots: Array<ManagedBot>;
  catalogEntries?: Maybe<Array<CatalogEntry>>;
  catalogImportedKeys: Array<Scalars['String']['output']>;
  catalogSources: Array<CatalogSource>;
  changeRequests: ChangeRequestConnection;
  dashboard?: Maybe<Dashboard>;
  dashboards: DashboardConnection;
  deviceGrant?: Maybe<DeviceGrant>;
  evalBenchmark: EvalBenchmark;
  flashMessages: Array<MessageType>;
  installationRequests: Array<AssetInstallationRequest>;
  installedAssets: InstalledAssetsResponse;
  integrationProvider: IntegrationProviderDefinitionType;
  integrationProviders: Array<IntegrationProviderDefinitionType>;
  managedImportRunStatus: ManagedImportRunStatus;
  managedImportScanStatus: ManagedImportScanStatus;
  managementSession: ManagementSession;
  mcpIntegrationTools: McpIntegrationToolsConnection;
  mcpProviderUrls: Array<McpProviderUrl>;
  myAssetCapabilities: MyAssetCapabilities;
  myInstallationRequests: Array<AssetInstallationRequest>;
  notification?: Maybe<Notification>;
  organization: OrganizationType;
  pendingInstallationRequestCount: Scalars['Int']['output'];
  pql: PqlResponse;
  pqlQuery: PqlQueryResult;
  profile?: Maybe<VaultAssetProfile>;
  profiles: VaultAssetProfileConnection;
  releaseCommit: Scalars['String']['output'];
  remoteMarketplacePlugins: Array<RemoteMarketplacePlugin>;
  repositoriesWithSkills: Array<RepositoryWithSkills>;
  repository?: Maybe<RepositoryType>;
  review?: Maybe<Review>;
  reviewTemplates: Array<ReviewTemplateGqlType>;
  salaries: Array<DeveloperSalaryType>;
  search: SearchResultConnection;
  searchOptions: SearchOptionsType;
  skillDiscoveryStatus: SkillDiscoveryStatus;
  skillUsageTimeSeries: SkillUsageTimeSeriesResponse;
  skillVersionDiff: SkillVersionDiff;
  smartMergeStatus: SmartMergeStatus;
  survey?: Maybe<Survey>;
  surveys: SurveyConnection;
  teamUsingSleuth: Scalars['Boolean']['output'];
  user?: Maybe<User>;
  vault: Vault;
  widget?: Maybe<Widget>;
  widgetType: WidgetType;
  widgetTypes: WidgetTypeConnection;
  workspace: Workspace;
  workspaces: WorkspaceConnection;
};


export type QueryAiQueryArgs = {
  input: AiQueryInput;
};


export type QueryAssetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssetAuditLogArgs = {
  actorId?: InputMaybe<Scalars['Int']['input']>;
  actorType?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  assetTypes?: InputMaybe<Array<AssetType>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  events?: InputMaybe<Array<AssetEventType>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAssetIdsArgs = {
  assetTypes?: InputMaybe<Array<AssetType>>;
  baseRepoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  impactMax?: InputMaybe<Scalars['Float']['input']>;
  impactMin?: InputMaybe<Scalars['Float']['input']>;
  includeOrgWide?: InputMaybe<Scalars['Boolean']['input']>;
  installationEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  installationEntityType?: InputMaybe<VaultAssetInstallationEntityType>;
  monoRepoConfigId?: InputMaybe<Scalars['ID']['input']>;
  noInstallations?: InputMaybe<Scalars['Boolean']['input']>;
  qualityMax?: InputMaybe<Scalars['Float']['input']>;
  qualityMin?: InputMaybe<Scalars['Float']['input']>;
  repositoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<AssetSortField>;
  sortDirection?: InputMaybe<SortDirection>;
  sourceType?: InputMaybe<AssetSourceType>;
  status?: InputMaybe<Array<SkillStatusEnum>>;
  type?: InputMaybe<AssetType>;
};


export type QueryAssetPullRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssetPullRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assetId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  creationType?: InputMaybe<SkillPullRequestCreationTypeEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SkillPullRequestStatusEnum>;
};


export type QueryAssetUsageEventsArgs = {
  actor?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  assetName?: InputMaybe<Scalars['String']['input']>;
  assetType?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryBotArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalogEntriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
};


export type QueryCatalogImportedKeysArgs = {
  source: Scalars['String']['input'];
};


export type QueryCatalogSourcesArgs = {
  assetType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChangeRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  changeType?: InputMaybe<ChangeRequestTypeEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ChangeRequestStatusEnum>;
};


export type QueryDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDashboardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDeviceGrantArgs = {
  clientId: Scalars['String']['input'];
  userCode: Scalars['String']['input'];
};


export type QueryEvalBenchmarkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInstallationRequestsArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInstalledAssetsArgs = {
  assetType?: InputMaybe<Scalars['String']['input']>;
  botId?: InputMaybe<Scalars['ID']['input']>;
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIntegrationProviderArgs = {
  provider: IntegrationProvider;
};


export type QueryIntegrationProvidersArgs = {
  providerCategories?: InputMaybe<Array<InputMaybe<ProviderCategory>>>;
};


export type QueryMcpIntegrationToolsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyInstallationRequestsArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPqlArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  ignoreCache?: InputMaybe<Scalars['Boolean']['input']>;
  query: Scalars['String']['input'];
  start?: InputMaybe<Scalars['DateTime']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryPqlQueryArgs = {
  query: Scalars['String']['input'];
  timeRange?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRemoteMarketplacePluginsArgs = {
  url: Scalars['String']['input'];
};


export type QueryRepositoriesWithSkillsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRepositoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReviewTemplatesArgs = {
  isSkillsDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  reviewType?: InputMaybe<ReviewType>;
};


export type QuerySearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  resultType?: InputMaybe<SearchResultType>;
  term?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySearchOptionsArgs = {
  orgSlug: Scalars['ID']['input'];
};


export type QuerySkillDiscoveryStatusArgs = {
  repositoryGid: Scalars['ID']['input'];
};


export type QuerySkillUsageTimeSeriesArgs = {
  assetType?: InputMaybe<Scalars['String']['input']>;
  botId?: InputMaybe<Scalars['ID']['input']>;
  groupByAssetType?: InputMaybe<Scalars['Boolean']['input']>;
  ownedBy?: InputMaybe<Scalars['String']['input']>;
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
  skillId?: InputMaybe<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  timeRange?: InputMaybe<SkillUsageTimeRange>;
};


export type QuerySkillVersionDiffArgs = {
  fromVersion: Scalars['Int']['input'];
  skillId: Scalars['ID']['input'];
  toVersion: Scalars['Int']['input'];
};


export type QuerySmartMergeStatusArgs = {
  mergeId: Scalars['ID']['input'];
};


export type QuerySurveyArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTeamUsingSleuthArgs = {
  email: Scalars['String']['input'];
};


export type QueryWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWidgetTypeArgs = {
  slug: Scalars['ID']['input'];
};


export type QueryWidgetTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skillsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWorkspaceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isGlobal?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWorkspacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFilter = {
  __typename?: 'QueryFilter';
  name?: Maybe<Scalars['String']['output']>;
};

export enum Rating {
  /** Good */
  Good = 'GOOD',
  /** Perfect */
  Perfect = 'PERFECT',
  /** So-so */
  SoSo = 'SO_SO'
}

export type RatingTableWidgetCell = {
  __typename?: 'RatingTableWidgetCell';
  rating?: Maybe<Rating>;
  /** Percentage will be `null` when there are no issues in this epic. */
  value?: Maybe<Scalars['FloatRoundedTo2']['output']>;
};

export type RatingTableWidgetValue = WidgetValue & {
  __typename?: 'RatingTableWidgetValue';
  cells: Array<Array<Maybe<RatingTableWidgetCell>>>;
  exportLinks: Array<Maybe<ExportLink>>;
  headings: Array<Scalars['String']['output']>;
  legend?: Maybe<WidgetLegend>;
  notes?: Maybe<Array<BaseNoteGqlType>>;
  participationRates?: Maybe<Array<Scalars['FloatRoundedTo2']['output']>>;
  rating?: Maybe<Rating>;
  rows: Array<Scalars['String']['output']>;
  type: WidgetValueFormat;
};

export type RatingWidgetValue = WidgetValue & {
  __typename?: 'RatingWidgetValue';
  commentary?: Maybe<TextContent>;
  exportLinks: Array<Maybe<ExportLink>>;
  legend?: Maybe<WidgetLegend>;
  notes?: Maybe<Array<BaseNoteGqlType>>;
  previousRating?: Maybe<Rating>;
  rating?: Maybe<Rating>;
  type: WidgetValueFormat;
};

export type Reaction = {
  __typename?: 'Reaction';
  author?: Maybe<User>;
  emoji: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type RefreshGitAssetMutation = {
  __typename?: 'RefreshGitAssetMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

/** Wipe a managed asset's files, evals, and chat history, then start a fresh orchestration run. */
export type RegenerateAssetMutation = {
  __typename?: 'RegenerateAssetMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type RegenerateEvalsInput = {
  /** Number of evals to generate (default 3) */
  count?: InputMaybe<Scalars['Int']['input']>;
  skillGid: Scalars['ID']['input'];
};

export type RegenerateEvalsMutation = {
  __typename?: 'RegenerateEvalsMutation';
  errors: Array<ErrorType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Re-initialize skill discovery for a repository, deleting existing suggestions. */
export type ReinitializeRepositoryDiscoveryMutation = {
  __typename?: 'ReinitializeRepositoryDiscoveryMutation';
  errors: Array<ErrorType>;
  repositoryGid?: Maybe<Scalars['String']['output']>;
};

export type RejectInstallationRequestMutation = {
  __typename?: 'RejectInstallationRequestMutation';
  errors: Array<ErrorType>;
  installationRequest?: Maybe<AssetInstallationRequest>;
};

export type RemoteMarketplacePlugin = {
  __typename?: 'RemoteMarketplacePlugin';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type RemoveAssetInstallationsInput = {
  assetName: Scalars['String']['input'];
  delete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoveAssetInstallationsMutation = {
  __typename?: 'RemoveAssetInstallationsMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

/** Remove assets from a profile. */
export type RemoveAssetsFromProfileMutation = {
  __typename?: 'RemoveAssetsFromProfileMutation';
  errors: Array<ErrorType>;
  profile?: Maybe<VaultAssetProfile>;
};

export type RemoveTeamMemberInput = {
  memberId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type RemoveTeamMemberMutation = {
  __typename?: 'RemoveTeamMemberMutation';
  errors: Array<ErrorType>;
  team?: Maybe<Team>;
};

export type RemoveTeamsOrUsersFromScopeMutation = {
  __typename?: 'RemoveTeamsOrUsersFromScopeMutation';
  errors?: Maybe<Array<ErrorType>>;
  instance: TeamOrUsersScoped;
};

export type RemoveTeamsOrUsersFromScopeMutationInput = {
  id: Scalars['ID']['input'];
  /** List of TeamOrUser IDs to be removed */
  teamOrUserIds: Array<Scalars['ID']['input']>;
};

export type RemoveUsersFromScopeMutation = {
  __typename?: 'RemoveUsersFromScopeMutation';
  errors?: Maybe<Array<ErrorType>>;
  instance: UserScoped;
};

export type RemoveUsersFromScopeMutationInput = {
  id: Scalars['ID']['input'];
  /** List of user IDs to be removed */
  users: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type RenameAssetInput = {
  newName: Scalars['String']['input'];
  oldName: Scalars['String']['input'];
};

export type RenameAssetMutation = {
  __typename?: 'RenameAssetMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type RepeatReviewInput = {
  fromReview: Scalars['ID']['input'];
  /** The title of the new review. Defaults to the title of the previous review. */
  newTitle?: InputMaybe<Scalars['String']['input']>;
};

/** Create a new review in this chain of reviews. The new review will link to the previous review and the previous review will link to the new review. */
export type RepeatReviewMutation = {
  __typename?: 'RepeatReviewMutation';
  errors?: Maybe<Array<ErrorType>>;
  review?: Maybe<Review>;
};

export type RepositoryConnection = {
  __typename?: 'RepositoryConnection';
  edges: Array<RepositoryTypeEdge>;
  nodes: Array<RepositoryType>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type RepositoryInstallationInput = {
  paths?: InputMaybe<Array<Scalars['String']['input']>>;
  url: Scalars['String']['input'];
};

export type RepositoryTopSkill = {
  __typename?: 'RepositoryTopSkill';
  skillId: Scalars['String']['output'];
  skillName: Scalars['String']['output'];
  totalUses: Scalars['Int']['output'];
};

export type RepositoryType = {
  __typename?: 'RepositoryType';
  id?: Maybe<Scalars['ID']['output']>;
  importedSkills?: Maybe<Array<Skill>>;
  issueTeamKeys?: Maybe<Scalars['String']['output']>;
  monoRepoConfigs?: Maybe<Array<MonoRepoConfigType>>;
  name: Scalars['String']['output'];
  owner: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  suggestedSkills?: Maybe<Array<SuggestedSkill>>;
};


export type RepositoryTypeSuggestedSkillsArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RepositoryTypeEdge = {
  __typename?: 'RepositoryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: RepositoryType;
};

export type RepositoryWithSkills = {
  __typename?: 'RepositoryWithSkills';
  assetCount: Scalars['Int']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: Scalars['String']['output'];
  topSkill?: Maybe<RepositoryTopSkill>;
  totalSkillUses: Scalars['Int']['output'];
};

export type ResendEmailConfirmationMutation = {
  __typename?: 'ResendEmailConfirmationMutation';
  success: Scalars['Boolean']['output'];
};

export type ResendInvitationMutationInput = {
  invitationId: Scalars['ID']['input'];
};

export type ResendInvitationMutationPayload = {
  __typename?: 'ResendInvitationMutationPayload';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean']['output'];
};

export type RetractInstallationRequestMutation = {
  __typename?: 'RetractInstallationRequestMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type Review = Assessable & Commentable & TeamOrUsersScoped & UserScoped & {
  __typename?: 'Review';
  assessment: DelayedAssessment;
  chain?: Maybe<ReviewChain>;
  comment?: Maybe<Comment>;
  commentAuthors: UserConnection;
  comments: CommentConnection;
  commentsCount: Scalars['Int']['output'];
  createdOn: Scalars['DateTime']['output'];
  dueOn: Scalars['DateTime']['output'];
  end: Scalars['DateTime']['output'];
  highlightWidget?: Maybe<Widget>;
  id: Scalars['ID']['output'];
  inProgressOn?: Maybe<Scalars['DateTime']['output']>;
  modifiedOn: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  nextReview?: Maybe<Review>;
  onlyOwnerCanChangeStatus: Scalars['Boolean']['output'];
  owner?: Maybe<User>;
  pql: PqlResponse;
  previousReview?: Maybe<Review>;
  publishedOn?: Maybe<Scalars['DateTime']['output']>;
  recipientsCount: Scalars['Int']['output'];
  requireApproval: Scalars['Boolean']['output'];
  reviewType: ReviewType;
  section?: Maybe<Section>;
  sectionSubmissionDeadline?: Maybe<Scalars['DateTime']['output']>;
  sections: SectionConnection;
  start: Scalars['DateTime']['output'];
  status: ReviewStatus;
  teamsOrUsers: TeamOrUsersConnection;
  users: UserConnection;
  workspace: Workspace;
};


export type ReviewCommentArgs = {
  id: Scalars['ID']['input'];
};


export type ReviewCommentAuthorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewPqlArgs = {
  query: Scalars['String']['input'];
};


export type ReviewSectionArgs = {
  id: Scalars['ID']['input'];
};


export type ReviewSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewTeamsOrUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type ReviewUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewChain = {
  __typename?: 'ReviewChain';
  chainReviews: ReviewConnection;
  id: Scalars['ID']['output'];
  templateIconPath?: Maybe<Scalars['String']['output']>;
};


export type ReviewChainChainReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeTopLink?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ReviewConnection = {
  __typename?: 'ReviewConnection';
  edges: Array<ReviewEdge>;
  nodes: Array<Review>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type ReviewEdge = {
  __typename?: 'ReviewEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Review;
};

export type ReviewInstallationRequestInput = {
  /** Optional note (used for rejections) */
  note?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['ID']['input'];
};

export enum ReviewStatus {
  /** Draft */
  Draft = 'DRAFT',
  /** In progress */
  InProgress = 'IN_PROGRESS',
  /** Published */
  Published = 'PUBLISHED'
}

export type ReviewTemplateGqlType = {
  __typename?: 'ReviewTemplateGqlType';
  description: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  emojiDepiction?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export enum ReviewType {
  /** Dashboard */
  Dashboard = 'DASHBOARD',
  /** Review */
  Review = 'REVIEW',
  /** Survey */
  Survey = 'SURVEY'
}

export type RevokeBotRuntimeTokensMutation = {
  __typename?: 'RevokeBotRuntimeTokensMutation';
  revokedCount: Scalars['Int']['output'];
};

export type RevokeInvitationMutationInput = {
  invitationId: Scalars['ID']['input'];
};

export type RevokeInvitationMutationPayload = {
  __typename?: 'RevokeInvitationMutationPayload';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean']['output'];
};

export enum Role {
  Admin = 'ADMIN',
  AssetManager = 'ASSET_MANAGER',
  Billing = 'BILLING',
  Dev = 'DEV',
  Member = 'MEMBER'
}

export type Rule = VaultAsset & {
  __typename?: 'Rule';
  /** Repository code contexts where this asset will execute */
  codeContexts: Array<AssetCodeContext>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** Whether an evaluation is currently in progress for this asset */
  evaluating: Scalars['Boolean']['output'];
  /** Files belonging to this asset */
  files: Array<SkillFile>;
  globs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  /** Pending installation requests for this asset visible to the current user */
  installationRequests: Array<AssetInstallationRequest>;
  installations: Array<VaultAssetInstallation>;
  isChatDefault: Scalars['Boolean']['output'];
  latestVersion: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Current user's permissions for this asset */
  permissions?: Maybe<VaultAssetPermissions>;
  profiles: Array<VaultAssetProfile>;
  slug: Scalars['String']['output'];
  /** Asset source metadata */
  source: AssetSource;
  status?: Maybe<SkillStatusEnum>;
  title?: Maybe<Scalars['String']['output']>;
  /** Token counts for the current version */
  tokenCounts?: Maybe<AssetTokenCount>;
  type: AssetType;
  updatedAt: Scalars['DateTime']['output'];
  usageCount: Scalars['Int']['output'];
  versions: Array<VaultAssetVersion>;
  versionsCount: Scalars['Int']['output'];
};


export type RuleFilesArgs = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type RunEvalBenchmarkInput = {
  /** Subset of eval GIDs to run */
  evalGids?: InputMaybe<Array<Scalars['ID']['input']>>;
  runsPerConfig?: InputMaybe<Scalars['Int']['input']>;
  skillGid: Scalars['ID']['input'];
};

export type RunEvalBenchmarkMutation = {
  __typename?: 'RunEvalBenchmarkMutation';
  benchmark?: Maybe<EvalBenchmark>;
  errors: Array<ErrorType>;
};

export enum SalaryLevel {
  /** Senior */
  Senior = 'SENIOR'
}

export type SaveSkillFileVersionInput = {
  assetId: Scalars['ID']['input'];
  changeSummary?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  fileId: Scalars['ID']['input'];
};

/** Save a new version of a file, creating a new asset version with the updated content. */
export type SaveSkillFileVersionMutation = {
  __typename?: 'SaveSkillFileVersionMutation';
  errors: Array<ErrorType>;
  file?: Maybe<SkillFile>;
};

export enum ScopeSource {
  Review = 'REVIEW',
  Widget = 'WIDGET',
  Workspace = 'WORKSPACE'
}

export type ScopeType = {
  __typename?: 'ScopeType';
  source: ScopeSource;
  teamsAndUsers: Array<TeamOrUser>;
};

export type ScopingModifierNote = BaseNoteGqlType & {
  __typename?: 'ScopingModifierNote';
  auth: Scalars['String']['output'];
  filters: Array<Maybe<Scalars['String']['output']>>;
  msg: Scalars['String']['output'];
};

export enum Score {
  /** Bad */
  Bad = 'BAD',
  /** Good */
  Good = 'GOOD',
  /** OK */
  Ok = 'OK'
}

export type SearchOptionsType = {
  __typename?: 'SearchOptionsType';
  authors: Array<Scalars['String']['output']>;
  deployments: Array<NameAndSlugSearchOptionType>;
  environments: Array<NameAndSlugSearchOptionType>;
  healthOptions: Array<Scalars['String']['output']>;
  labels: Array<NameAndSlugSearchOptionType>;
  projects: Array<NameAndSlugSearchOptionType>;
  sizeOptions: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  teams: Array<NameAndSlugSearchOptionType>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  artifactId?: Maybe<Scalars['ID']['output']>;
  artifactName?: Maybe<Scalars['String']['output']>;
  assetType?: Maybe<AssetType>;
  chainCount?: Maybe<Scalars['Int']['output']>;
  lastViewedOn?: Maybe<Scalars['DateTime']['output']>;
  monoRepoConfigId?: Maybe<Scalars['ID']['output']>;
  ownerId?: Maybe<Scalars['ID']['output']>;
  ownerType?: Maybe<Scalars['String']['output']>;
  type: SearchResultType;
  workspaceId?: Maybe<Scalars['ID']['output']>;
  workspaceMarker?: Maybe<WorkspaceMarkerField>;
  workspaceName?: Maybe<Scalars['String']['output']>;
};

export type SearchResultConnection = {
  __typename?: 'SearchResultConnection';
  edges: Array<SearchResultEdge>;
  nodes: Array<SearchResult>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type SearchResultEdge = {
  __typename?: 'SearchResultEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: SearchResult;
};

export enum SearchResultType {
  Dashboard = 'DASHBOARD',
  Repository = 'REPOSITORY',
  Review = 'REVIEW',
  Skill = 'SKILL',
  Survey = 'SURVEY',
  Team = 'TEAM',
  Workspace = 'WORKSPACE'
}

export type Section = Assessable & Commentable & {
  __typename?: 'Section';
  assessment: DelayedAssessment;
  assessmentScoreIsMandatory: Scalars['Boolean']['output'];
  assessmentSummaryIsMandatory: Scalars['Boolean']['output'];
  comment?: Maybe<Comment>;
  commentAuthors: UserConnection;
  comments: CommentConnection;
  commentsCount: Scalars['Int']['output'];
  hasAssessment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owners: UserConnection;
  parameterOptions: ParameterValueOptionConnection;
  position: Scalars['Int']['output'];
  review: Review;
  status: SectionStatus;
  widget?: Maybe<Widget>;
  widgets: WidgetConnection;
};


export type SectionCommentArgs = {
  id: Scalars['ID']['input'];
};


export type SectionCommentAuthorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionOwnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionParameterOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fieldName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  precursorValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selectedValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: Scalars['String']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
};


export type SectionWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type SectionWidgetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SectionConnection = {
  __typename?: 'SectionConnection';
  edges: Array<SectionEdge>;
  nodes: Array<Section>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type SectionEdge = {
  __typename?: 'SectionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Section;
};

export enum SectionStatus {
  /** Approved */
  Approved = 'APPROVED',
  /** Draft */
  Draft = 'DRAFT',
  /** Submitted */
  Submitted = 'SUBMITTED'
}

export type SeenEventType = {
  __typename?: 'SeenEventType';
  name: Scalars['String']['output'];
};

/** Set or clear the active skill profile for the current user. */
export type SetActiveSkillProfileMutation = {
  __typename?: 'SetActiveSkillProfileMutation';
  user?: Maybe<User>;
};

export type SetAssetInstallationsInput = {
  assetName: Scalars['String']['input'];
  assetVersion?: InputMaybe<Scalars['String']['input']>;
  installations?: InputMaybe<Array<AssetInstallationInput>>;
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  repositories: Array<RepositoryInstallationInput>;
};

export type SetAssetInstallationsMutation = {
  __typename?: 'SetAssetInstallationsMutation';
  asset?: Maybe<VaultAsset>;
  errors: Array<ErrorType>;
};

/** Set an asset's status to a specific value (draft, published, or rejected). */
export type SetAssetStatusMutation = {
  __typename?: 'SetAssetStatusMutation';
  asset?: Maybe<VaultAsset>;
  errors: Array<ErrorType>;
};

export type SetBulkUserWorkingHoursMutation = {
  __typename?: 'SetBulkUserWorkingHoursMutation';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type SetCurrentUserWorkingHoursMutation = {
  __typename?: 'SetCurrentUserWorkingHoursMutation';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type SetDeveloperSalaryMutation = {
  __typename?: 'SetDeveloperSalaryMutation';
  errors: Array<ErrorType>;
  salary?: Maybe<DeveloperSalaryType>;
  success: Scalars['Boolean']['output'];
};

/** NOTE: If the list of filters is empty, we will return `workPlanning: null`. */
export type SetNamedWorkCategoryMutation = {
  __typename?: 'SetNamedWorkCategoryMutation';
  errors?: Maybe<Array<ErrorType>>;
  success: Scalars['Boolean']['output'];
  workCategories: Array<NamedWorkCategoryGqlType>;
};

/** NOTE: If the list of filters is empty, we will return `workPlanning: null`. */
export type SetNamedWorkPlanningMutation = {
  __typename?: 'SetNamedWorkPlanningMutation';
  errors?: Maybe<Array<ErrorType>>;
  success: Scalars['Boolean']['output'];
  workPlanning: Array<NamedWorkPlanningGqlType>;
};

export type SetOrganizationWorkingHoursMutation = {
  __typename?: 'SetOrganizationWorkingHoursMutation';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type SetReviewStatusInput = {
  id: Scalars['ID']['input'];
  status: ReviewStatus;
};

export type SetReviewStatusMutation = {
  __typename?: 'SetReviewStatusMutation';
  errors?: Maybe<Array<ErrorType>>;
  review?: Maybe<Review>;
};

export type SetSectionStatusInput = {
  id: Scalars['ID']['input'];
  status: SectionStatus;
};

export type SetSectionStatusMutation = {
  __typename?: 'SetSectionStatusMutation';
  errors?: Maybe<Array<ErrorType>>;
  section?: Maybe<Section>;
};

export type SetTeamAdminInput = {
  isAdmin: Scalars['Boolean']['input'];
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type SetTeamAdminMutation = {
  __typename?: 'SetTeamAdminMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export enum SettingsPage {
  IntegrationAuths = 'INTEGRATION_AUTHS',
  IntegrationAuthScoping = 'INTEGRATION_AUTH_SCOPING',
  OrgSalaries = 'ORG_SALARIES',
  PqlBuckets = 'PQL_BUCKETS',
  WidgetConfig = 'WIDGET_CONFIG'
}

export type ShortTeamType = {
  __typename?: 'ShortTeamType';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type SimpleUserType = {
  __typename?: 'SimpleUserType';
  display: Scalars['String']['output'];
  email: Scalars['String']['output'];
  gravatar: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** GraphQL type for skill. */
export type Skill = VaultAsset & {
  __typename?: 'Skill';
  /** Benchmark history (lightweight summaries) */
  benchmarks?: Maybe<Array<EvalBenchmarkSummary>>;
  /** Repository code contexts where this asset will execute */
  codeContexts: Array<AssetCodeContext>;
  /** Maximum context tokens available for orchestration */
  contextMaxTokens?: Maybe<Scalars['Int']['output']>;
  /** Last known context tokens used in orchestration for progress bar display */
  contextTokensUsed?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** Description optimization history */
  descriptionOptimizations?: Maybe<Array<DescriptionOptimization>>;
  /** Delta pass rate from latest benchmark (with_skill - without_skill) */
  evalImpact?: Maybe<Scalars['Float']['output']>;
  /** Pass rate from latest benchmark (with_skill) */
  evalPassRate?: Maybe<Scalars['Float']['output']>;
  /** All evals for this skill */
  evals?: Maybe<Array<AssetEval>>;
  /** Whether an evaluation is currently in progress for this asset */
  evaluating: Scalars['Boolean']['output'];
  /** Files belonging to this asset */
  files: Array<SkillFile>;
  id: Scalars['ID']['output'];
  /** Pending installation requests for this asset visible to the current user */
  installationRequests: Array<AssetInstallationRequest>;
  installations: Array<VaultAssetInstallation>;
  isChatDefault: Scalars['Boolean']['output'];
  /** Most recent benchmark with full results */
  latestBenchmark?: Maybe<EvalBenchmark>;
  latestVersion: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Current user's permissions for this asset */
  permissions?: Maybe<VaultAssetPermissions>;
  profiles: Array<VaultAssetProfile>;
  slug: Scalars['String']['output'];
  /** Asset source metadata */
  source: AssetSource;
  /** GID of the repository this skill was imported from */
  sourceRepositoryGid?: Maybe<Scalars['String']['output']>;
  /** Name of the repository this skill was imported from */
  sourceRepositoryName?: Maybe<Scalars['String']['output']>;
  status: SkillStatusEnum;
  teamId?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  /** Token counts for the current version */
  tokenCounts?: Maybe<AssetTokenCount>;
  type: AssetType;
  updatedAt: Scalars['DateTime']['output'];
  usageCount: Scalars['Int']['output'];
  versions: Array<VaultAssetVersion>;
  versionsCount: Scalars['Int']['output'];
};


/** GraphQL type for skill. */
export type SkillFilesArgs = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** Result of comparing skill files with repository content. */
export type SkillComparisonResult = {
  __typename?: 'SkillComparisonResult';
  error?: Maybe<Scalars['String']['output']>;
  fileDiffs: Array<SkillFileDiff>;
  filesAdded: Scalars['Int']['output'];
  filesDeleted: Scalars['Int']['output'];
  filesModified: Scalars['Int']['output'];
  filesUnchanged: Scalars['Int']['output'];
  hasDifferences: Scalars['Boolean']['output'];
  suggestedDescription: Scalars['String']['output'];
  versionChanges: Array<VersionChange>;
};

/** Status of skill discovery for a repository. */
export type SkillDiscoveryStatus = {
  __typename?: 'SkillDiscoveryStatus';
  /** Whether skill discovery is currently running */
  isRunning: Scalars['Boolean']['output'];
  /** Stream ID for the discovery process */
  streamId?: Maybe<Scalars['String']['output']>;
};

/** A versioned file belonging to a vault asset (skill, agent, etc.). */
export type SkillFile = {
  __typename?: 'SkillFile';
  currentVersion?: Maybe<Scalars['Int']['output']>;
  deletable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  tokenCounts?: Maybe<SkillFileTokenCounts>;
  versions: Array<SkillFileVersion>;
};

/** Information about a single file difference. */
export type SkillFileDiff = {
  __typename?: 'SkillFileDiff';
  action: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
};

/** Token counts for a skill file version. */
export type SkillFileTokenCounts = {
  __typename?: 'SkillFileTokenCounts';
  claudeTokens?: Maybe<Scalars['Int']['output']>;
  estimatedTokens: Scalars['Int']['output'];
  openaiTokens?: Maybe<Scalars['Int']['output']>;
};

/** A version of a skill file. */
export type SkillFileVersion = {
  __typename?: 'SkillFileVersion';
  changeSummary?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

/** Action type for skill patch generation. */
export enum SkillPatchActionTypeEnum {
  Delete = 'DELETE',
  Update = 'UPDATE'
}

/** GraphQL type for skill pull request. */
export type SkillPullRequest = {
  __typename?: 'SkillPullRequest';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedById?: Maybe<Scalars['String']['output']>;
  approvedByName?: Maybe<Scalars['String']['output']>;
  authorId?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  baseVersionNumber?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Array<SkillPullRequestComment>>;
  createdAt: Scalars['DateTime']['output'];
  /** Description of what this pull request changes */
  description: Scalars['String']['output'];
  diff?: Maybe<PullRequestDiff>;
  fileChanges?: Maybe<Array<SkillPullRequestFile>>;
  id: Scalars['ID']['output'];
  mergedAt?: Maybe<Scalars['DateTime']['output']>;
  mergedById?: Maybe<Scalars['String']['output']>;
  mergedByName?: Maybe<Scalars['String']['output']>;
  mergedVersionNumber?: Maybe<Scalars['Int']['output']>;
  /** Whether approval is required to merge this pull request */
  requiresApproval: Scalars['Boolean']['output'];
  skill: Skill;
  sourceUrl: Scalars['String']['output'];
  status: SkillPullRequestStatusEnum;
  /** Title of the proposed changes */
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** GraphQL type for comments on skill pull requests. */
export type SkillPullRequestComment = {
  __typename?: 'SkillPullRequestComment';
  authorId?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** File name this comment is on (optional) */
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Line number for inline comments */
  lineNumber?: Maybe<Scalars['Int']['output']>;
  /** Comment text */
  text: Scalars['String']['output'];
};

export type SkillPullRequestConnection = {
  __typename?: 'SkillPullRequestConnection';
  edges: Array<SkillPullRequestEdge>;
  nodes: Array<SkillPullRequest>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

/** Creation type of a skill pull request. */
export enum SkillPullRequestCreationTypeEnum {
  Autogenerated = 'AUTOGENERATED',
  Manual = 'MANUAL'
}

export type SkillPullRequestEdge = {
  __typename?: 'SkillPullRequestEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: SkillPullRequest;
};

/** GraphQL type for file changes within a skill pull request. */
export type SkillPullRequestFile = {
  __typename?: 'SkillPullRequestFile';
  action: IssuesAssetPullRequestFileActionChoices;
  content?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  previousContent?: Maybe<Scalars['String']['output']>;
};

/** File action type for pull request changes. */
export enum SkillPullRequestFileActionEnum {
  Add = 'ADD',
  Delete = 'DELETE',
  Modify = 'MODIFY'
}

/** Status of a skill pull request. */
export enum SkillPullRequestStatusEnum {
  Closed = 'CLOSED',
  Merged = 'MERGED',
  Open = 'OPEN'
}

/** Status of an asset. */
export enum SkillStatusEnum {
  AutoPublished = 'AUTO_PUBLISHED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Rejected = 'REJECTED'
}

export type SkillUsageDataPoint = {
  __typename?: 'SkillUsageDataPoint';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export enum SkillUsageTimeRange {
  All = 'ALL',
  Days_30 = 'DAYS_30',
  Days_90 = 'DAYS_90'
}

export type SkillUsageTimeSeries = {
  __typename?: 'SkillUsageTimeSeries';
  dataPoints: Array<SkillUsageDataPoint>;
  skillId?: Maybe<Scalars['String']['output']>;
  skillName: Scalars['String']['output'];
};

export type SkillUsageTimeSeriesResponse = {
  __typename?: 'SkillUsageTimeSeriesResponse';
  daysInPeriod: Scalars['Int']['output'];
  endDate: Scalars['String']['output'];
  granularity: Scalars['String']['output'];
  series: Array<SkillUsageTimeSeries>;
  skillsUsedInPeriod: Scalars['Int']['output'];
  startDate: Scalars['String']['output'];
  timeRange: Scalars['String']['output'];
  totalSkillsAvailable: Scalars['Int']['output'];
  totalUsageInPeriod: Scalars['Int']['output'];
};

/** Diff between two skill versions. */
export type SkillVersionDiff = {
  __typename?: 'SkillVersionDiff';
  /** File diffs */
  files: Array<SkillVersionFileDiff>;
  /** Number of files added */
  filesAdded: Scalars['Int']['output'];
  /** Number of files deleted */
  filesDeleted: Scalars['Int']['output'];
  /** Number of files modified */
  filesModified: Scalars['Int']['output'];
  /** Version number being compared from */
  fromVersion: Scalars['Int']['output'];
  /** Version number being compared to */
  toVersion: Scalars['Int']['output'];
  /** Total lines added */
  totalAdditions: Scalars['Int']['output'];
  /** Total lines deleted */
  totalDeletions: Scalars['Int']['output'];
};

/** Diff information for a single file between versions. */
export type SkillVersionFileDiff = {
  __typename?: 'SkillVersionFileDiff';
  /** Action: add, modify, delete */
  action: Scalars['String']['output'];
  /** Number of lines added */
  additions: Scalars['Int']['output'];
  /** Number of lines deleted */
  deletions: Scalars['Int']['output'];
  /** File name */
  name: Scalars['String']['output'];
  /** Unified diff patch */
  patch?: Maybe<Scalars['String']['output']>;
  /** File path */
  path?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum SkillsDescriptionOptimizationStatusChoices {
  /** Completed */
  Completed = 'COMPLETED',
  /** Failed */
  Failed = 'FAILED',
  /** Pending */
  Pending = 'PENDING',
  /** Running */
  Running = 'RUNNING',
  /** Superseded */
  Superseded = 'SUPERSEDED'
}

/** An enumeration. */
export enum SkillsEvalBenchmarkStatusChoices {
  /** Completed */
  Completed = 'COMPLETED',
  /** Failed */
  Failed = 'FAILED',
  /** Pending */
  Pending = 'PENDING',
  /** Running */
  Running = 'RUNNING',
  /** Superseded */
  Superseded = 'SUPERSEDED'
}

/** An enumeration. */
export enum SkillsEvalBenchmarkTriggeredByChoices {
  /** Manual */
  Manual = 'MANUAL',
  /** Model Change */
  ModelChange = 'MODEL_CHANGE',
  /** Orchestrator */
  Orchestrator = 'ORCHESTRATOR',
  /** Scheduled */
  Scheduled = 'SCHEDULED',
  /** Upload */
  Upload = 'UPLOAD',
  /** Version Change */
  VersionChange = 'VERSION_CHANGE'
}

/** An enumeration. */
export enum SkillsEvalRunConfigurationChoices {
  /** Without Skill */
  WithoutSkill = 'WITHOUT_SKILL',
  /** With Skill */
  WithSkill = 'WITH_SKILL'
}

/** An enumeration. */
export enum SkillsEvalRunStatusChoices {
  /** Completed */
  Completed = 'COMPLETED',
  /** Failed */
  Failed = 'FAILED',
  /** Pending */
  Pending = 'PENDING',
  /** Running */
  Running = 'RUNNING',
  /** Superseded */
  Superseded = 'SUPERSEDED'
}

/** Input for team-repository association with optional mono_repo_config */
export type SkillsRepositoryInput = {
  monoRepoConfigId?: InputMaybe<Scalars['ID']['input']>;
  repositoryId: Scalars['ID']['input'];
};

/** GraphQL type for team-repository configuration with optional mono_repo_config */
export type SkillsRepositoryType = {
  __typename?: 'SkillsRepositoryType';
  monoRepoConfigId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  owner: Scalars['String']['output'];
  repositoryId: Scalars['String']['output'];
};

/** Organization-level settings for skills. */
export type SkillsSettings = {
  __typename?: 'SkillsSettings';
  /** Whether skill PRs should be automatically created based on code changes in GitHub PRs */
  autoCreateSkillPullRequests: Scalars['Boolean']['output'];
  /** Whether to automatically publish skills that meet the confidence threshold */
  autoPublishEnabled: Scalars['Boolean']['output'];
  /** Minimum confidence percentage required for auto-publishing (0-100) */
  autoPublishThreshold: Scalars['Int']['output'];
};

export type SmartMergeFile = {
  __typename?: 'SmartMergeFile';
  content: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
};

export type SmartMergeStatus = {
  __typename?: 'SmartMergeStatus';
  error?: Maybe<Scalars['String']['output']>;
  files: Array<SmartMergeFile>;
  isComplete: Scalars['Boolean']['output'];
  isRunning: Scalars['Boolean']['output'];
};

export type SmartMergeVariantInput = {
  files: Array<ManagedImportFileInput>;
};

export enum SocialLoginProviderType {
  /** Github */
  Github = 'GITHUB',
  /** Google */
  Google = 'GOOGLE',
  /** Sleuth Dora */
  SleuthDora = 'SLEUTH_DORA'
}

/** Sort direction for ordered listings. */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SourceData = {
  __typename?: 'SourceData';
  columns: Array<SourceDataColumn>;
  listedObjectType: SourceDataObjectType;
  values: Array<Array<Maybe<Scalars['GenericScalar']['output']>>>;
};

export type SourceDataColumn = {
  __typename?: 'SourceDataColumn';
  name: Scalars['String']['output'];
  type: DataType;
  unit?: Maybe<Unit>;
};

export enum SourceDataObjectType {
  Incident = 'INCIDENT',
  Issue = 'ISSUE',
  PullRequest = 'PULL_REQUEST',
  SupportTicket = 'SUPPORT_TICKET',
  SurveyAnswer = 'SURVEY_ANSWER',
  Unknown = 'UNKNOWN'
}

/** GraphQL type for suggested skill. */
export type SuggestedSkill = {
  __typename?: 'SuggestedSkill';
  createdSkillId?: Maybe<Scalars['String']['output']>;
  /** Description of what this skill covers */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Importance rating from 1-10, with 10 being most important */
  importance: Scalars['Int']['output'];
  /** Reasoning for the importance score based on evaluation criteria */
  importanceReasoning?: Maybe<Scalars['String']['output']>;
  /** Importance tier (Critical, Important, Useful, Minor, Trivial) */
  importanceTier?: Maybe<Scalars['String']['output']>;
  /** Suggested skill name */
  name: Scalars['String']['output'];
  /** AI reasoning for why this should be a skill */
  reasoning?: Maybe<Scalars['String']['output']>;
  relatedFiles: Array<Scalars['String']['output']>;
  status: SuggestedSkillStatusEnum;
  /** How the skill can be used */
  usageGuide: Scalars['String']['output'];
};

/** Status of a suggested skill. */
export enum SuggestedSkillStatusEnum {
  Approved = 'APPROVED',
  Created = 'CREATED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type Survey = Assessable & Commentable & TeamOrUsersScoped & UserScoped & {
  __typename?: 'Survey';
  assessment: DelayedAssessment;
  chain?: Maybe<SurveyChain>;
  comment?: Maybe<Comment>;
  commentAuthors: UserConnection;
  comments: CommentConnection;
  commentsCount: Scalars['Int']['output'];
  createdOn: Scalars['DateTime']['output'];
  dueOn: Scalars['DateTime']['output'];
  end: Scalars['DateTime']['output'];
  highlightWidget?: Maybe<Widget>;
  id: Scalars['ID']['output'];
  inProgressOn?: Maybe<Scalars['DateTime']['output']>;
  modifiedOn: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  nextSurvey?: Maybe<Survey>;
  onlyOwnerCanChangeStatus: Scalars['Boolean']['output'];
  owner?: Maybe<User>;
  previousSurvey?: Maybe<Survey>;
  publishedOn?: Maybe<Scalars['DateTime']['output']>;
  recipientsCount: Scalars['Int']['output'];
  section?: Maybe<Section>;
  sections: SectionConnection;
  start: Scalars['DateTime']['output'];
  status: ReviewStatus;
  teamsOrUsers: TeamOrUsersConnection;
  users: UserConnection;
  workspace: Workspace;
};


export type SurveyCommentArgs = {
  id: Scalars['ID']['input'];
};


export type SurveyCommentAuthorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SurveyCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SurveySectionArgs = {
  id: Scalars['ID']['input'];
};


export type SurveySectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SurveyTeamsOrUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type SurveyUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyChain = {
  __typename?: 'SurveyChain';
  chainReviews: SurveyConnection;
  id: Scalars['ID']['output'];
  templateIconPath?: Maybe<Scalars['String']['output']>;
};


export type SurveyChainChainReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeTopLink?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SurveyConnection = {
  __typename?: 'SurveyConnection';
  edges: Array<SurveyEdge>;
  nodes: Array<Survey>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type SurveyEdge = {
  __typename?: 'SurveyEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Survey;
};

export type SurveyQuestionRatingWidgetValue = WidgetValue & {
  __typename?: 'SurveyQuestionRatingWidgetValue';
  averageRating: Scalars['FloatRoundedTo2']['output'];
  exportLinks: Array<Maybe<ExportLink>>;
  legend?: Maybe<WidgetLegend>;
  notes?: Maybe<Array<BaseNoteGqlType>>;
  responseSummary: Scalars['String']['output'];
  responses: Array<Scalars['String']['output']>;
  type: WidgetValueFormat;
};

export type SurveyQuestionTextWidgetValue = WidgetValue & {
  __typename?: 'SurveyQuestionTextWidgetValue';
  exportLinks: Array<Maybe<ExportLink>>;
  legend?: Maybe<WidgetLegend>;
  notes?: Maybe<Array<BaseNoteGqlType>>;
  responseSummary: Scalars['String']['output'];
  responses: Array<Scalars['String']['output']>;
  type: WidgetValueFormat;
};

export type Team = {
  __typename?: 'Team';
  adminMembers?: Maybe<Array<SimpleUserType>>;
  /** URL to the external provider's page for this team (only set for teams synced from an external provider). */
  externalTeamUrl?: Maybe<Scalars['String']['output']>;
  hasSubteams: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  integrationDescription?: Maybe<Scalars['String']['output']>;
  integrationSlug?: Maybe<Scalars['String']['output']>;
  members: UserConnection;
  missingConfiguration: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Team>;
  provider?: Maybe<IntegrationProvider>;
  repositories: RepositoryConnection;
  skillsRepositories?: Maybe<Array<SkillsRepositoryType>>;
};


export type TeamMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TeamAdminScope = {
  __typename?: 'TeamAdminScope';
  gid: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TeamEdge = {
  __typename?: 'TeamEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Team;
};

export type TeamOrUser = {
  __typename?: 'TeamOrUser';
  avatar: Scalars['String']['output'];
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: TeamOrUserType;
};

export type TeamOrUserEdge = {
  __typename?: 'TeamOrUserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TeamOrUser;
};

export enum TeamOrUserType {
  Team = 'TEAM',
  User = 'USER'
}

export type TeamOrUsersConnection = {
  __typename?: 'TeamOrUsersConnection';
  edges: Array<TeamOrUserEdge>;
  nodes: Array<TeamOrUser>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type TeamOrUsersScoped = {
  teamsOrUsers: TeamOrUsersConnection;
};


export type TeamOrUsersScopedTeamsOrUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type TeamParentInputType = {
  any?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TeamsConnection = {
  __typename?: 'TeamsConnection';
  edges: Array<TeamEdge>;
  nodes: Array<Team>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type TeamsSyncInputType = {
  /** Slug of the integration used for teams sync in case of multiple integrations configured. */
  integrationSlug?: InputMaybe<Scalars['String']['input']>;
  orgSlug: Scalars['ID']['input'];
  /** Desired Teams provider. Leave empty for manual control over Sleuth Teams */
  provider?: InputMaybe<TeamsSyncProviderType>;
};

export enum TeamsSyncProviderType {
  /** Github */
  Github = 'GITHUB',
  /** Sleuth Dora */
  SleuthDora = 'SLEUTH_DORA'
}

export type TeamsSyncStatusMutation = {
  __typename?: 'TeamsSyncStatusMutation';
  success: Scalars['Boolean']['output'];
};

export type TeamsSyncStatusType = {
  __typename?: 'TeamsSyncStatusType';
  integrationSlug?: Maybe<Scalars['String']['output']>;
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  syncInProgress: Scalars['Boolean']['output'];
};

export type TextContent = {
  __typename?: 'TextContent';
  html: Scalars['HTMLString']['output'];
  markdown: Scalars['String']['output'];
};

export type TextWidgetValue = WidgetValue & {
  __typename?: 'TextWidgetValue';
  content?: Maybe<TextContent>;
  details?: Maybe<Scalars['GenericScalar']['output']>;
  exportLinks: Array<Maybe<ExportLink>>;
  legend?: Maybe<WidgetLegend>;
  notes?: Maybe<Array<BaseNoteGqlType>>;
  type: WidgetValueFormat;
};

export type ToggleAssetStatusMutation = {
  __typename?: 'ToggleAssetStatusMutation';
  asset?: Maybe<VaultAsset>;
  errors: Array<ErrorType>;
};

export type ToggleLlmFeaturesMutation = {
  __typename?: 'ToggleLLMFeaturesMutation';
  success: Scalars['Boolean']['output'];
};

export type TrackViewMutation = {
  __typename?: 'TrackViewMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type TriggerDescriptionOptimizationInput = {
  maxIterations?: InputMaybe<Scalars['Int']['input']>;
  skillGid: Scalars['ID']['input'];
};

export type TriggerDescriptionOptimizationMutation = {
  __typename?: 'TriggerDescriptionOptimizationMutation';
  errors: Array<ErrorType>;
  optimization?: Maybe<DescriptionOptimization>;
};

/**
 * Start a managed-import scan over the user-selected repositories.
 *
 * Resets prior scan state, queues one celery task per repo, and returns
 * immediately. Frontend reads progress from ``managedImportScanStatus`` and
 * listens to ``MANAGED_IMPORT_CANDIDATE_FOUND`` / ``MANAGED_IMPORT_SCAN_COMPLETED``
 * websocket events.
 */
export type TriggerManagedImportScanMutation = {
  __typename?: 'TriggerManagedImportScanMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

/**
 * Kick off a background LLM-driven smart merge.
 *
 * Returns a ``merge_id`` immediately. The actual LLM call runs in a celery
 * task; the frontend polls ``smartMergeStatus(mergeId)`` for the result.
 * A single LLM call can take well over the 60s GraphQL request timeout, so
 * keeping this mutation synchronous would unavoidably stall the wizard.
 */
export type TriggerSmartMergeMutation = {
  __typename?: 'TriggerSmartMergeMutation';
  errors: Array<ErrorType>;
  mergeId?: Maybe<Scalars['ID']['output']>;
};

export type TriggerTeamsSyncInputType = {
  integrationSlugs?: InputMaybe<Array<Scalars['ID']['input']>>;
  orgSlug: Scalars['ID']['input'];
};

export type TriggerTeamsSyncMutation = {
  __typename?: 'TriggerTeamsSyncMutation';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

export type UnfavoriteWorkspaceMutation = {
  __typename?: 'UnfavoriteWorkspaceMutation';
  errors?: Maybe<Array<ErrorType>>;
  success: Scalars['Boolean']['output'];
};

export type UninstallAssetInput = {
  /** GID of the entity (null for organization-wide installs) */
  entityId?: InputMaybe<Scalars['ID']['input']>;
  entityType: VaultAssetInstallationEntityType;
  /** GID of the asset to uninstall from a target */
  id: Scalars['ID']['input'];
  /** GID of the mono-repo config (only for repository targets) */
  monoRepoConfigId?: InputMaybe<Scalars['ID']['input']>;
};

/** Remove a single installation from an asset (does not delete the asset). */
export type UninstallAssetMutation = {
  __typename?: 'UninstallAssetMutation';
  asset?: Maybe<VaultAsset>;
  errors: Array<ErrorType>;
};

export type UninstallSkillFromBotMutation = {
  __typename?: 'UninstallSkillFromBotMutation';
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export enum Unit {
  /** Count */
  Count = 'COUNT',
  /** Currency */
  Currency = 'CURRENCY',
  /** Percentage */
  Percentage = 'PERCENTAGE',
  /** Seconds */
  Seconds = 'SECONDS',
  /** Unknown */
  Unknown = 'UNKNOWN',
  /** UTC Timestamp */
  UtcTimestamp = 'UTC_TIMESTAMP',
  /** Working hours */
  WorkingHours = 'WORKING_HOURS'
}

export type UnlinkExternalUserMutation = {
  __typename?: 'UnlinkExternalUserMutation';
  errors?: Maybe<Array<ErrorType>>;
  success: Scalars['Boolean']['output'];
};

export type UpdateAssetEvalInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  evalGid: Scalars['ID']['input'];
  expectations?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedOutput?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAssetEvalMutation = {
  __typename?: 'UpdateAssetEvalMutation';
  errors: Array<ErrorType>;
  eval?: Maybe<AssetEval>;
};

export type UpdateAssetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  hookArgs?: InputMaybe<Array<Scalars['String']['input']>>;
  hookCommand?: InputMaybe<Scalars['String']['input']>;
  hookEvent?: InputMaybe<Scalars['String']['input']>;
  hookMatcher?: InputMaybe<Scalars['String']['input']>;
  hookTimeout?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  /** Replace the asset's installations entirely. Empty list = org-wide. */
  installations?: InputMaybe<Array<AssetInstallationInput>>;
  mcpToolNames?: InputMaybe<Array<McpToolInput>>;
  mcpTransport?: InputMaybe<Scalars['String']['input']>;
  mcpUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Rule asset globs */
  ruleGlobs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAssetMutation = {
  __typename?: 'UpdateAssetMutation';
  asset?: Maybe<VaultAsset>;
  errors: Array<ErrorType>;
};

export type UpdateAssetProfileInput = {
  /** New profile description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Profile GID */
  gid: Scalars['ID']['input'];
  /** New profile name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Update an existing asset profile. */
export type UpdateAssetProfileMutation = {
  __typename?: 'UpdateAssetProfileMutation';
  errors: Array<ErrorType>;
  profile?: Maybe<VaultAssetProfile>;
};

export type UpdateBotInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateBotMutation = {
  __typename?: 'UpdateBotMutation';
  bot?: Maybe<ManagedBot>;
  errors: Array<ErrorType>;
};

/** Trigger an update of a catalog-sourced asset from upstream. */
export type UpdateFromCatalogMutation = {
  __typename?: 'UpdateFromCatalogMutation';
  asset?: Maybe<VaultAsset>;
  errors: Array<ErrorType>;
};

export type UpdateIntegrationMutationInput = {
  apiSecondaryToken?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraData?: InputMaybe<Scalars['String']['input']>;
  /** Coma separated list of custom headers Sleuth will send with every request. Specify in the format: my-header=my-value,my-other-header=value2 */
  extraHeaders?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  /** Whether only read operations will be allowed or not. If enabled, some features may be unavailable. */
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
  /** The fully qualified url of your instance. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The username of the user used to create the API token */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIntegrationMutationPayload = {
  __typename?: 'UpdateIntegrationMutationPayload';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  integration?: Maybe<IntegrationAuthenticationType>;
};

export type UpdateMonoRepoConfigInput = {
  id: Scalars['ID']['input'];
  issueProvider?: InputMaybe<Provider>;
  issueTeamKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sourcePathPrefixExcludes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourcePathPrefixIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateMonoRepoConfigMutation = {
  __typename?: 'UpdateMonoRepoConfigMutation';
  errors: Array<ErrorType>;
  monoRepoConfig?: Maybe<MonoRepoConfigOutputType>;
};

export type UpdateOrganizationInputType = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressPostalCode?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  defaultRole?: InputMaybe<Role>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailDomain?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  loginMethods?: InputMaybe<Array<LoginMethodInputType>>;
  name?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationMutation = {
  __typename?: 'UpdateOrganizationMutation';
  success: Scalars['Boolean']['output'];
};

export type UpdateReviewInput = {
  dueOn?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  onlyOwnerCanChangeStatus?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  requireApproval?: InputMaybe<Scalars['Boolean']['input']>;
  sectionSubmissionDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateReviewMutation = {
  __typename?: 'UpdateReviewMutation';
  errors?: Maybe<Array<ErrorType>>;
  review?: Maybe<Review>;
};

export type UpdateSectionInput = {
  assessmentScoreIsMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  assessmentSummaryIsMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateSectionMutation = {
  __typename?: 'UpdateSectionMutation';
  errors?: Maybe<Array<ErrorType>>;
  section?: Maybe<Section>;
};

export type UpdateSkillsSettingsInput = {
  /** Whether skill PRs should be automatically created based on code changes in GitHub PRs */
  autoCreateSkillPullRequests?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to automatically publish skills */
  autoPublishEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minimum confidence percentage for auto-publishing (0-100) */
  autoPublishThreshold?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSkillsSettingsMutation = {
  __typename?: 'UpdateSkillsSettingsMutation';
  errors: Array<ErrorType>;
  skillsSettings?: Maybe<SkillsSettings>;
};

/** Update the status of a suggested skill (reject or unreject). */
export type UpdateSuggestedSkillStatusMutation = {
  __typename?: 'UpdateSuggestedSkillStatusMutation';
  errors: Array<ErrorType>;
  suggestedSkill?: Maybe<SuggestedSkill>;
};

export type UpdateTeamInput = {
  id: Scalars['ID']['input'];
  members?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  skillsRepositories?: InputMaybe<Array<SkillsRepositoryInput>>;
};

export type UpdateTeamMutation = {
  __typename?: 'UpdateTeamMutation';
  errors: Array<ErrorType>;
  team?: Maybe<Team>;
};

export type UpdateUserMutation = {
  __typename?: 'UpdateUserMutation';
  user?: Maybe<User>;
};

export type UpdateWidgetInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSONString']['input']>;
  renderer?: InputMaybe<FormatRenderer>;
  size?: InputMaybe<WidgetSize>;
  /** All possible values are: Current month breakdown, Current quarter breakdown, Details, Manual chart, Manual stacked chart, Percentages, Period breakdown, Period vs last period trend, Period vs period last year, Previous comparison, Priorities, Proportions, Rating, Single number, Six months trend, Six period proportions trend, Six period trend, Survey answer list, Text, Trend, Twelve months trend, Twelve period proportions trend, Twelve period trend, Two months trend. But not every widget supports all of them. */
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWidgetMutation = {
  __typename?: 'UpdateWidgetMutation';
  errors?: Maybe<Array<ErrorType>>;
  widget?: Maybe<Widget>;
};

export type UpdateWorkspaceMutation = {
  __typename?: 'UpdateWorkspaceMutation';
  errors?: Maybe<Array<ErrorType>>;
  workspace?: Maybe<Workspace>;
};

export type UpdateWorkspaceMutationInput = {
  id: Scalars['ID']['input'];
  marker?: InputMaybe<WorkspaceMarkerInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UploadMutation = {
  __typename?: 'UploadMutation';
  errors: Array<ErrorType>;
  urls: Array<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  activeSkillProfile?: Maybe<VaultAssetProfile>;
  dateJoined: Scalars['DateTime']['output'];
  display: Scalars['String']['output'];
  email: Scalars['String']['output'];
  externalUsers: Array<ExternalUserType>;
  favoriteWorkspaces: Array<FavoriteWorkspaceType>;
  firstName: Scalars['String']['output'];
  gravatar: Scalars['String']['output'];
  hasUsablePassword: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean']['output'];
  isBeingImpersonated: Scalars['Boolean']['output'];
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean']['output'];
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  missingExternalUserProviders: Array<Scalars['String']['output']>;
  notifications: NotificationConnection;
  organizations: Array<OrganizationType>;
  permissions: UserPermissionsType;
  personalTokens: AccessTokenConnection;
  role?: Maybe<Role>;
  seen: Array<SeenEventType>;
  setup: UserSetupType;
  slackUserId?: Maybe<Scalars['String']['output']>;
  teams: Array<ShortTeamType>;
  timezone?: Maybe<Scalars['String']['output']>;
  userOnboardingCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String']['output'];
  /** EXPERIMENTAL FIELD, can change at any time. */
  workingHours?: Maybe<WorkingHoursType>;
};


export type UserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserPersonalTokensArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  nodes: Array<User>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: User;
};

export type UserPermissionsType = {
  __typename?: 'UserPermissionsType';
  canChangeBilling: Scalars['Boolean']['output'];
  canChangeOrg: Scalars['Boolean']['output'];
  canChangeOrgConfig: Scalars['Boolean']['output'];
  canCreateAssets: Scalars['Boolean']['output'];
  canManageAssets: Scalars['Boolean']['output'];
};

export type UserScoped = {
  users: UserConnection;
};


export type UserScopedUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type UserSetupType = {
  __typename?: 'UserSetupType';
  confirmedEmail: Scalars['Boolean']['output'];
  noSlack: Scalars['Boolean']['output'];
  socialConnections: Array<Scalars['String']['output']>;
};

export type UsersModifierNote = BaseNoteGqlType & {
  __typename?: 'UsersModifierNote';
  msg: Scalars['String']['output'];
  teams: Array<Maybe<Scalars['String']['output']>>;
  users: Array<Maybe<Scalars['String']['output']>>;
  usersField: Scalars['String']['output'];
};

export enum UsersType {
  All = 'ALL',
  Members = 'MEMBERS'
}

export type ValidateDeviceCodeMutation = {
  __typename?: 'ValidateDeviceCodeMutation';
  result: ValidateDeviceCodeResult;
};

export type ValidateDeviceCodeResult = {
  __typename?: 'ValidateDeviceCodeResult';
  clientId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Vault containing assets. */
export type Vault = {
  __typename?: 'Vault';
  asset?: Maybe<VaultAsset>;
  assets: VaultAssetsConnection;
};


/** Vault containing assets. */
export type VaultAssetArgs = {
  id: Scalars['ID']['input'];
};


/** Vault containing assets. */
export type VaultAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assetTypes?: InputMaybe<Array<AssetType>>;
  baseRepoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  impactMax?: InputMaybe<Scalars['Float']['input']>;
  impactMin?: InputMaybe<Scalars['Float']['input']>;
  includeOrgWide?: InputMaybe<Scalars['Boolean']['input']>;
  installationEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  installationEntityType?: InputMaybe<VaultAssetInstallationEntityType>;
  last?: InputMaybe<Scalars['Int']['input']>;
  monoRepoConfigId?: InputMaybe<Scalars['ID']['input']>;
  noInstallations?: InputMaybe<Scalars['Boolean']['input']>;
  qualityMax?: InputMaybe<Scalars['Float']['input']>;
  qualityMin?: InputMaybe<Scalars['Float']['input']>;
  repositoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<AssetSortField>;
  sortDirection?: InputMaybe<SortDirection>;
  sourceType?: InputMaybe<AssetSourceType>;
  status?: InputMaybe<Array<SkillStatusEnum>>;
  type?: InputMaybe<AssetType>;
};

/** Asset in the vault (Skill, MCP, Agent, etc.). */
export type VaultAsset = {
  /** Repository code contexts where this asset will execute */
  codeContexts: Array<AssetCodeContext>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** Whether an evaluation is currently in progress for this asset */
  evaluating: Scalars['Boolean']['output'];
  /** Files belonging to this asset */
  files: Array<SkillFile>;
  id: Scalars['ID']['output'];
  /** Pending installation requests for this asset visible to the current user */
  installationRequests: Array<AssetInstallationRequest>;
  installations: Array<VaultAssetInstallation>;
  isChatDefault: Scalars['Boolean']['output'];
  latestVersion: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Current user's permissions for this asset */
  permissions?: Maybe<VaultAssetPermissions>;
  profiles: Array<VaultAssetProfile>;
  slug: Scalars['String']['output'];
  /** Asset source metadata */
  source: AssetSource;
  status?: Maybe<SkillStatusEnum>;
  /** Token counts for the current version */
  tokenCounts?: Maybe<AssetTokenCount>;
  type: AssetType;
  updatedAt: Scalars['DateTime']['output'];
  usageCount: Scalars['Int']['output'];
  versions: Array<VaultAssetVersion>;
  versionsCount: Scalars['Int']['output'];
};


/** Asset in the vault (Skill, MCP, Agent, etc.). */
export type VaultAssetFilesArgs = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type VaultAssetEdge = {
  __typename?: 'VaultAssetEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: VaultAsset;
};

/** Installation location for a vault asset. */
export type VaultAssetInstallation = {
  __typename?: 'VaultAssetInstallation';
  /** Whether the current user can uninstall from this target */
  canUninstall: Scalars['Boolean']['output'];
  entityId?: Maybe<Scalars['String']['output']>;
  entityName: Scalars['String']['output'];
  entityProvider?: Maybe<Scalars['String']['output']>;
  entityType: VaultAssetInstallationEntityType;
  monoRepoConfigId?: Maybe<Scalars['String']['output']>;
  monoRepoConfigName?: Maybe<Scalars['String']['output']>;
};

/** Entity type for vault asset installation. */
export enum VaultAssetInstallationEntityType {
  Bot = 'BOT',
  Organization = 'ORGANIZATION',
  Repository = 'REPOSITORY',
  Team = 'TEAM',
  User = 'USER'
}

/** Per-asset permissions for the current user. */
export type VaultAssetPermissions = {
  __typename?: 'VaultAssetPermissions';
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  canInstallOrg: Scalars['Boolean']['output'];
  canInstallRepo: Scalars['Boolean']['output'];
  canInstallSelf: Scalars['Boolean']['output'];
  canInstallTeam: Scalars['Boolean']['output'];
  canMergePr: Scalars['Boolean']['output'];
  canPublish: Scalars['Boolean']['output'];
  canRequestInstallOrg: Scalars['Boolean']['output'];
  canRequestInstallRepo: Scalars['Boolean']['output'];
  canRequestInstallTeam: Scalars['Boolean']['output'];
  canUninstallOrg: Scalars['Boolean']['output'];
  canUninstallRepo: Scalars['Boolean']['output'];
  canUninstallSelf: Scalars['Boolean']['output'];
  canUninstallTeam: Scalars['Boolean']['output'];
  isAuthor: Scalars['Boolean']['output'];
  teamAdminOf: Array<Scalars['String']['output']>;
};

/** GraphQL type for skill profile. */
export type VaultAssetProfile = {
  __typename?: 'VaultAssetProfile';
  assets: VaultAssetsConnection;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** GraphQL type for skill profile. */
export type VaultAssetProfileAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Paginated list of skill profiles. */
export type VaultAssetProfileConnection = {
  __typename?: 'VaultAssetProfileConnection';
  edges: Array<VaultAssetProfileEdge>;
  nodes: Array<VaultAssetProfile>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type VaultAssetProfileEdge = {
  __typename?: 'VaultAssetProfileEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: VaultAssetProfile;
};

/** Version information for a vault asset. */
export type VaultAssetVersion = {
  __typename?: 'VaultAssetVersion';
  changeSummary: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  filesCount: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  version: Scalars['String']['output'];
};

/** Paginated list of vault assets. */
export type VaultAssetsConnection = {
  __typename?: 'VaultAssetsConnection';
  edges: Array<VaultAssetEdge>;
  nodes: Array<VaultAsset>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

/** Information about a skill version change. */
export type VersionChange = {
  __typename?: 'VersionChange';
  changeSummary: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export enum ViewTargetType {
  Review = 'REVIEW',
  Workspace = 'WORKSPACE'
}

/** An enumeration. */
export enum WsEventType {
  AgentStatus = 'agent_status',
  Ai = 'ai',
  AiNoop = 'ai_noop',
  AiResponded = 'ai_responded',
  AiThinking = 'ai_thinking',
  AiTransitional = 'ai_transitional',
  AiWaiting = 'ai_waiting',
  AnalysisComplete = 'analysis_complete',
  AnalysisStarted = 'analysis_started',
  AssetLoadingStatus = 'asset_loading_status',
  BreakdownStarted = 'breakdown_started',
  CheapPlanGenerationComplete = 'cheap_plan_generation_complete',
  CheapPlanGenerationStarted = 'cheap_plan_generation_started',
  CommentAdded = 'comment_added',
  CommentRemoved = 'comment_removed',
  CommentUpdated = 'comment_updated',
  DependencyAdded = 'dependency_added',
  DependentPlanUpdated = 'dependent_plan_updated',
  DiscoveryAssetFound = 'discovery_asset_found',
  DiscoveryCompleted = 'discovery_completed',
  EnhancedPlanGenerationComplete = 'enhanced_plan_generation_complete',
  EnhancedPlanGenerationStarted = 'enhanced_plan_generation_started',
  Error = 'error',
  EvaluatingCompleted = 'evaluating_completed',
  EvaluatingStarted = 'evaluating_started',
  Evaluation = 'evaluation',
  ImplementationPlanningComplete = 'implementation_planning_complete',
  ImplementationPlanningFailed = 'implementation_planning_failed',
  ImplementationPlanningProgress = 'implementation_planning_progress',
  ImplementationPlanningStarted = 'implementation_planning_started',
  IssueAnalysisStarted = 'issue_analysis_started',
  IssueAnalyzed = 'issue_analyzed',
  IssuePlanGenerated = 'issue_plan_generated',
  IssuePlanProgress = 'issue_plan_progress',
  IssuePlanStarted = 'issue_plan_started',
  IssueRetrieved = 'issue_retrieved',
  IssuesError = 'issues_error',
  ManagedImportCandidateFound = 'managed_import_candidate_found',
  ManagedImportItemCompleted = 'managed_import_item_completed',
  ManagedImportRunCompleted = 'managed_import_run_completed',
  ManagedImportScanCompleted = 'managed_import_scan_completed',
  NoIssuesFound = 'no_issues_found',
  Plan = 'plan',
  PlanningCompleted = 'planning_completed',
  PlanningStarted = 'planning_started',
  ProcessingComplete = 'processing_complete',
  ProcessingHeartbeat = 'processing_heartbeat',
  ProcessingStarted = 'processing_started',
  ProcessingStopped = 'processing_stopped',
  RelatedCodeAnalyzed = 'related_code_analyzed',
  RelatedIssuesAnalyzed = 'related_issues_analyzed',
  RelatedPrsAnalyzed = 'related_prs_analyzed',
  ResearchingCompleted = 'researching_completed',
  ResearchingStarted = 'researching_started',
  ReviewAssessmentNoChange = 'review_assessment_no_change',
  ReviewAssessmentUpdateRequested = 'review_assessment_update_requested',
  ReviewAssessmentUpdated = 'review_assessment_updated',
  ReviewChainRemoved = 'review_chain_removed',
  ReviewCopied = 'review_copied',
  ReviewCreated = 'review_created',
  ReviewInProgress = 'review_in_progress',
  ReviewPublished = 'review_published',
  ReviewRemoved = 'review_removed',
  ReviewRepeated = 'review_repeated',
  ReviewStopped = 'review_stopped',
  ReviewUpdated = 'review_updated',
  SectionAdded = 'section_added',
  SectionAssessmentNoChange = 'section_assessment_no_change',
  SectionAssessmentUpdateRequested = 'section_assessment_update_requested',
  SectionAssessmentUpdated = 'section_assessment_updated',
  SectionRemoved = 'section_removed',
  SectionStatusUpdated = 'section_status_updated',
  SectionUpdated = 'section_updated',
  SubtaskCreated = 'subtask_created',
  ToolCall = 'tool_call',
  ToolResult = 'tool_result',
  ToolStreaming = 'tool_streaming',
  User = 'user',
  WidgetAdded = 'widget_added',
  WidgetAssessmentUpdateRequested = 'widget_assessment_update_requested',
  WidgetAssessmentUpdated = 'widget_assessment_updated',
  WidgetRemoved = 'widget_removed',
  WidgetUpdated = 'widget_updated',
  WidgetValueNoChange = 'widget_value_no_change',
  WidgetValueUpdateRequested = 'widget_value_update_requested',
  WidgetValueUpdated = 'widget_value_updated',
  WorkspaceCreated = 'workspace_created',
  WorkspaceRemoved = 'workspace_removed',
  WorkspaceUpdated = 'workspace_updated'
}

export type Widget = Assessable & TeamOrUsersScoped & {
  __typename?: 'Widget';
  assessment: DelayedAssessment;
  createdOn: Scalars['DateTime']['output'];
  dataModifiedOn?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  modifiedOn: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  parameters: Scalars['JSONString']['output'];
  position: Scalars['Int']['output'];
  renderer: FormatRenderer;
  scope: ScopeType;
  section: Section;
  size: WidgetSize;
  teamsOrUsers: TeamOrUsersConnection;
  value: DelayedWidgetValue;
  valueType: Scalars['String']['output'];
  widgetType: WidgetType;
};


export type WidgetTeamsOrUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type WidgetValueArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  pqlFilters?: InputMaybe<Array<PqlFilterInput>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userOrTeamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type WidgetChartVersion = {
  __typename?: 'WidgetChartVersion';
  changeSummary: Scalars['String']['output'];
  chartConfig?: Maybe<Scalars['JSONString']['output']>;
  id: Scalars['ID']['output'];
  insightsMarkdown: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  mermaidCode: Scalars['String']['output'];
  metaCreatedOn: Scalars['DateTime']['output'];
  pqlQuery: Scalars['String']['output'];
  tableMarkdown: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type WidgetConnection = {
  __typename?: 'WidgetConnection';
  edges: Array<WidgetEdge>;
  nodes: Array<Widget>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type WidgetConversation = {
  __typename?: 'WidgetConversation';
  /** Max context window size for the AI model */
  contextMaxTokens?: Maybe<Scalars['Int']['output']>;
  /** Last known input token count from AI conversation */
  contextTokensUsed?: Maybe<Scalars['Int']['output']>;
  currentVersion?: Maybe<WidgetChartVersion>;
  id: Scalars['ID']['output'];
  /** Persisted Mermaid diagram code extracted from AI response */
  mermaidCode: Scalars['String']['output'];
  metaCreatedOn: Scalars['DateTime']['output'];
  metaLastUpdatedOn: Scalars['DateTime']['output'];
};

export type WidgetEdge = {
  __typename?: 'WidgetEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Widget;
};

export type WidgetError = {
  __typename?: 'WidgetError';
  message: Scalars['String']['output'];
  settingsPage?: Maybe<SettingsPage>;
};

export type WidgetLegend = {
  type?: Maybe<Scalars['String']['output']>;
};

export enum WidgetSize {
  /** Large */
  Large = 'LARGE',
  /** Medium */
  Medium = 'MEDIUM',
  /** Small */
  Small = 'SMALL'
}

export type WidgetType = {
  __typename?: 'WidgetType';
  active: Scalars['Boolean']['output'];
  defaultValues: Scalars['String']['output'];
  description: Scalars['String']['output'];
  externalConfiguration?: Maybe<Array<NamedBucketOptions>>;
  filterPqlFragment?: Maybe<Scalars['String']['output']>;
  images: Array<WidgetTypeImage>;
  isSkillsWidget: Scalars['Boolean']['output'];
  isSurveyQuestionWidget: Scalars['Boolean']['output'];
  isSurveyWidget: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  namePlaceholder: Scalars['String']['output'];
  parameterSchema: Scalars['String']['output'];
  publishedOn: Scalars['DateTime']['output'];
  slug: Scalars['String']['output'];
  supportedValueTypes: Array<WidgetValueType>;
  teamOrUserAware: Scalars['Boolean']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};


export type WidgetTypeDefaultValuesArgs = {
  workspaceId: Scalars['ID']['input'];
};

export type WidgetTypeConnection = {
  __typename?: 'WidgetTypeConnection';
  edges: Array<WidgetTypeEdge>;
  nodes: Array<WidgetType>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of edges. */
  totalCount: Scalars['Int']['output'];
};

export type WidgetTypeEdge = {
  __typename?: 'WidgetTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: WidgetType;
};

export type WidgetTypeImage = {
  __typename?: 'WidgetTypeImage';
  description: Scalars['String']['output'];
  isHero: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type WidgetValue = {
  exportLinks: Array<Maybe<ExportLink>>;
  legend?: Maybe<WidgetLegend>;
  notes?: Maybe<Array<BaseNoteGqlType>>;
  type: WidgetValueFormat;
};

export enum WidgetValueFormat {
  /** Categories */
  Categories = 'CATEGORIES',
  /** Combined */
  Combined = 'COMBINED',
  /** Dora */
  Dora = 'DORA',
  /** Epics timeline */
  EpicsTimelineCategories = 'EPICS_TIMELINE_CATEGORIES',
  /** Grouped categories */
  GroupedCategories = 'GROUPED_CATEGORIES',
  /** KTLO */
  Ktlo = 'KTLO',
  /** Number */
  Number = 'NUMBER',
  /** Percentage categories */
  PercentageCategories = 'PERCENTAGE_CATEGORIES',
  /** Priorities */
  Priorities = 'PRIORITIES',
  /** Rating */
  Rating = 'RATING',
  /** Rating table */
  RatingTable = 'RATING_TABLE',
  /** Rating wth previous */
  RatingWithPrevious = 'RATING_WITH_PREVIOUS',
  /** Rating table */
  SurveyRatingAnswerList = 'SURVEY_RATING_ANSWER_LIST',
  /** Rating table */
  SurveyTextAnswerList = 'SURVEY_TEXT_ANSWER_LIST',
  /** Text */
  Text = 'TEXT'
}

export type WidgetValueType = {
  __typename?: 'WidgetValueType';
  default: Scalars['Boolean']['output'];
  defaultRenderer: FormatRenderer;
  format: WidgetValueFormat;
  formatRenderers: Array<FormatRenderer>;
  name: Scalars['String']['output'];
};

export type WorkEffortLegend = WidgetLegend & {
  __typename?: 'WorkEffortLegend';
  items: Array<WorkEffortLegendItem>;
  type?: Maybe<Scalars['String']['output']>;
};

export type WorkEffortLegendItem = {
  __typename?: 'WorkEffortLegendItem';
  avgHourlySalary?: Maybe<Scalars['DecimalRoundedTo2']['output']>;
  categoryName: Scalars['String']['output'];
  currencySign?: Maybe<Scalars['String']['output']>;
  moneySpent?: Maybe<Scalars['Int']['output']>;
  /** Percentage will be `null` when the total time of all issues is 0. */
  percentage?: Maybe<Scalars['FloatRoundedTo1']['output']>;
  /** Number of seconds spent working on this category. */
  timeSpent: Scalars['Int']['output'];
};

export type WorkingHoursInputType = {
  duration: Scalars['String']['input'];
  recurrence: Scalars['String']['input'];
  startTime: Scalars['Time']['input'];
};

export type WorkingHoursType = {
  __typename?: 'WorkingHoursType';
  duration: Scalars['String']['output'];
  recurrence?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['Time']['output'];
};

export type Workspace = TeamOrUsersScoped & UserScoped & {
  __typename?: 'Workspace';
  chain?: Maybe<ReviewChain>;
  dashboard?: Maybe<Dashboard>;
  dashboards: DashboardConnection;
  id: Scalars['ID']['output'];
  /** Every org has one global workspace, this workspace cannot be deleted. */
  isGlobal: Scalars['Boolean']['output'];
  marker?: Maybe<WorkspaceMarkerField>;
  name: Scalars['String']['output'];
  parameterOptions: ParameterValueOptionConnection;
  review?: Maybe<Review>;
  reviews: ReviewConnection;
  survey?: Maybe<Survey>;
  surveys: SurveyConnection;
  teamsOrUsers: TeamOrUsersConnection;
  users: UserConnection;
  workCategoryBuckets?: Maybe<Array<NamedWorkCategoryGqlType>>;
  workPlanningBuckets?: Maybe<Array<NamedWorkPlanningGqlType>>;
};


export type WorkspaceChainArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  reviewId?: InputMaybe<Scalars['ID']['input']>;
};


export type WorkspaceDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type WorkspaceDashboardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type WorkspaceParameterOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fieldName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  includeRelatedTags?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pqlFragmentName: Scalars['String']['input'];
  precursorValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selectedValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type WorkspaceReviewArgs = {
  id: Scalars['ID']['input'];
};


export type WorkspaceReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviewType?: InputMaybe<ReviewType>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type WorkspaceSurveyArgs = {
  id: Scalars['ID']['input'];
};


export type WorkspaceSurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type WorkspaceTeamsOrUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type WorkspaceUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type WorkspaceWorkCategoryBucketsArgs = {
  defaultToGlobal?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WorkspaceWorkPlanningBucketsArgs = {
  defaultToGlobal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkspaceConnection = {
  __typename?: 'WorkspaceConnection';
  edges: Array<WorkspaceEdge>;
  nodes: Array<Workspace>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type WorkspaceEdge = {
  __typename?: 'WorkspaceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Workspace;
};

export type WorkspaceMarkerField = {
  __typename?: 'WorkspaceMarkerField';
  color?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type?: Maybe<WorkspaceMarkerType>;
};

export type WorkspaceMarkerInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: WorkspaceMarkerType;
};

export enum WorkspaceMarkerType {
  /** Emoji */
  Emoji = 'EMOJI',
  /** Icon */
  Icon = 'ICON'
}
